
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("l7ScM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9d44f0dd638c374f$export$2e2bcd8739ae039);

var $ivm9B = parcelRequire("ivm9B");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9UpXi = parcelRequire("9UpXi");
const $9d44f0dd638c374f$var$HorizontalNavJiraInner = ({ queries: { horizontalNavQuery: horizontalNavQuery } })=>{
    /*
   * Keep this component as small as possible! Ideally, it is so small that all it does is call usePreloadedQuery,
   * spread JiraHorizontalNavigationContent and the response into into JiraHorizontalNavigationContent.
   *
   * This means we don't run into the issue of having to import the compiled query into mocks, which means you can't add
   * @relay_test_operation to the query in the test/storybook, which can create hard-to-solve mock issues like this one:
   * https://hello.atlassian.net/wiki/x/FzuK1w
   * */ const data = (0, $8Uumt.usePreloadedQuery)((0, $ivm9B.default), horizontalNavQuery);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UpXi.default), {
        queryRef: data
    });
};
var $9d44f0dd638c374f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($9d44f0dd638c374f$var$HorizontalNavJiraInner);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65aa3d0e80afa1ef1974b040e02308e6>>
 * @relayHash 3e46c73d092c57994860733b90d1d2eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce

var $58v9Y = parcelRequire("58v9Y");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                            "kind": "LinkedField",
                                            "name": "teamsConnected",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});

parcelRegister("9UpXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb33d72d81438f58$export$2e2bcd8739ae039);

var $gxnRm = parcelRequire("gxnRm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $g7crU = parcelRequire("g7crU");

var $2A19k = parcelRequire("2A19k");

var $7Ib1j = parcelRequire("7Ib1j");

var $fK1eg = parcelRequire("fK1eg");

var $inpPZ = parcelRequire("inpPZ");

var $jPgWz = parcelRequire("jPgWz");

var $drBJy = parcelRequire("drBJy");
const $bb33d72d81438f58$var$JiraHorizontalNavigationContentComponent = ({ queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $gxnRm.default), queryRef);
    const project = data.jira_projectByIdOrKey;
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const setMostRecentlyViewedBoard = (0, $2A19k.useSetMostRecentlyViewedBoard)();
    (0, $5uXOq.useEffect)(()=>{
        if (data?.jira?.containerNavigation?.scopeId && project?.softwareBoardCount && project.softwareBoardCount > 0) setMostRecentlyViewedBoard?.(data.jira.containerNavigation.scopeId, project?.__id);
    }, [
        setMostRecentlyViewedBoard,
        data?.jira?.containerNavigation?.scopeId,
        project?.__id,
        project?.softwareBoardCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, project && (0, $4R6GH.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Ib1j.CustomTemplateProjectBanner), {
        projectFragment: project
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inpPZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fK1eg.default), {
        projectFragment: project,
        queryFragment: data
    }), !(0, $4R6GH.fg)('jira_theming_relay_migration') && project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drBJy.default), {
        projectRef: project
    }), !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jPgWz.default), {
        projectFragment: project,
        queryFragment: data
    })));
};
const $bb33d72d81438f58$var$JiraHorizontalNavigationContent = /*#__PURE__*/ (0, $5uXOq.memo)($bb33d72d81438f58$var$JiraHorizontalNavigationContentComponent);
var $bb33d72d81438f58$export$2e2bcd8739ae039 = $bb33d72d81438f58$var$JiraHorizontalNavigationContent;

});
parcelRegister("gxnRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $817155e15ff948b3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07ce494cd5e23a82ca54f8b4f98b1418>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $817155e15ff948b3$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "containerNavigationInput"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        },
        {
            "kind": "RootArgument",
            "name": "withProject"
        }
    ],
    "kind": "Fragment",
    "name": "JiraHorizontalNavigationContent",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabsContent_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "NavHeader_query"
        },
        {
            "condition": "withProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "idOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ThemeEvaluated"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "TabsContent_project"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "NavHeader_project"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "CustomTemplateProjectBanner"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "containerNavigationInput"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "containerNavigation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scopeId"
                                    }
                                ],
                                "type": "JiraContainerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira.containerNavigation"
                }
            ]
        }
    ],
    "type": "Query"
};
$817155e15ff948b3$var$node.hash = "7653bac1b59edb8c24c1e8829b0acf5f";
var $817155e15ff948b3$export$2e2bcd8739ae039 = $817155e15ff948b3$var$node;

});

parcelRegister("g7crU", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $aa937e51388f56fd$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});
parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});




parcelRegister("2A19k", function(module, exports) {

$parcel$export(module.exports, "useSetMostRecentlyViewedBoard", () => $6dee56e78d8107f5$export$3c43491dc3e7b6a8);

var $dm1MT = parcelRequire("dm1MT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $eCBf9 = parcelRequire("eCBf9");

var $erN97 = parcelRequire("erN97");
const $6dee56e78d8107f5$export$d1b013dc8403efee = 'setMostRecentlyViewedBoard';
const $6dee56e78d8107f5$export$b8b9d90f9e5bd72b = 'horizontalNavSoftware';
const $6dee56e78d8107f5$export$3c43491dc3e7b6a8 = ()=>{
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dm1MT.default));
    const onError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: $6dee56e78d8107f5$export$d1b013dc8403efee,
                packageName: $6dee56e78d8107f5$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    return (0, $5uXOq.useCallback)((id, projectRelayId)=>{
        commitMutation({
            variables: {
                id: id
            },
            onError: onError,
            updater: (store, data)=>{
                if (!data?.jira?.setMostRecentlyViewedBoard?.success || !projectRelayId) return;
                const parentRecord = store.get(projectRelayId);
                const newBoardDataId = (0, $erN97.default)({
                    id: data?.jira?.setMostRecentlyViewedBoard?.board?.id
                }, 'JiraBoard');
                const newBoardRecord = newBoardDataId && store.get(newBoardDataId);
                if (parentRecord && newBoardRecord) parentRecord.setLinkedRecord(newBoardRecord, 'mostRecentlyViewedBoard');
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.setMostRecentlyViewedBoard ?? {};
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    !error.statusCode?.toString().startsWith('4') && onError(error);
                }
            }
        });
    }, [
        commitMutation,
        onError
    ]);
};

});
parcelRegister("dm1MT", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d2dc7d025ea157$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a2587a8feb5ed65f63719a9f78f154d>>
 * @relayHash e4b9571054871d36ce4a62f8dfc3a347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff
const $08d2dc7d025ea157$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v2 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff",
            "metadata": {},
            "name": "setMostRecentlyViewedBoardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$08d2dc7d025ea157$var$node.hash = "4cedd313a6b84b6c272b36ea0fb2a5e6";
var $08d2dc7d025ea157$export$2e2bcd8739ae039 = $08d2dc7d025ea157$var$node;

});

parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});


parcelRegister("7Ib1j", function(module, exports) {

$parcel$export(module.exports, "CustomTemplateProjectBanner", () => $1d7413b3f4dbc2fa$export$659f09fccafc59ca);

var $8VUgV = parcelRequire("8VUgV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6eFvr = parcelRequire("6eFvr");

var $l5jpf = parcelRequire("l5jpf");

var $koVbs = parcelRequire("koVbs");

var $aQoCL = parcelRequire("aQoCL");
const $1d7413b3f4dbc2fa$var$isBannerSupported = ()=>{
    if (false) return true;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $1d7413b3f4dbc2fa$export$659f09fccafc59ca = ({ projectFragment: projectFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $8VUgV.default), projectFragment);
    return data.isLiveTemplate === true && $1d7413b3f4dbc2fa$var$isBannerSupported() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5jpf.JiraBanner), {
        appearance: "announcement",
        messageId: "horizontal-nav.ui.content.banner",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $aQoCL.default).customTemplateProjectBannerMessage)));
};

});
parcelRegister("8VUgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aa7e4c35098a2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53e84c22517867c880da6c976b95643a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6aa7e4c35098a2c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CustomTemplateProjectBanner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isLiveTemplate"
        }
    ],
    "type": "JiraProject"
};
$f6aa7e4c35098a2c$var$node.hash = "8fa4edcc596948b7b940eaf11aa2562a";
var $f6aa7e4c35098a2c$export$2e2bcd8739ae039 = $f6aa7e4c35098a2c$var$node;

});

parcelRegister("l5jpf", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $3840750ff328d8cb$export$23eaf79dd14ebe6e);

var $5uXOq = parcelRequire("5uXOq");

var $9eEJv = parcelRequire("9eEJv");

var $10xFf = parcelRequire("10xFf");

var $lAEmg = parcelRequire("lAEmg");
const $3840750ff328d8cb$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAEmg.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eEJv.default), rest);
};

});
parcelRegister("lAEmg", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $f0c8589fc9ef9b7d$export$d77caaec2153a90b);

var $9eEJv = parcelRequire("9eEJv");

var $cSWNW = parcelRequire("cSWNW");
const $f0c8589fc9ef9b7d$export$d77caaec2153a90b = (0, $cSWNW.withChoreographedRender)((0, $9eEJv.default));

});


parcelRegister("aQoCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed507aac7e03085$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ed507aac7e03085$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    customTemplateProjectBannerMessage: {
        "id": "jira-horizontal-nav.custom-template-project-banner-message",
        "defaultMessage": "This project is saved as a custom template. Project settings changes will apply to the template."
    },
    projectNavigation: {
        "id": "jira-horizontal-nav.project-navigation",
        "defaultMessage": "Project navigation"
    }
});

});


parcelRegister("fK1eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e172e45f4424ed$export$2e2bcd8739ae039);

var $caHFT = parcelRequire("caHFT");

var $doRiK = parcelRequire("doRiK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4R6GH = parcelRequire("4R6GH");

var $irF25 = parcelRequire("irF25");

var $hzZnF = parcelRequire("hzZnF");

var $4VBHB = parcelRequire("4VBHB");
const $d9e172e45f4424ed$var$NavHeader = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $doRiK.default), queryFragment);
    const projectData = (0, $8Uumt.useFragment)((0, $caHFT.default), projectFragment);
    // a user board can only exist outside of a project
    if (data.jira.jiraBoard && !projectData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VBHB.UserBoardHeader), {
        boardFragment: data.jira.jiraBoard
    });
    // from this point, we only support project scope
    if (!projectData) return null;
    if ((0, $4R6GH.fg)('issue_terminology_refresh_change_boarding_modal')) {
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'projectOrIssuePage',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectOrIssueScreen');
    }
    const board = data.jira.jiraBoard ?? projectData?.mostRecentlyViewedBoard;
    // softwareBoardCount >= 1 condition ensures boardless projects have the correct header (ie ProjectHeader)
    if (board && projectData.projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) && projectData.projectStyle === (0, $2vSU6.COMPANY_MANAGED_PROJECT) && projectData.softwareBoardCount && projectData.softwareBoardCount >= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irF25.HorizontalNavBoardHeader), {
        boardFragment: board,
        projectFragment: projectData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzZnF.ProjectHeader), {
        queryFragment: data,
        projectFragment: projectData
    });
};
var $d9e172e45f4424ed$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d9e172e45f4424ed$var$NavHeader);

});
parcelRegister("caHFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7f59a739301f95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb3d49ec1361822d0b50dc23ab66269c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed7f59a739301f95$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "HorizontalNavBoardHeader_project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            "action": "THROW",
            "path": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "mostRecentlyViewedBoard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "HorizontalNavBoardHeader_board"
                                }
                            ],
                            "type": "JiraBoard"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$ed7f59a739301f95$var$node.hash = "e6f2c3a6daae909edfe8b5a8b679337c";
var $ed7f59a739301f95$export$2e2bcd8739ae039 = $ed7f59a739301f95$var$node;

});

parcelRegister("doRiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ccaf9d0c88deef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3972279f28209d5e2c9e54ca00a26ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1ccaf9d0c88deef$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "boardId"
        },
        {
            "kind": "RootArgument",
            "name": "withBoard"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_query"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "withBoard",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "id",
                                        "variableName": "boardId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "jiraBoard",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "UserBoardHeader_board"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "HorizontalNavBoardHeader_board"
                                            }
                                        ],
                                        "type": "JiraBoard"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$f1ccaf9d0c88deef$var$node.hash = "b22ab921c492432920571f89e3a177a3";
var $f1ccaf9d0c88deef$export$2e2bcd8739ae039 = $f1ccaf9d0c88deef$var$node;

});

parcelRegister("irF25", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavBoardHeader", () => $30137961c15e82bc$export$a50d1fe8d7279a5c);

var $8CWoZ = parcelRequire("8CWoZ");

var $d9zQ5 = parcelRequire("d9zQ5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");


var $g7crU = parcelRequire("g7crU");


var $2203k = parcelRequire("2203k");

var $iXVV6 = parcelRequire("iXVV6");

var $eC0BO = parcelRequire("eC0BO");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $krB5y = parcelRequire("krB5y");

var $hjXMc = parcelRequire("hjXMc");

var $2qjHu = parcelRequire("2qjHu");
const $30137961c15e82bc$export$a50d1fe8d7279a5c = ({ boardFragment: boardFragment, projectFragment: projectFragment = null })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const board = (0, $8Uumt.useFragment)((0, $d9zQ5.default), boardFragment);
    const project = (0, $8Uumt.useFragment)((0, $8CWoZ.default), projectFragment);
    const toBoardType = (jiraBoardType)=>{
        if (jiraBoardType === 'SCRUM') return 0, $8f9d7295a53f46ca$export$b75edebf0c64f31e;
        if (jiraBoardType === 'KANBAN') return 0, $8f9d7295a53f46ca$export$eff0efe8746a33f;
    };
    const boardData = (0, $5uXOq.useMemo)(()=>{
        if (board?.__typename !== 'JiraBoard') return null;
        const isPublicBoard = !!board.name;
        return isPublicBoard ? {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            name: board.name,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            type: toBoardType(board.boardType),
            favourite: board.favouriteValue?.isFavourite ?? false,
            canEdit: !!board.canEdit
        } : {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            canEdit: !!board.canEdit,
            isPrivate: true
        };
    }, [
        board
    ]);
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            navigationContainer: (0, $68cb678dc917978e$export$b83d0ee9325a2d0a)
        }), []);
    if (board == null || board.__typename !== 'JiraBoard' || board.boardId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        title: board.name,
        isLoading: board == null,
        extraComponentsClose: [
            showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qjHu.NavigationTeamButton), {
                key: "TeamButton",
                projectFragment: project,
                scope: "board"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                key: "BoardActions",
                attributes: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2203k.BoardActions), {
                key: "BoardActions",
                board: boardData,
                projectFragment: project,
                isBoardFavorite: board.favouriteValue?.isFavourite ?? undefined
            }))
        ],
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krB5y.ExtraComponentsFar), {
            projectFragment: project
        }),
        testId: "horizontal-nav-header.ui.board-header.header",
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjXMc.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project,
            shouldShowProjectName: true
        })
    });
};

});
parcelRegister("8CWoZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4383aaac6682da6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e2cdcef8dcfebdff39ba9650da81044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4383aaac6682da6c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_navigationBoardActionMenu_BoardActions"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$4383aaac6682da6c$var$node.hash = "0182ef8ea67e2047a2c73a62c74cf453";
var $4383aaac6682da6c$export$2e2bcd8739ae039 = $4383aaac6682da6c$var$node;

});

parcelRegister("d9zQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $78aa502f173ea5af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<739dfc853bfad69d6e306d8e6203605d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $78aa502f173ea5af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_board",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    },
                    "action": "THROW",
                    "path": "favouriteValue.isFavourite"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraBoard"
};
$78aa502f173ea5af$var$node.hash = "2bee90c92c0551f1635f4463f247385b";
var $78aa502f173ea5af$export$2e2bcd8739ae039 = $78aa502f173ea5af$var$node;

});

const $8f9d7295a53f46ca$export$b75edebf0c64f31e = 'scrum';
const $8f9d7295a53f46ca$export$eff0efe8746a33f = 'kanban';
const $8f9d7295a53f46ca$export$aca095bc476d426f = 'simple';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("2203k", function(module, exports) {

$parcel$export(module.exports, "BoardActions", () => $5884ba870969fb86$export$bb50bc4d1176eb2f);

var $7FzK5 = parcelRequire("7FzK5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1Seuh = parcelRequire("1Seuh");

var $bGsST = parcelRequire("bGsST");

var $51oeD = parcelRequire("51oeD");

var $4AeHp = parcelRequire("4AeHp");

var $7H980 = parcelRequire("7H980");
var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $6eFvr = parcelRequire("6eFvr");

var $1WQct = parcelRequire("1WQct");

var $9BBUA = parcelRequire("9BBUA");

var $koVbs = parcelRequire("koVbs");

var $9g2vH = parcelRequire("9g2vH");


var $eDLAW = parcelRequire("eDLAW");

var $36mJD = parcelRequire("36mJD");

var $d62in = parcelRequire("d62in");

var $jgJNO = parcelRequire("jgJNO");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $h2QE2 = parcelRequire("h2QE2");

var $8j0rr = parcelRequire("8j0rr");

var $gYrf5 = parcelRequire("gYrf5");
const $5884ba870969fb86$export$bb50bc4d1176eb2f = ({ board: board, projectFragment: projectFragment, placement: placement, isBoardFavorite: isBoardFavorite = false, isParentProjectStarred: isParentProjectStarred, forceOpen: forceOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceOpen);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent } = (0, $eDLAW.useProjectsAnalyticsL3)();
    const { sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent } = (0, $36mJD.useProjectsAnalyticsL4)();
    const project = (0, $8Uumt.useFragment)((0, $7FzK5.default), projectFragment);
    const tenantId = (0, $koeKL.useCloudId)();
    const boardARI = (0, $1WQct.JiraSoftwareBoardAri).create({
        siteId: tenantId,
        boardId: board?.id.toString() ?? ''
    }).toString();
    const [showDeleteModal, setShowDeleteModal] = (0, $5uXOq.useState)(false);
    const boardId = board?.id || '';
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const route = (0, $8j0rr.useRoute)();
    const isBacklogUrl = (0, $9g2vH.isBacklogRoute)(route.name);
    if (!project?.projectKey) return null;
    const openModal = ()=>{
        setShowDeleteModal(true);
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            itemId: (0, $496585bee7985bb9$export$a68d619e7022f2c3),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const handleBoardDelete = ()=>{
        if (!board?.dataId) return;
        setShowDeleteModal(false);
        push(`/browse/${project?.projectKey}`);
    };
    const handleModalCancel = ()=>{
        setShowDeleteModal(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: placement ?? 'bottom-start',
        testId: "navigation-board-action-menu.ui.popup",
        messageId: "navigation-board-action-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d62in.FavoriteToggleButton), {
                entityId: boardARI,
                entityTypeName: "JiraBoard",
                defaultIsStarred: isBoardFavorite,
                onClick: ()=>sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        itemId: isBoardFavorite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684),
                        boardId: Number(boardId),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    spacing: "spacious"
                }),
                "aria-label": formatMessage((0, $gYrf5.default).boardSettingsLabel),
                href: $5884ba870969fb86$var$getJSWCMPBoardSettingsUrl(project?.projectKey, boardId, isBacklogUrl),
                onClick: ()=>{
                    sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        boardId: Number(boardId),
                        itemId: (0, $496585bee7985bb9$export$192d610b0b7719f4),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    });
                }
            }, formatMessage((0, $gYrf5.default).boardSettingsLabel))), board?.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bGsST))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
                onClick: openModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                color: "color.text.danger"
            }, formatMessage((0, $gYrf5.default).deleteBoardLabel))))), board && board.canEdit && showDeleteModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BBUA.default), {
                board: board,
                // eslint-disable-next-line jira/deprecations/no-base-url
                baseUrl: "",
                onBoardDeleteFailed: ()=>setShowDeleteModal(false),
                onBoardDeleted: handleBoardDelete,
                onCancel: handleModalCancel
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4AeHp))),
                label: formatMessage((0, $gYrf5.default).dropdownIconLabel),
                appearance: "subtle",
                spacing: (0, $4R6GH.fg)('blu-5566-nav4-real-estates-updates') ? 'default' : 'compact',
                onClick: ()=>{
                    setIsOpen(!isOpen);
                    sendMeatBallDropDownOnBoardsAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        boardId: Number(boardId),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    });
                },
                isSelected: isOpen,
                testId: "navigation-board-action-menu.ui.dropdown"
            }),
        shouldRenderToParent: (0, $4R6GH.fg)('a11y-actions-menus-reading-order')
    });
};
function $5884ba870969fb86$var$getJSWCMPBoardSettingsUrl(projectKey, boardId, isBacklogUrl) {
    const supportsCurrentNav = (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)();
    if (supportsCurrentNav && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const query = isBacklogUrl ? '?from-backlog=1' : '';
        return `${(0, $h2QE2.getBoardSettingsUrl)((0, $h2QE2.getBoardUrl)(projectKey, boardId, true))}/filter${query}`;
    }
    const path = isBacklogUrl ? '/backlog' : '';
    return `/jira/software/c/projects/${projectKey}/boards/${boardId}${path}?config=filter`;
}

});
parcelRegister("7FzK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a3e7e58b3c58ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caaf1222eee2525329079525fc89c17d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18a3e7e58b3c58ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationBoardActionMenu_BoardActions",
    "selections": [
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$18a3e7e58b3c58ae$var$node.hash = "c4890e10b4a9bc525d38501ea5a616a3";
var $18a3e7e58b3c58ae$export$2e2bcd8739ae039 = $18a3e7e58b3c58ae$var$node;

});

parcelRegister("bGsST", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $881a05c6f4edd719$var$_react = $881a05c6f4edd719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $881a05c6f4edd719$var$_baseNew = $881a05c6f4edd719$var$_interopRequireDefault((parcelRequire("enEmH")));
function $881a05c6f4edd719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $881a05c6f4edd719$var$DeleteIcon = (props)=>/*#__PURE__*/ $881a05c6f4edd719$var$_react.default.createElement($881a05c6f4edd719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$881a05c6f4edd719$var$DeleteIcon.displayName = 'DeleteIcon';
var $881a05c6f4edd719$var$_default = module.exports.default = $881a05c6f4edd719$var$DeleteIcon;

});

parcelRegister("4AeHp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab63f49f3262af83b926e204475086f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3565ed240e83552e$var$_react = $3565ed240e83552e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3565ed240e83552e$var$_baseNew = $3565ed240e83552e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $3565ed240e83552e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3565ed240e83552e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $3565ed240e83552e$var$_react.default.createElement($3565ed240e83552e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.25 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M0 6a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 0 6m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M4.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M9.5 6A1.25 1.25 0 1 1 12 6a1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"/><path fill="currentcolor" d="M1.5 6A.25.25 0 1 1 1 6a.25.25 0 0 1 .5 0m4.75 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M11 6a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"/>`,
        type: 'utility'
    }, props));
$3565ed240e83552e$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $3565ed240e83552e$var$_default = module.exports.default = $3565ed240e83552e$var$ShowMoreHorizontalIcon;

});

parcelRegister("9BBUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a0504256a529d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");


var $1tXsX = parcelRequire("1tXsX");

var $49qY2 = parcelRequire("49qY2");

var $ck8Za = parcelRequire("ck8Za");

var $iAAcr = parcelRequire("iAAcr");
// eslint-disable-next-line jira/react/no-class-components
class $22a0504256a529d4$var$DeleteModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $ck8Za.default)((0, $1tXsX.default));
        this.store.dispatch((0, $49qY2.setAppProps)(this.props));
        this.store.dispatch((0, $49qY2.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAAcr.default), null)));
    }
}
var $22a0504256a529d4$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('deleteBoard', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($22a0504256a529d4$var$DeleteModal);

});
parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1tXsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51ccb85a14bd3c5$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $3pHol = parcelRequire("3pHol");

var $jxD18 = parcelRequire("jxD18");
var // @ts-expect-error - TS2769 - No overload matches this call.
$b51ccb85a14bd3c5$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $3pHol.default), (0, $jxD18.default));

});
parcelRegister("3pHol", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b51828983128039$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");


var $fsh9d = parcelRequire("fsh9d");

var $9xsrV = parcelRequire("9xsrV");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b51828983128039$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        return (0, $9xsrV.default)(baseUrl, board.id).mergeMap(()=>{
            (0, $8ojMd.getOnBoardDeleted)(state)(board);
            return (0, $kVLXA.Observable).of((0, $49qY2.boardDeleted)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.delete-board', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $8ojMd.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $kVLXA.Observable).of((0, $49qY2.deleteBoardFailed)({
                reason: reason
            }));
        });
    });

});
const $cb28450c2d487e75$export$f1a2e76e49f3534e = 'directories.boards.error';

parcelRegister("fsh9d", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $064efdbf2b7e743c$export$c77be5886e7f1d9e);

var $2YZCu = parcelRequire("2YZCu");
const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

parcelRegister("9xsrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $30eef91be03ea0d6$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$30eef91be03ea0d6$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $487fd.default)(url, options);
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});


parcelRegister("49qY2", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $d54547bc1c4d086f$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $d54547bc1c4d086f$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $d54547bc1c4d086f$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $d54547bc1c4d086f$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $d54547bc1c4d086f$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $d54547bc1c4d086f$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $d54547bc1c4d086f$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $d54547bc1c4d086f$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $d54547bc1c4d086f$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $d54547bc1c4d086f$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $d54547bc1c4d086f$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $d54547bc1c4d086f$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $d54547bc1c4d086f$export$d6d2ce109de8e68b);
const $d54547bc1c4d086f$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $d54547bc1c4d086f$export$cfda7627848a58cd = (payload)=>({
        type: $d54547bc1c4d086f$export$8aefe701a6f431e0,
        payload: payload
    });
const $d54547bc1c4d086f$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $d54547bc1c4d086f$export$2893b8608d2a6d6a = ()=>({
        type: $d54547bc1c4d086f$export$590db52f99257537
    });
const $d54547bc1c4d086f$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $d54547bc1c4d086f$export$12dcad2fd94d0a72 = (payload)=>({
        type: $d54547bc1c4d086f$export$215dde409662413,
        payload: payload
    });
const $d54547bc1c4d086f$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $d54547bc1c4d086f$export$694c6ee523cd87cb = ()=>({
        type: $d54547bc1c4d086f$export$14cf35077b6f85f7
    });
const $d54547bc1c4d086f$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $d54547bc1c4d086f$export$a68d619e7022f2c3
    });
const $d54547bc1c4d086f$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $d54547bc1c4d086f$export$983279b2aa6031b0 = (payload)=>({
        type: $d54547bc1c4d086f$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $d54547bc1c4d086f$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $d54547bc1c4d086f$export$d6d2ce109de8e68b = ()=>({
        type: $d54547bc1c4d086f$export$aea8ac0fecc03cf6
    });

});

parcelRegister("8ojMd", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $fd5d0e91a7503729$export$f654b28f82155665);
$parcel$export(module.exports, "getBoard", () => $fd5d0e91a7503729$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $fd5d0e91a7503729$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $fd5d0e91a7503729$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $fd5d0e91a7503729$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $fd5d0e91a7503729$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $fd5d0e91a7503729$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $fd5d0e91a7503729$export$4e64490e97fad74a);
const $fd5d0e91a7503729$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $fd5d0e91a7503729$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $fd5d0e91a7503729$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $fd5d0e91a7503729$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $fd5d0e91a7503729$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $fd5d0e91a7503729$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $fd5d0e91a7503729$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $fd5d0e91a7503729$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("jxD18", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8e1cebd0698b37$export$2e2bcd8739ae039);
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");



var $fsh9d = parcelRequire("fsh9d");

var $1o0mA = parcelRequire("1o0mA");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b8e1cebd0698b37$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $8f9d7295a53f46ca$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
        }
        return (0, $kVLXA.Observable).fromPromise((0, $1o0mA.default)(baseUrl, board.id)).mergeMap((sprints)=>{
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.get-active-sprints', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            return (0, $kVLXA.Observable).of((0, $49qY2.getActiveSprintsFailed)());
        });
    });

});
parcelRegister("1o0mA", function(module, exports) {

$parcel$export(module.exports, "default", () => $593a1371127faca1$export$2e2bcd8739ae039);

var $cVp8I = parcelRequire("cVp8I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$593a1371127faca1$export$2e2bcd8739ae039 = async (baseUrl, boardId)=>{
    const activeSprints = await (0, $cVp8I.default)(baseUrl, boardId);
    return activeSprints.values;
};

});
parcelRegister("cVp8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7120231aa21daa$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f7120231aa21daa$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const params = (0, $ebyGx.stringify)({
        state: 'active'
    });
    return (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

});




parcelRegister("ck8Za", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca4b6202c29f451$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $0jPL7 = parcelRequire("0jPL7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ca4b6202c29f451$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $0jPL7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("0jPL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2fd5f8b2e6ddfae$export$2e2bcd8739ae039);

var $49qY2 = parcelRequire("49qY2");
const $e2fd5f8b2e6ddfae$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2fd5f8b2e6ddfae$export$2e2bcd8739ae039 = (state = $e2fd5f8b2e6ddfae$var$defaultState, action)=>{
    switch(action.type){
        case 0, $49qY2.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $49qY2.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $49qY2.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $49qY2.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS:
        case 0, $49qY2.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("iAAcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $af343ed9c16b8de5$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");

var $i89gU = parcelRequire("i89gU");

var $kzAuQ = parcelRequire("kzAuQ");
const $af343ed9c16b8de5$var$mapStateToProps = (state)=>({
        Content: $i89gU.default,
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state),
        deleteInProgress: (0, $8ojMd.isDeleteInProgress)(state),
        onCancel: (0, $8ojMd.getOnCancel)(state)
    });
var $af343ed9c16b8de5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $az4zD.injectIntlV2), (0, $bC2fB.connect)($af343ed9c16b8de5$var$mapStateToProps, {
    onDelete: (0, $49qY2.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $kzAuQ.default));

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("i89gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $54da6d40f32d7800$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $8ojMd = parcelRequire("8ojMd");

var $igKvW = parcelRequire("igKvW");
const $54da6d40f32d7800$var$mapStateToProps = (state)=>({
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$54da6d40f32d7800$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($54da6d40f32d7800$var$mapStateToProps, {})((0, $igKvW.default));

});
parcelRegister("igKvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b0115c410cf51a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $45XQ3 = parcelRequire("45XQ3");
// eslint-disable-next-line jira/react/no-class-components
class $45b0115c410cf51a$var$Content extends (0, $5uXOq.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).privateBoardMessage));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            as: "p"
        }, formatMessage((0, $45XQ3.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            as: "em"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $45XQ3.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).noSprintsMessage, {
            boardName: board.name
        }));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $45XQ3.default).singleSprintMessage,
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $45b0115c410cf51a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($45b0115c410cf51a$var$Content);

});
parcelRegister("45XQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d141b44f5ce2e32$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d141b44f5ce2e32$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    }
});

});



parcelRegister("kzAuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9258234539a783c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $7NYq5 = parcelRequire("7NYq5");

var $1WQct = parcelRequire("1WQct");

var $hZHze = parcelRequire("hZHze");

var $1ppIJ = parcelRequire("1ppIJ");

var $9fuVs = parcelRequire("9fuVs");

var $3HwlS = parcelRequire("3HwlS");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $cSD7y = parcelRequire("cSD7y");

var $ehcCJ = parcelRequire("ehcCJ");

var $iT7TT = parcelRequire("iT7TT");
const $c9258234539a783c$var$ModalDialog = (0, $cSD7y.componentWithFG)('jfp_a11y_team_boards_delete_actions_return_focus', (0, $1ppIJ.ModalDialog), (0, $7NYq5.JiraModal));
function $c9258234539a783c$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $koeKL.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $ehcCJ.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $iT7TT.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $iT7TT.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $1WQct.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $erN97.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9258234539a783c$var$ModalDialog, {
        messageId: "delete-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "danger",
        onClick: (0, $3HwlS.getWillShowNav4)() ? handleDelete : onDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).cancel)))));
}
$c9258234539a783c$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $c9258234539a783c$export$2e2bcd8739ae039 = $c9258234539a783c$var$DeleteBoardsModal;

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $asiGE.default)({
    componentName: 'view-tracker'
})((0, $3TR0I.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $iXqE5.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $3sQ5x.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $3sQ5x.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("ehcCJ", function(module, exports) {

$parcel$export(module.exports, "useDeleteBoard", () => $f597fd2c84db3563$export$abd16ada93ebfa6a);

var $8Uumt = parcelRequire("8Uumt");
const $f597fd2c84db3563$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $f597fd2c84db3563$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return $f597fd2c84db3563$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("iT7TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cc28168885a575$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7cc28168885a575$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});

});




parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

const $496585bee7985bb9$export$f06dfcec5ff912e = 'meatballDropdown';
const $496585bee7985bb9$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $496585bee7985bb9$export$78fd0bd637fe1684 = 'addToStarred';
const $496585bee7985bb9$export$c540230986f848f6 = 'addPeople';
const $496585bee7985bb9$export$44d67b522cbcce6d = 'projects';
const $496585bee7985bb9$export$3cc9ab700c406a19 = 'projectSettings';
const $496585bee7985bb9$export$dc23a793cf9e9de8 = 'archiveProject';
const $496585bee7985bb9$export$a68d619e7022f2c3 = 'deleteBoard';
const $496585bee7985bb9$export$22748439827110a4 = 'deleteProject';
const $496585bee7985bb9$export$192d610b0b7719f4 = 'boardSettings';
const $496585bee7985bb9$export$a65812b4aab631bb = 'alertSettings';
const $496585bee7985bb9$export$ca6db12118be69a1 = 'schemas';
const $496585bee7985bb9$export$f2eca6cf19c9a973 = 'reports';
const $496585bee7985bb9$export$147264622218a553 = 'dataManager';
const $496585bee7985bb9$export$ee52916f9ebd8000 = 'adapters';
const $496585bee7985bb9$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $496585bee7985bb9$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $496585bee7985bb9$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $496585bee7985bb9$export$27e4092edca7bb97 = 'jwmSampleProject';
const $496585bee7985bb9$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $496585bee7985bb9$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $496585bee7985bb9$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $496585bee7985bb9$export$f8a73cc0211412ca = 'mostRecentProjectOnly';

parcelRegister("eDLAW", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $304a05e3ff22f010$export$619b8904be99ed7c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aTtGi = parcelRequire("aTtGi");

const $304a05e3ff22f010$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $632bd8725b437a12$export$119dad133da0b4a)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';

const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $632bd8725b437a12$export$9b8283d5878d2491 = 'board';
const $632bd8725b437a12$export$c3d83ca6855fa0d0 = 'app';
const $632bd8725b437a12$export$c1c49903035a02df = 'filter';
const $632bd8725b437a12$export$6deee0e4f2fb784e = 'defaultFilter';
const $632bd8725b437a12$export$4695c1a423ffe431 = 'dashboard';
const $632bd8725b437a12$export$5828682c822c26e7 = 'queue';
const $632bd8725b437a12$export$fe791c4fa892e400 = 'project';
const $632bd8725b437a12$export$c303e491e026ebc6 = 'plan';
const $632bd8725b437a12$export$509e83d3c8d91279 = 'appSubpage';
const $632bd8725b437a12$export$a2e7d1d0a3d169f4 = 'asset';
const $632bd8725b437a12$export$b56168d831461ce2 = 'operation';
const $632bd8725b437a12$export$499a3e77858b7713 = 'translationGroup';
const $632bd8725b437a12$export$bb8a37ab8d9ba82b = 'roadmap';
const $632bd8725b437a12$export$9a778ca616c24a93 = 'projectRecommendation';
const $632bd8725b437a12$export$9cbb0f231a0ab7ea = 'overview';
const $632bd8725b437a12$export$119dad133da0b4a = 'changeView';

const $951a0ed422513987$export$265c523d1a8f25cf = '1';
const $951a0ed422513987$export$fe3b012b0224e4e1 = '2';
const $951a0ed422513987$export$f9db6a58b4aabd18 = '3';
const $951a0ed422513987$export$35ac629b8b943d5a = '4';

parcelRegister("aTtGi", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $085f7c8df53a9d4d$export$542854f16c0127e7);

var $jecJ3 = parcelRequire("jecJ3");
const $085f7c8df53a9d4d$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $jecJ3.SECTION_ITEM_STARRED;
    if (recent) return 0, $jecJ3.SECTION_ITEM_RECENT;
    return '';
};

});
parcelRegister("jecJ3", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $06147718dc8a8493$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $06147718dc8a8493$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $06147718dc8a8493$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $06147718dc8a8493$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $06147718dc8a8493$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $06147718dc8a8493$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $06147718dc8a8493$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $06147718dc8a8493$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $06147718dc8a8493$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $06147718dc8a8493$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $06147718dc8a8493$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $06147718dc8a8493$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $06147718dc8a8493$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $06147718dc8a8493$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $06147718dc8a8493$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $06147718dc8a8493$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $06147718dc8a8493$export$340dfb7166bc7df6);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $06147718dc8a8493$export$1a73d7f5e6997c6d);

var $jhS4y = parcelRequire("jhS4y");
const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
const $06147718dc8a8493$export$31111a67d393221 = 'projects';
const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
const $06147718dc8a8493$export$935694b184853c59 = 'assets';
const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
const $06147718dc8a8493$export$f3045e909a12df36 = 'customerHubs';
const $06147718dc8a8493$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $06147718dc8a8493$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $06147718dc8a8493$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $06147718dc8a8493$export$f3045e909a12df36,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $06147718dc8a8493$export$f780439bdf7412c6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $06147718dc8a8493$export$340dfb7166bc7df6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $06147718dc8a8493$export$be1ee97c6c39a7a0
};

});


const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';


parcelRegister("36mJD", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL4", () => $6db414ac8e29993a$export$cc7d25cb07e1eb10);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aTtGi = parcelRequire("aTtGi");
const $6db414ac8e29993a$export$cc7d25cb07e1eb10 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$35ac629b8b943d5a)
        }), []);
    // actions inside meatball menu on boards
    const sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectId: projectId,
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent
    };
};

});

parcelRegister("d62in", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $177932fc5526585a$export$b01f3062fe4ad89b);

var $5uXOq = parcelRequire("5uXOq");

var $X3Phd = parcelRequire("X3Phd");

var $fkyxu = parcelRequire("fkyxu");

var $7H980 = parcelRequire("7H980");

var $6eFvr = parcelRequire("6eFvr");

var $4041n = parcelRequire("4041n");

var $koVbs = parcelRequire("koVbs");

var $9eeFp = parcelRequire("9eeFp");

var $9WLyc = parcelRequire("9WLyc");
const $177932fc5526585a$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fkyxu))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $177932fc5526585a$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($X3Phd))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $177932fc5526585a$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $4041n.useChangeFavorite)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $9eeFp.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: $177932fc5526585a$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: $177932fc5526585a$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).addToStarred)));
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1Y49U = parcelRequire("1Y49U");

var $1WQct = parcelRequire("1WQct");

var $k0goX = parcelRequire("k0goX");

var $gbLWS = parcelRequire("gbLWS");

var $89DrR = parcelRequire("89DrR");

var $j5YhT = parcelRequire("j5YhT");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $j5YhT.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $gbLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $k0goX.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $89DrR.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $1WQct.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1Y49U.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("9eeFp", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $9838019739bca90d$export$f7bb512e68bcecd9);

var $5uXOq = parcelRequire("5uXOq");
const $9838019739bca90d$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $5uXOq.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("9WLyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff4f0ec548b713f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ff4f0ec548b713f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $vCqQa = parcelRequire("vCqQa");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $vCqQa.Popup), 'isOpen', 'content');

});


parcelRegister("h2QE2", function(module, exports) {

$parcel$export(module.exports, "getBoardSettingsHref", () => $34db911e1caaedb7$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $34db911e1caaedb7$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $34db911e1caaedb7$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $34db911e1caaedb7$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $34db911e1caaedb7$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getUserBoardUrl", () => $34db911e1caaedb7$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $34db911e1caaedb7$export$222cc43a27cdf5b1);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
function $34db911e1caaedb7$export$8d54870ff0bbaead(view, location) {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    !$34db911e1caaedb7$var$isServiceDeskLocation(location) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $34db911e1caaedb7$export$e4d153b3e021fb47(view, queryConfig = '', pathConfig = '') {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return pathConfig === view;
    return queryConfig === view;
}
function $34db911e1caaedb7$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $34db911e1caaedb7$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $34db911e1caaedb7$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("8j0rr", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $71494baa766bb420$export$3f79f0b98112cf57);

var $lODMY = parcelRequire("lODMY");
const $71494baa766bb420$export$3f79f0b98112cf57 = (0, $lODMY.createRouterSelector)((state)=>state.route);

});

parcelRegister("gYrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b00a9a853f2de0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19b00a9a853f2de0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardSettingsLabel: {
        "id": "navigation-board-action-menu.board-settings-label",
        "defaultMessage": "Board settings"
    },
    deleteBoardLabel: {
        "id": "navigation-board-action-menu.delete-board-label",
        "defaultMessage": "Delete board"
    },
    dropdownIconLabel: {
        "id": "navigation-board-action-menu.dropdown-icon-label",
        "defaultMessage": "Board actions"
    }
});

});


parcelRegister("eC0BO", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a9450e4a0fa7fd$export$2e2bcd8739ae039);
/* BaseHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $9IFFl = parcelRequire("9IFFl");

var $4R6GH = parcelRequire("4R6GH");

var $1IAbb = parcelRequire("1IAbb");
const $55a9450e4a0fa7fd$var$BaseHeader = ({ title: title, withInlineEdit: withInlineEdit, onConfirm: onConfirm, onValidate: onValidate, id: id, icon: icon, extraComponentsClose: extraComponentsClose, extraComponentsFar: extraComponentsFar, extraComponentsAbove: extraComponentsAbove, isLoading: isLoading = false, testId: testId })=>{
    const WrapperElement = extraComponentsAbove ? (0, $0yZbT.default) : (0, $5uXOq.Fragment);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.100",
        xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $55a9450e4a0fa7fd$var$extraComponentsAboveStylesWithNoMargin : $55a9450e4a0fa7fd$var$extraComponentsAboveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $55a9450e4a0fa7fd$var$headerWrapperStylesWithUpdatedWhitespace : $55a9450e4a0fa7fd$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.IconSkeleton), {
        "data-testid": "business-horizontal-nav.common.ui.header.icon-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $55a9450e4a0fa7fd$var$titleSkeletonStyles,
        testId: "business-horizontal-nav.common.ui.header.title-skeleton"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $55a9450e4a0fa7fd$var$extraComponentsAboveStylesWithNoMargin : $55a9450e4a0fa7fd$var$extraComponentsAboveStyles
    }, extraComponentsAbove), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $55a9450e4a0fa7fd$var$headerWrapperStylesWithUpdatedWhitespace : $55a9450e4a0fa7fd$var$headerWrapperStyles,
        testId: testId
    }, icon, withInlineEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1IAbb.EditableTitle), {
        key: id,
        title: title,
        onConfirm: onConfirm,
        onValidate: onValidate
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $55a9450e4a0fa7fd$var$titleContainerStyles
    }, (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55a9450e4a0fa7fd$var$TitleWithSmallerFont, null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55a9450e4a0fa7fd$var$Title, null, title)), extraComponentsClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignInline: "start"
    }, extraComponentsClose), extraComponentsFar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $55a9450e4a0fa7fd$var$extraComponentsFarStyles
    }, extraComponentsFar)));
};
var $55a9450e4a0fa7fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($55a9450e4a0fa7fd$var$BaseHeader);
const $55a9450e4a0fa7fd$var$headerWrapperStyles = (0, $2s57o.xcss)({
    justifyContent: 'flex-start',
    gap: 'space.100',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    height: "var(--ds-space-400, 32px)"
});
const $55a9450e4a0fa7fd$var$headerWrapperStylesWithUpdatedWhitespace = (0, $2s57o.xcss)({
    justifyContent: 'flex-start',
    gap: 'space.075',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    height: "var(--ds-space-400, 32px)"
});
const $55a9450e4a0fa7fd$var$titleSkeletonStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '200px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '90px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $55a9450e4a0fa7fd$var$extraComponentsFarStyles = (0, $2s57o.xcss)({
    alignSelf: 'end',
    marginLeft: 'auto'
});
const $55a9450e4a0fa7fd$var$extraComponentsAboveStyles = (0, $2s57o.xcss)({
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginBottom: 'space.075'
});
const $55a9450e4a0fa7fd$var$extraComponentsAboveStylesWithNoMargin = (0, $2s57o.xcss)({
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $55a9450e4a0fa7fd$var$titleContainerStyles = (0, $2s57o.xcss)({
    display: 'grid'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55a9450e4a0fa7fd$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8nf1z _19pkidpf _syazfrbu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $55a9450e4a0fa7fd$var$TitleWithSmallerFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8lodh _19pkidpf _syazfrbu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9IFFl", function(module, exports) {

$parcel$export(module.exports, "ProjectIcon", () => $48848e57380c5fd1$export$219c8b8c393795b3);
$parcel$export(module.exports, "ProjectIconSmallerSize", () => $48848e57380c5fd1$export$f93a8bad82c8219);
$parcel$export(module.exports, "IconSkeleton", () => $48848e57380c5fd1$export$777a4901c1708535);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48848e57380c5fd1$var$iconStylesCompiledStyles = null;
const $48848e57380c5fd1$var$iconStylesWithSmallerSize = null;
const $48848e57380c5fd1$export$219c8b8c393795b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $48848e57380c5fd1$export$f93a8bad82c8219 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf",
            __cmplp.className
        ])
    });
});
const $48848e57380c5fd1$export$777a4901c1708535 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3i1tcg _1bsb1tcg _bfhkn82g",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1IAbb", function(module, exports) {

$parcel$export(module.exports, "EditableTitle", () => $b24d60a278aa78d2$export$f9d7171ad5f156a8);
/* EditableTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ec0Lk = parcelRequire("ec0Lk");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $6BDPK = parcelRequire("6BDPK");
const $b24d60a278aa78d2$var$renderReadView = (title, triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", {
        ...triggerProps,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _k48pmoej"
        ])
    }, (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b24d60a278aa78d2$var$ReadViewWithSmallerFont, {
        "data-testid": "horizontal-nav-header.common.ui.read-view"
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b24d60a278aa78d2$var$ReadView, {
        "data-testid": "horizontal-nav-header.common.ui.read-view"
    }, title));
const $b24d60a278aa78d2$export$f9d7171ad5f156a8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ title: title, onConfirm: onConfirm, onValidate: onValidate })=>{
    const [editValue, setEditValue] = (0, $5uXOq.useState)(title);
    const [error, setError] = (0, $5uXOq.useState)('');
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6BDPK.inlineEditTitleEditViewEntryPoint), {});
    const readViewTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b24d60a278aa78d2$var$inlineEditTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ec0Lk.default), {
        isRequired: true,
        defaultValue: editValue,
        onEdit: ()=>setError(''),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-header.inline-edit-title-edit-view",
                packageName: "jiraNavigationKitHeaderInlineEditTitleEditView",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: {
                    errorMessage: errorMessage,
                    fieldProps: {
                        ...fieldProps,
                        defaultValue: editValue ?? '',
                        value: undefined
                    }
                },
                fallback: $b24d60a278aa78d2$var$renderReadView(title),
                errorFallback: ()=>$b24d60a278aa78d2$var$renderReadView(title)
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                ref: readViewTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
                messageId: "navigation-kit-inline-edit-title.ui.jira-popup",
                messageType: "transactional",
                isOpen: error !== '',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                        xcss: $b24d60a278aa78d2$var$errorPopupStyles
                    }, error),
                placement: "right",
                trigger: (triggerProps)=>$b24d60a278aa78d2$var$renderReadView(editValue, triggerProps)
            })),
        onConfirm: (newValue)=>{
            const value = newValue.trim();
            setEditValue(value);
            onConfirm(value);
        },
        validate: (newValue)=>onValidate(title ?? '', newValue.trim())
    }));
});
const $b24d60a278aa78d2$var$errorPopupStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.200'
});
const $b24d60a278aa78d2$var$headingStyles = null;
const $b24d60a278aa78d2$var$inlineEditTitleStyles = (0, $2s57o.xcss)({
    // Negative margin is added here to make the inline edit field fit in the
    // header without needing to modify the header height
    marginTop: 'space.negative.200',
    marginBottom: 'space.negative.100',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b24d60a278aa78d2$var$ReadView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8nf1z _syazfrbu _19pk12x7 _otyr12x7 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $b24d60a278aa78d2$var$ReadViewWithSmallerFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8lodh _syazfrbu _19pk12x7 _otyr12x7 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ec0Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c84accef102bc9e$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $4EHpO = parcelRequire("4EHpO");

var $7folp = parcelRequire("7folp");

var $fHpHg = parcelRequire("fHpHg");

var $7rJgC = parcelRequire("7rJgC");

var $cBCgC = parcelRequire("cBCgC");

var $5uae8 = parcelRequire("5uae8");

var $1eXlh = parcelRequire("1eXlh");

var $4P8zB = parcelRequire("4P8zB");
const $3c84accef102bc9e$var$fieldStyles = null;
const $3c84accef102bc9e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3c84accef102bc9e$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1eXlh.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$3c84accef102bc9e$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4P8zB.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7folp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $fHpHg.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uae8.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $3c84accef102bc9e$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c84accef102bc9e$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3c84accef102bc9e$export$2e2bcd8739ae039 = $3c84accef102bc9e$var$InlineEdit;

});
parcelRegister("4EHpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4338501a4bebd545$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $bU9TL = parcelRequire("bU9TL");

var $7folp = parcelRequire("7folp");

var $cGltd = parcelRequire("cGltd");

var $cUUCJ = parcelRequire("cUUCJ");

var $6cAn5 = parcelRequire("6cAn5");
const $4338501a4bebd545$var$fieldWrapperStyles = null;
function $4338501a4bebd545$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $4338501a4bebd545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4338501a4bebd545$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $4338501a4bebd545$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $4338501a4bebd545$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $7folp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $4338501a4bebd545$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $4338501a4bebd545$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$4338501a4bebd545$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $4338501a4bebd545$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $4338501a4bebd545$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($4338501a4bebd545$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $jJsBW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cGltd.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("bU9TL", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $fd4ca56d0899c490$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $fd4ca56d0899c490$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("7folp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $989b7d35312a49bd$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $989b7d35312a49bd$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $989b7d35312a49bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $989b7d35312a49bd$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $989b7d35312a49bd$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $989b7d35312a49bd$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("cGltd", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6da09f2418b6f13e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $6da09f2418b6f13e$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6da09f2418b6f13e$var$fieldsetLabelStyles = null;
const $6da09f2418b6f13e$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $6da09f2418b6f13e$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("cUUCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ed1e0c62cc06b$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4a7ed1e0c62cc06b$var$requiredIndicatorStyles = null;
function $4a7ed1e0c62cc06b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("5uae8", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f5c85371814cc$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Seuh = parcelRequire("1Seuh");

var $goMg1 = parcelRequire("goMg1");

var $gANiX = parcelRequire("gANiX");

var $dR8fb = parcelRequire("dR8fb");
const $568f5c85371814cc$var$buttonsContainerStyles = null;
const $568f5c85371814cc$var$buttonWrapperBaseStyles = null;
const $568f5c85371814cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dR8fb))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($goMg1)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$568f5c85371814cc$export$2e2bcd8739ae039 = $568f5c85371814cc$var$Buttons;

});
parcelRegister("dR8fb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1669ea74f05704f$var$_react = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1669ea74f05704f$var$_checkMark = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $a1669ea74f05704f$var$_check = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("2n32C")));
function $a1669ea74f05704f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1669ea74f05704f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a1669ea74f05704f$var$_react.default.createElement($a1669ea74f05704f$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a1669ea74f05704f$var$_check.default
    }, props));
$a1669ea74f05704f$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a1669ea74f05704f$var$_default = module.exports.default = $a1669ea74f05704f$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("2n32C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ba016b41382ba32$var$_react = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1ba016b41382ba32$var$_checkMark = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $1ba016b41382ba32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ba016b41382ba32$var$CheckIcon = (props)=>/*#__PURE__*/ $1ba016b41382ba32$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1ba016b41382ba32$var$_checkMark.default
    }));
$1ba016b41382ba32$var$CheckIcon.displayName = 'CheckIcon';
var $1ba016b41382ba32$var$_default = module.exports.default = $1ba016b41382ba32$var$CheckIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});




parcelRegister("1eXlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0118167eb799ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ac0118167eb799ed$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $ac0118167eb799ed$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $ac0118167eb799ed$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $ac0118167eb799ed$export$2e2bcd8739ae039 = $ac0118167eb799ed$var$useButtonFocusHook;

});

parcelRegister("4P8zB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3969b97f38c61a8$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7rJgC = parcelRequire("7rJgC");
const $a3969b97f38c61a8$var$readViewContainerStyles = null;
const $a3969b97f38c61a8$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $a3969b97f38c61a8$var$readViewWrapperStyles = null;
const $a3969b97f38c61a8$var$readViewFitContainerWidthStyles = null;
const $a3969b97f38c61a8$var$DRAG_THRESHOLD = 5;
const $a3969b97f38c61a8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                xcss: $a3969b97f38c61a8$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3969b97f38c61a8$export$2e2bcd8739ae039 = $a3969b97f38c61a8$var$ReadView;

});


parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aatTc = parcelRequire("aatTc");

var $lAOer = parcelRequire("lAOer");

var $5tDD0 = parcelRequire("5tDD0");

var $5i16O = parcelRequire("5i16O");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");

var $aJOZ3 = parcelRequire("aJOZ3");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $aatTc.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $lAOer.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $lAOer.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJOZ3.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5i16O.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tDD0.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("aJOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d596e34a54eb72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $37d596e34a54eb72$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $37d596e34a54eb72$export$2e2bcd8739ae039 = $37d596e34a54eb72$var$SsrRenderProfiler;

});




parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("6BDPK", function(module, exports) {

$parcel$export(module.exports, "inlineEditTitleEditViewEntryPoint", () => $8bd2b33918b67933$export$6adaa323774f44e4);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8bd2b33918b67933$export$6adaa323774f44e4 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cTDdU")).then((module)=>module.InlineEditTitleEditViewEntryPoint), {
        moduleId: "55d1ca2e",
        moduleName: "InlineEditTitleEditView"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cTDdU", function(module, exports) {

let $96390c00d73cec05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96390c00d73cec05$var$load("39J6G").then(()=>parcelRequire('2gc8v'));

});




parcelRegister("krB5y", function(module, exports) {

$parcel$export(module.exports, "ExtraComponentsFar", () => $389ae185a2dab3d2$export$e21e0ccc96f4edd);

var $fXZnT = parcelRequire("fXZnT");

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $8Uumt = parcelRequire("8Uumt");

var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $g7crU = parcelRequire("g7crU");

var $cZpsT = parcelRequire("cZpsT");

var $6jY6G = parcelRequire("6jY6G");

var $9FHy9 = parcelRequire("9FHy9");

var $Bvv5R = parcelRequire("Bvv5R");

var $2yK1M = parcelRequire("2yK1M");
const $389ae185a2dab3d2$export$e21e0ccc96f4edd = ({ projectFragment: projectFragment })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { name: currentRouteName } = (0, $6jY6G.useCurrentRoute)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const componentsToShow = [];
    const project = (0, $8Uumt.useFragment)((0, $fXZnT.default), projectFragment);
    const hasFullscreenButton = (0, $Bvv5R.SUPPORTED_ROUTES).includes(currentRouteName);
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const shouldShowAutomation = !isAnonymous && project && canEditProjectConfig;
    const isSimplified = project?.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT);
    if (isFullscreen) {
        if (hasFullscreenButton && (0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
            componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
                key: "fullscreen"
            }));
            return componentsToShow;
        }
        return null;
    }
    let projectShareContext = null;
    if (project) projectShareContext = {
        avatarUrl: project?.avatar?.large ?? '',
        id: Number(project.projectId),
        isSimplified: isSimplified,
        key: project.key,
        name: project.name,
        style: project.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT) ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC,
        type: project?.projectType ?? ''
    };
    if (hasFullscreenButton && (0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
        key: "fullscreen"
    }));
    if (projectShareContext && !isAnonymous) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), {
        key: "share-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FHy9.ShareButton), {
        data: projectShareContext,
        key: "Share"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    })));
    if (shouldShowAutomation) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2yK1M.AutomationButton), {
        key: "automation"
    }));
    return componentsToShow;
};

});
parcelRegister("fXZnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a6919f38a63b3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6388d6addc3201cb95f9624f0c643121>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3a6919f38a63b3b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "extraComponentsFar_horizontalNav",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$a3a6919f38a63b3b$var$node.hash = "5e95b8ebdc04c45245fa22575f910961";
var $a3a6919f38a63b3b$export$2e2bcd8739ae039 = $a3a6919f38a63b3b$var$node;

});

parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("9FHy9", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $42f92381533036a0$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $4K4K7 = parcelRequire("4K4K7");

var $1WQct = parcelRequire("1WQct");

var $j5YhT = parcelRequire("j5YhT");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $104Ju = parcelRequire("104Ju");

var $22OQR = parcelRequire("22OQR");

var $5GqLe = parcelRequire("5GqLe");

var $iL8EU = parcelRequire("iL8EU");

var $16v4H = parcelRequire("16v4H");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $aocZ2 = parcelRequire("aocZ2");

var $hU5v5 = parcelRequire("hU5v5");
const $42f92381533036a0$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $42f92381533036a0$var$ShareButtonInner = ({ data: data })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isUserBoard = 'isProjectBoard' in data && data.isProjectBoard === false;
    const integrationType = (0, $5GqLe.integrationTypes).BOARD;
    const subProduct = (0, $16v4H.useSubProduct)();
    const subProductId = subProduct && $42f92381533036a0$var$subProductMap[subProduct] || 'jira-platform';
    const objectAri = isUserBoard ? (0, $1WQct.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(data.id)
    }).toString() : (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(data.id)
    }).toString();
    const [{ integrationType: pageIntegrationType, productId: productId, subProductId: pageSubproductId, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, objectAri: pageObjectAri, shareIntegrations: shareIntegrations, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, poSpotlightShareButtonId: poSpotlightShareButtonId }] = (0, $104Ju.useProjectShareButton)();
    const contentType = `${data.name}_${integrationType}`;
    const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            onClick: onClick,
            isSelected: isSelected,
            id: "po-spotlight-share-button",
            "data-vc": "share-button",
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4K4K7))), {
                spacing: "spacious",
                label: formatMessage((0, $hU5v5.messages).shareFormTitle),
                color: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
            })
        }), [
        formatMessage
    ]);
    const [isFirstHovered, setIsFirstHovered] = (0, $5uXOq.useState)(false);
    const shareButtonRef = (0, $5uXOq.useRef)(null);
    const handleIconHover = (0, $5uXOq.useCallback)(()=>{
        setIsFirstHovered(true);
        shareButtonRef?.current?.focus();
    }, []);
    // GALILEO-1454 START
    const fireJpdRoadmapOnTimelineSpotlightTrigger = (0, $aocZ2.useFireJpdRoadmapOnTimelineSpotlightTrigger)();
    const handleShareDialogClose = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireJpdRoadmapOnTimelineSpotlightTrigger();
        onDialogClose?.();
    }, [
        fireJpdRoadmapOnTimelineSpotlightTrigger,
        onDialogClose
    ]);
    // GALILEO-1454 END
    if ((0, $4R6GH.fg)('sea-2972-project-share-button')) return isFirstHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: shareButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        integrationType: pageIntegrationType || integrationType,
        productId: productId,
        subProductId: pageSubproductId || subProductId,
        shareLink: shareLink,
        shareTitle: shareTitle || data.name,
        shareContentType: shareContentType || contentType,
        objectAri: pageObjectAri || objectAri,
        shareIntegrations: shareIntegrations,
        copyTooltipText: copyTooltipText,
        onDialogClose: handleShareDialogClose,
        onTriggerButtonClick: onTriggerButtonClick,
        shareFormTitle: shareFormTitle || formatMessage((0, $hU5v5.messages).shareFormTitle),
        shareFormHelperMessage: shareFormHelperMessage || formatMessage((0, $hU5v5.messages).shareHelperMessage),
        shareFieldsFooter: shareFieldsFooter,
        renderCustomTriggerButton: renderCustomTriggerButton,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4K4K7))), {
            spacing: "spacious",
            label: formatMessage((0, $hU5v5.messages).shareFormTitle)
        }),
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: handleIconHover,
        onFocus: handleIconHover
    });
    return isFirstHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: shareButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        integrationType: integrationType,
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: data.name,
        shareContentType: contentType,
        objectAri: objectAri,
        poSpotlightShareButtonId: poSpotlightShareButtonId,
        shareFormTitle: formatMessage((0, $hU5v5.messages).shareFormTitle),
        shareFormHelperMessage: formatMessage((0, $hU5v5.messages).shareHelperMessage),
        renderCustomTriggerButton: renderCustomTriggerButton,
        onDialogClose: handleShareDialogClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4K4K7))), {
            spacing: "spacious",
            label: formatMessage((0, $hU5v5.messages).shareFormTitle),
            color: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
        }),
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: handleIconHover,
        onFocus: handleIconHover
    });
};
const $42f92381533036a0$export$e980dfbc2840e8bc = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $104Ju.ProjectShareContainer), {
        scope: (0, $8fd3709049e64a0b$export$f86c4708a4b1ecd4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f92381533036a0$var$ShareButtonInner, {
        data: data
    }));

});
parcelRegister("4K4K7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $373f2327b4286a93$var$_react = $373f2327b4286a93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $373f2327b4286a93$var$_share = $373f2327b4286a93$var$_interopRequireDefault((parcelRequire("4bgLi")));

var $373f2327b4286a93$var$_share2 = $373f2327b4286a93$var$_interopRequireDefault((parcelRequire("daD6r")));
function $373f2327b4286a93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $373f2327b4286a93$var$ShareIcon = (props)=>/*#__PURE__*/ $373f2327b4286a93$var$_react.default.createElement($373f2327b4286a93$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $373f2327b4286a93$var$_share2.default
    }, props));
$373f2327b4286a93$var$ShareIcon.Name = 'ShareIconMigration';
var $373f2327b4286a93$var$_default = module.exports.default = $373f2327b4286a93$var$ShareIcon;

});
parcelRegister("4bgLi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30b5310f9479568f$var$_react = $30b5310f9479568f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30b5310f9479568f$var$_baseNew = $30b5310f9479568f$var$_interopRequireDefault((parcelRequire("enEmH")));
function $30b5310f9479568f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30b5310f9479568f$var$ShareIcon = (props)=>/*#__PURE__*/ $30b5310f9479568f$var$_react.default.createElement($30b5310f9479568f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$30b5310f9479568f$var$ShareIcon.displayName = 'ShareIcon';
var $30b5310f9479568f$var$_default = module.exports.default = $30b5310f9479568f$var$ShareIcon;

});

parcelRegister("daD6r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $996a8a8bc5c9d178$var$_react = $996a8a8bc5c9d178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $996a8a8bc5c9d178$var$_share = $996a8a8bc5c9d178$var$_interopRequireDefault((parcelRequire("4bgLi")));
function $996a8a8bc5c9d178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $996a8a8bc5c9d178$var$ShareIcon = (props)=>/*#__PURE__*/ $996a8a8bc5c9d178$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $996a8a8bc5c9d178$var$_share.default
    }));
$996a8a8bc5c9d178$var$ShareIcon.displayName = 'ShareIcon';
var $996a8a8bc5c9d178$var$_default = module.exports.default = $996a8a8bc5c9d178$var$ShareIcon;

});


const $8fd3709049e64a0b$export$f86c4708a4b1ecd4 = 'project-share-button-global';

parcelRegister("104Ju", function(module, exports) {

$parcel$export(module.exports, "ProjectShareContainer", () => $a3cc015566e54a3d$export$44b5323fa87de475);
$parcel$export(module.exports, "useProjectShareButton", () => $a3cc015566e54a3d$export$5abd9014d277b249);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a3cc015566e54a3d$export$44b5323fa87de475 = (0, $gg7kZ.createContainer)();
const $a3cc015566e54a3d$var$initialState = {
    integrationType: '',
    productId: 'jira',
    subProductId: undefined,
    shareLink: undefined,
    shareTitle: '',
    shareContentType: '',
    shareFormTitle: undefined,
    objectAri: '',
    shareIntegrations: undefined,
    copyTooltipText: undefined,
    onDialogClose: undefined,
    onTriggerButtonClick: undefined,
    shareFormHelperMessage: undefined,
    shareFieldsFooter: undefined,
    poSpotlightShareButtonId: undefined
};
const $a3cc015566e54a3d$var$Store = (0, $iXqE5.createStore)({
    containedBy: $a3cc015566e54a3d$export$44b5323fa87de475,
    initialState: $a3cc015566e54a3d$var$initialState,
    actions: {
        setContext: (context)=>({ setState: setState })=>{
                setState({
                    ...$a3cc015566e54a3d$var$initialState,
                    ...context
                });
            },
        clearContext: ()=>({ setState: setState })=>{
                setState($a3cc015566e54a3d$var$initialState);
            }
    },
    name: 'project-share-button'
});
const $a3cc015566e54a3d$export$5abd9014d277b249 = (0, $3sQ5x.createHook)($a3cc015566e54a3d$var$Store);

});

parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $i95f5.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};

});

parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $4K4K7 = parcelRequire("4K4K7");

var $1Seuh = parcelRequire("1Seuh");

var $cnhic = parcelRequire("cnhic");

var $4bgLi = parcelRequire("4bgLi");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $93Yeu = parcelRequire("93Yeu");

var $dAfqg = parcelRequire("dAfqg");

var $lODMY = parcelRequire("lODMY");

var $7XYc4 = parcelRequire("7XYc4");

var $1hpyi = parcelRequire("1hpyi");
var $b7xtM = parcelRequire("b7xtM");

var $7CMCs = parcelRequire("7CMCs");

var $Kpokz = parcelRequire("Kpokz");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4K4K7))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gOkRe")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$export$f87be37f8e8be65 = (0, $lODMY.createRouterSelector)((state)=>state.match.params.projectKey || '');
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const projectKey = $4e5335f44d688bbf$export$f87be37f8e8be65();
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectStyle = (0, $93Yeu.useProjectStyle)(projectKey);
    const projectContext = (0, $dAfqg.useProjectContext)();
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnhic.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children);
};
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapperWithGating = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonAnalyticsWrapperWithGating, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $b7xtM.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-share-button-async",
        packageName: "jiraShareButton",
        teamName: "people-and-teams-collective",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hpyi.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bgLi))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectStyle", () => $5f0f9360597cdbd8$export$27e24febf0f5c3bc);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $buby4.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $1daUm.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $42c27dedc1310bb2$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $2vSU6 = parcelRequire("2vSU6");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$export$b291cf203d6481a4 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getJiraProjectStyle
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});



parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("1hpyi", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $5a6207578e00eafd$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $eCE62 = parcelRequire("eCE62");

var $2b2jE = parcelRequire("2b2jE");

var $l5ZMD = parcelRequire("l5ZMD");

var $65KjW = parcelRequire("65KjW");
const $5a6207578e00eafd$var$emptyEntryPointParams = {};
const $5a6207578e00eafd$var$emptyEntryPointProps = {};
function $5a6207578e00eafd$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $65KjW.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $5a6207578e00eafd$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        const defaultFallback = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {})
            ]
        });
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5ZMD.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || defaultFallback,
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $5a6207578e00eafd$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $2b2jE.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});

parcelRegister("b7xtM", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $d6fa8c34b3da9c6b$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $d6fa8c34b3da9c6b$export$9168a42f32e3d071(initialState) {
    const [panel, setPanel] = (0, $5uXOq.useState)(initialState);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("96z0m")), {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("96z0m", function(module, exports) {

let $6a0fd3d6e38f0700$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6a0fd3d6e38f0700$var$load("cM9em"),
    $6a0fd3d6e38f0700$var$load("fr9NE"),
    $6a0fd3d6e38f0700$var$load("hPzOn"),
    $6a0fd3d6e38f0700$var$load("h2MrD"),
    $6a0fd3d6e38f0700$var$load("bYT2S"),
    $6a0fd3d6e38f0700$var$load("iVQTr")
]).then(()=>parcelRequire('8kufr'));

});


parcelRegister("gOkRe", function(module, exports) {

let $c3d17ec1e67bb60d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c3d17ec1e67bb60d$var$load("cM9em"),
    $c3d17ec1e67bb60d$var$load("fr9NE"),
    $c3d17ec1e67bb60d$var$load("hPzOn"),
    $c3d17ec1e67bb60d$var$load("h2MrD"),
    $c3d17ec1e67bb60d$var$load("bYT2S"),
    $c3d17ec1e67bb60d$var$load("bfk3F")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("16v4H", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $f7eda04ad2dc7e84$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $f7eda04ad2dc7e84$export$16aa2ad52cd8992a);

var $4DPZY = parcelRequire("4DPZY");
const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("aocZ2", function(module, exports) {

$parcel$export(module.exports, "useHasJpd", () => $ce343aabec446e95$export$885c04e01732e451);
$parcel$export(module.exports, "useFireJpdRoadmapOnTimelineSpotlightTrigger", () => $ce343aabec446e95$export$251f5afd4b360688);
$parcel$export(module.exports, "useResetJpdRoadmapOnTimelineSpotlightTrigger", () => $ce343aabec446e95$export$858259b849b74419);
$parcel$export(module.exports, "pickIssuesToConvert", () => $ce343aabec446e95$export$8bc7e05763b0e01);
$parcel$export(module.exports, "useOpenCrossFlow", () => $ce343aabec446e95$export$f6033fcc5716710c);

var $5uXOq = parcelRequire("5uXOq");

var $Q9DHJ = parcelRequire("Q9DHJ");
var $bBrJC = parcelRequire("bBrJC");

var $3gy1Y = parcelRequire("3gy1Y");

var $hqBSi = parcelRequire("hqBSi");

var $lODMY = parcelRequire("lODMY");

var $j5kk0 = parcelRequire("j5kk0");

var $4R6GH = parcelRequire("4R6GH");

const $ce343aabec446e95$export$885c04e01732e451 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return licensedProducts['jira-product-discovery'] === true;
};
const $ce343aabec446e95$export$e4406211eb6a241e = ()=>{
    const timelineRoutes = new Set([
        'classic-business-timeline',
        'software-timeline',
        'software-timeline-classic'
    ]);
    return (0, $lODMY.useIsActiveRoute)(timelineRoutes);
};
const $ce343aabec446e95$export$251f5afd4b360688 = ()=>{
    const isTimelineRoute = $ce343aabec446e95$export$e4406211eb6a241e();
    const { fireTrigger: fireTrigger } = (0, $j5kk0.useFirePostOfficeTrigger)({
        triggerId: (0, $a42c0505d16c76fe$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) {
            if (isTimelineRoute) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger,
        isTimelineRoute
    ]);
    return triggerSpotlight;
};
const $ce343aabec446e95$export$858259b849b74419 = ()=>{
    const { fireTrigger: fireTrigger } = (0, $j5kk0.useFirePostOfficeTrigger)({
        triggerId: (0, $a42c0505d16c76fe$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireTrigger({
            isActive: false
        });
    }, [
        fireTrigger
    ]);
    return triggerSpotlight;
};
const $ce343aabec446e95$var$sortIssuesEpicFirst = (a, b)=>{
    if (a.issueType === 'epic' && b.issueType === 'task') return -1;
    if (a.issueType === 'task' && b.issueType === 'epic') return 1;
    return 0;
};
const $ce343aabec446e95$export$7d33d0f6a9facb15 = '4';
const $ce343aabec446e95$export$2d2b9a257f1cc7e0 = '2';
const $ce343aabec446e95$var$sortIssuesInProgressFirst = (a, b)=>{
    if (a.status.categoryId === $ce343aabec446e95$export$7d33d0f6a9facb15 && b.status.categoryId === $ce343aabec446e95$export$2d2b9a257f1cc7e0) return -1;
    if (a.status.categoryId === $ce343aabec446e95$export$2d2b9a257f1cc7e0 && b.status.categoryId === $ce343aabec446e95$export$7d33d0f6a9facb15) return 1;
    return 0;
};
const $ce343aabec446e95$var$sortIssues = (a, b)=>{
    let result = $ce343aabec446e95$var$sortIssuesEpicFirst(a, b);
    if (result === 0) result = $ce343aabec446e95$var$sortIssuesInProgressFirst(a, b);
    if (result === 0) result = a.id.localeCompare(b.id);
    return result;
};
const $ce343aabec446e95$export$8bc7e05763b0e01 = (issues, maxCount = 5)=>{
    const sortedIssues = issues.sort($ce343aabec446e95$var$sortIssues);
    const top5Issues = [];
    // pick 1 in-progress issue as the first one
    const inProgressIssue = sortedIssues.find((issue)=>issue.status.categoryId === $ce343aabec446e95$export$7d33d0f6a9facb15);
    if (inProgressIssue) top5Issues.push(inProgressIssue);
    // fill up to 5 issues with remaining todo issues
    const remainingSortedIssues = inProgressIssue ? sortedIssues.filter((issue)=>issue.id !== inProgressIssue.id) : sortedIssues;
    remainingSortedIssues.filter((issue)=>issue.status.categoryId !== $ce343aabec446e95$export$7d33d0f6a9facb15).forEach((issue)=>{
        if (top5Issues.length < maxCount) top5Issues.push(issue);
    });
    return top5Issues;
};
const $ce343aabec446e95$export$f6033fcc5716710c = (inwardIssues)=>{
    const crossFlow = (0, $Q9DHJ.useCrossFlow)();
    const templateId = 'jpd.product-roadmap';
    const extensions = (0, $3gy1Y.createProvisioningPageExtensions)({
        actions: {
            primary: {
                behaviour: (0, $3gy1Y.Behaviours).LAND,
                prompt: (0, $3gy1Y.Prompts).NEXT,
                options: {
                    targetTab: (0, $3gy1Y.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateId,
                        inwardIssueIds: inwardIssues.map(({ id: id })=>id).join(',')
                    }
                }
            }
        }
    });
    return ()=>{
        crossFlow.isEnabled && crossFlow.apiV1.open({
            journey: (0, $Q9DHJ.Journeys).GET_STARTED,
            targetProduct: (0, $bBrJC.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'recJpdOnJiraTimelineMoreSettings',
            sourceContext: 'jpdRoadmapButton',
            extensions: extensions,
            v1: true
        });
    };
};

});
parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("j5kk0", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $af1a979995a7009c$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $af1a979995a7009c$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $af1a979995a7009c$export$83b33e5fe4cce64);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $af1a979995a7009c$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $af1a979995a7009c$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $af1a979995a7009c$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialActiveTriggerState);
const $af1a979995a7009c$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialTriggerDispatchState);
const $af1a979995a7009c$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($af1a979995a7009c$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $af1a979995a7009c$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerContext);
const $af1a979995a7009c$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerDispatchContext);
const $af1a979995a7009c$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $af1a979995a7009c$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $af1a979995a7009c$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $af1a979995a7009c$export$23cbf084e08bdb93();
    const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

const $a42c0505d16c76fe$export$6672f7663a94639 = 'jpd-roadmap-on-timeline-spotlight-trigger';


parcelRegister("hU5v5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $69abc4ea8b10f9cc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $69abc4ea8b10f9cc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareFormTitle: {
        "id": "horizontal-nav-header.common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "horizontal-nav-header.common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("Bvv5R", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_ROUTES", () => $f129bf3689db09fc$export$f183fe8f38c8cf4f);
$parcel$export(module.exports, "HeaderFullscreenButton", () => $f129bf3689db09fc$export$ca813c374edd850d);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $99BAr = parcelRequire("99BAr");

var $g7crU = parcelRequire("g7crU");

var $lODMY = parcelRequire("lODMY");
const $f129bf3689db09fc$export$f183fe8f38c8cf4f = [
    'software-boards',
    'software-timeline-classic',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-user-board',
    'software-backlog',
    'software-timeline',
    'classic-business-timeline',
    'classic-business-board',
    'connect-project',
    'connect-general',
    'forge-spa-project',
    'forge-spa-global'
];
const $f129bf3689db09fc$export$ca813c374edd850d = ()=>{
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)((state)=>{
            // The board settings page is /jira/software/c/projects/TEST/boards/81/?config=filter
            // which matches the RAPIDBOARD_BOARD route, but we want to exclude it from fullscreen
            const isOnBoardConfig = state.route.name === 'rapidboard-board' && !!state.query.config;
            if (isFullscreen && !$f129bf3689db09fc$export$f183fe8f38c8cf4f.includes(state.route.name) || isOnBoardConfig) setIsFullscreen(false);
        });
        return ()=>unsubscribe();
    }, [
        isFullscreen,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "jira-horizontal-nav-header-fullscreen-button",
        packageName: "jira-horizontal-nav-header",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        key: "fullscreen",
        "data-vc": "horizontal-nav-header-fullscreen-button",
        testId: "horizontal-nav-header.ui.fullscreen-button.fullscreen-button",
        withContainerStyles: false
    }));
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle, isHidden: isHidden })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle,
        isHidden: isHidden
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $7NkuU = parcelRequire("7NkuU");

var $kegpy = parcelRequire("kegpy");

var $5KCCi = parcelRequire("5KCCi");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $3Tty1 = parcelRequire("3Tty1");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false, isHidden: isHidden })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    let globalStyle = null;
    if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
        if (!false) globalStyle = document.createElement('style');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle ?? undefined);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        if (globalStyle) {
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
        }
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        if (globalStyle) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle ?? undefined);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // remove this useEffect when cleaning up blu-5747-fullscreen-in-nav-header
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) {
            if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcutContainer
                }, formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcut
                }, formatMessage((0, $gydfO.default).fullScreenShortcut))),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                onClick: onClick,
                "aria-keyshortcuts": "Z",
                iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kegpy))), {
                    label: formatMessage((0, $gydfO.default).exitFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))), {
                    label: formatMessage((0, $gydfO.default).enterFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }),
                appearance: isSubtle ? 'subtle' : 'default',
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($kegpy))) : (0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false,
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            });
        }
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($kegpy))) : (0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button',
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kegpy))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            }),
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c116y _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $f59079bf3589c5a6$var$KeyboardShortcutContainer = (0, $2s57o.xcss)({
    display: 'flex',
    lineHeight: 'space.200',
    alignItems: 'center',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
});
const $f59079bf3589c5a6$var$KeyboardShortcut = (0, $2s57o.xcss)({
    border: `1px solid ${"var(--ds-text-inverse, #FFFFFF)"}`,
    borderRadius: '2px',
    marginLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100',
    paddingLeft: 'space.100',
    lineHeight: 'space.200'
});

});
parcelRegister("7NkuU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5acd0264cf7f9b6d$var$_react = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5acd0264cf7f9b6d$var$_growDiagonal = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("34MjD")));

var $5acd0264cf7f9b6d$var$_actualSize = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("ejYdG")));
function $5acd0264cf7f9b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5acd0264cf7f9b6d$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $5acd0264cf7f9b6d$var$_react.default.createElement($5acd0264cf7f9b6d$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $5acd0264cf7f9b6d$var$_actualSize.default
    }, props));
$5acd0264cf7f9b6d$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $5acd0264cf7f9b6d$var$_default = module.exports.default = $5acd0264cf7f9b6d$var$GrowDiagonalIcon;

});
parcelRegister("34MjD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d73952c4f37c38$var$_react = $23d73952c4f37c38$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23d73952c4f37c38$var$_baseNew = $23d73952c4f37c38$var$_interopRequireDefault((parcelRequire("enEmH")));
function $23d73952c4f37c38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d73952c4f37c38$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $23d73952c4f37c38$var$_react.default.createElement($23d73952c4f37c38$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$23d73952c4f37c38$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $23d73952c4f37c38$var$_default = module.exports.default = $23d73952c4f37c38$var$GrowDiagonalIcon;

});

parcelRegister("ejYdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d18d6d0979a5a8$var$_react = $a6d18d6d0979a5a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a6d18d6d0979a5a8$var$_growDiagonal = $a6d18d6d0979a5a8$var$_interopRequireDefault((parcelRequire("34MjD")));
function $a6d18d6d0979a5a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $a6d18d6d0979a5a8$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $a6d18d6d0979a5a8$var$_growDiagonal.default
    }));
$a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $a6d18d6d0979a5a8$var$_default = module.exports.default = $a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon;

});


parcelRegister("kegpy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eba1d85e1dd9b598$var$_react = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eba1d85e1dd9b598$var$_shrinkDiagonal = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("jmSR7")));

var $eba1d85e1dd9b598$var$_fitToPage = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("jJCZj")));
function $eba1d85e1dd9b598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eba1d85e1dd9b598$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $eba1d85e1dd9b598$var$_react.default.createElement($eba1d85e1dd9b598$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $eba1d85e1dd9b598$var$_fitToPage.default
    }, props));
$eba1d85e1dd9b598$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $eba1d85e1dd9b598$var$_default = module.exports.default = $eba1d85e1dd9b598$var$ShrinkDiagonalIcon;

});
parcelRegister("jmSR7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e19a9f9f106e471c$var$_react = $e19a9f9f106e471c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e19a9f9f106e471c$var$_baseNew = $e19a9f9f106e471c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e19a9f9f106e471c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e19a9f9f106e471c$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $e19a9f9f106e471c$var$_react.default.createElement($e19a9f9f106e471c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$e19a9f9f106e471c$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $e19a9f9f106e471c$var$_default = module.exports.default = $e19a9f9f106e471c$var$ShrinkDiagonalIcon;

});

parcelRegister("jJCZj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5e0767f85f7fe84$var$_react = $e5e0767f85f7fe84$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e5e0767f85f7fe84$var$_shrinkDiagonal = $e5e0767f85f7fe84$var$_interopRequireDefault((parcelRequire("jmSR7")));
function $e5e0767f85f7fe84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5e0767f85f7fe84$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $e5e0767f85f7fe84$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $e5e0767f85f7fe84$var$_shrinkDiagonal.default
    }));
$e5e0767f85f7fe84$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $e5e0767f85f7fe84$var$_default = module.exports.default = $e5e0767f85f7fe84$var$MediaServicesFitToPageIcon;

});


parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $9IeM0 = parcelRequire("9IeM0");

var $4lkOX = parcelRequire("4lkOX");

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $3sQ5x.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});


parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4R6GH.fg)('log-hotkey-analytics')) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");
var $liZ21 = parcelRequire("liZ21");
var $620fp = parcelRequire("620fp");

var $2Eqc8 = parcelRequire("2Eqc8");

var $gg2il = parcelRequire("gg2il");
var $gZkTp = parcelRequire("gZkTp");

var $5KCCi = parcelRequire("5KCCi");

var $hCCtP = parcelRequire("hCCtP");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $gZkTp.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gg2il.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gg2il.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $gZkTp.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    const IconButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkIconButton) : (0, $620fp.default);
    const ButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkButton) : (0, $liZ21.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gg2il.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gg2il.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("gg2il", function(module, exports) {

$parcel$export(module.exports, "Show", () => $59aef86717cff2da$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $2s57o = parcelRequire("2s57o");

var $5PAUh = parcelRequire("5PAUh");
function $59aef86717cff2da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $59aef86717cff2da$var$showAboveQueries = (0, $5PAUh.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $59aef86717cff2da$var$showBelowQueries = (0, $5PAUh.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $59aef86717cff2da$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $59aef86717cff2da$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $59aef86717cff2da$var$defaultHiddenStyles,
            above && $59aef86717cff2da$var$showAboveQueries[above],
            below && $59aef86717cff2da$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("5PAUh", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $afacb554ac9e0a7f$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $afacb554ac9e0a7f$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $g1DCj = parcelRequire("g1DCj");

var $kU1q1 = parcelRequire("kU1q1");
const $afacb554ac9e0a7f$export$918f8818cfbbeb2c = (input)=>{
    return (0, $g1DCj.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $kU1q1.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $afacb554ac9e0a7f$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $g1DCj.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $kU1q1.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("g1DCj", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $0fcd7daf0a562012$export$2d293d9871c38e91);
const $0fcd7daf0a562012$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $0fcd7daf0a562012$export$2d293d9871c38e91 = Object.keys($0fcd7daf0a562012$export$e5ee4fe8b989fd09);
const $0fcd7daf0a562012$export$b7ed752a57b4177b = $0fcd7daf0a562012$export$2d293d9871c38e91[0];

});



parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");
var $liZ21 = parcelRequire("liZ21");
var $620fp = parcelRequire("620fp");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");
const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        xcss: $34060b1367424582$var$overrideStyles
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liZ21.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $620fp.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $2s57o.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});

});
parcelRegister("lmBAt", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $e55c8e35955d09b8$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $e55c8e35955d09b8$export$4fa2eaefe7d59f41);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");
const $e55c8e35955d09b8$export$a505f57c5130832f = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $e55c8e35955d09b8$export$4fa2eaefe7d59f41 = (variant)=>{
    // being part of M1 experiment is a prerequisite to be in M2
    if (!$e55c8e35955d09b8$export$a505f57c5130832f()) return false;
    if (variant === 'blurry-background') return (0, $6s1PB.expValEquals)('jira_theming_milestone_2', 'variant', 'blurry-background', 'control');
    if (variant === 'dominant-color') return (0, $6s1PB.expValEquals)('jira_theming_milestone_2', 'variant', 'dominant-color', 'control');
    // if we're here, variant doesn't matter anymore, we just show the experiment
    return (0, $6s1PB.expVal)('jira_theming_milestone_2', 'variant', 'control') !== 'control';
};

});


const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    },
    fullScreenShortcut: {
        "id": "platform.fullscreen-button.full-screen-shortcut",
        "defaultMessage": "Z"
    }
});

});




parcelRegister("2yK1M", function(module, exports) {

$parcel$export(module.exports, "AutomationButton", () => $d60cfa0788e5dce0$export$bf7bacbbcbf7d755);

var $5uXOq = parcelRequire("5uXOq");

var $8xUwj = parcelRequire("8xUwj");

var $5KCCi = parcelRequire("5KCCi");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $22OQR = parcelRequire("22OQR");

var $47gW9 = parcelRequire("47gW9");

var $dCm1o = parcelRequire("dCm1o");

var $j4hty = parcelRequire("j4hty");

var $34BMx = parcelRequire("34BMx");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $6m2h7 = parcelRequire("6m2h7");
const $d60cfa0788e5dce0$export$bf7bacbbcbf7d755 = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const projectIdOrKey = (0, $j4hty.useProjectIdOrKey)() ?? '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $34BMx.automationMenuContentEntrypoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const handleClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: handleClose
        }), [
        handleClose
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "horizontal-nav-header-automation",
            packageName: "@atlassian/jira-horizontal-nav-header",
            runtimeProps: runtimeProps
        }), [
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage((0, $6m2h7.default).automationButton),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'automationBolt',
                    action: 'opened'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
                setIsOpen(!isOpen);
            },
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            isSelected: isOpen,
            "data-vc": "automation-menu-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xUwj))), {
                label: formatMessage((0, $6m2h7.default).automationButton),
                color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor',
                spacing: "spacious"
            })
        })), [
        buttonTrigger,
        createAnalyticsEvent,
        formatMessage,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        messageId: "horizontal-nav.ui.content.header.extra-components-far.automation-button.popup",
        messageType: "transactional",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $4R6GH.fg)('ux-2931-a11y-automation-fix')
    });
};

});
parcelRegister("8xUwj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $638d3f8186876248$var$_react = $638d3f8186876248$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $638d3f8186876248$var$_baseNew = $638d3f8186876248$var$_interopRequireDefault((parcelRequire("enEmH")));
function $638d3f8186876248$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $638d3f8186876248$var$AutomationIcon = (props)=>/*#__PURE__*/ $638d3f8186876248$var$_react.default.createElement($638d3f8186876248$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$638d3f8186876248$var$AutomationIcon.displayName = 'AutomationIcon';
var $638d3f8186876248$var$_default = module.exports.default = $638d3f8186876248$var$AutomationIcon;

});

parcelRegister("j4hty", function(module, exports) {

$parcel$export(module.exports, "useProjectIdOrKey", () => $b3dce18eb6886925$export$12b007aa97244648);
$parcel$export(module.exports, "getConnection", () => $b3dce18eb6886925$export$26b2f38d0fc342a3);
$parcel$export(module.exports, "getStoreEdges", () => $b3dce18eb6886925$export$137f3eb02a91737e);
$parcel$export(module.exports, "getAnalyticsTabOrder", () => $b3dce18eb6886925$export$58da6593ae071994);

var $erN97 = parcelRequire("erN97");

var $lODMY = parcelRequire("lODMY");

var $1nb22 = parcelRequire("1nb22");

const $b3dce18eb6886925$export$12b007aa97244648 = (0, $lODMY.createRouterSelector)((state)=>(0, $1nb22.getProjectIdOrKey)(state.match, state.query));
const $b3dce18eb6886925$export$26b2f38d0fc342a3 = (store, containerNavigationId)=>{
    const dataId = (0, $erN97.default)({
        id: containerNavigationId
    }, 'JiraContainerNavigation');
    return dataId && store.get(dataId)?.getLinkedRecord('navigationItems', {
        first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
    });
};
const $b3dce18eb6886925$export$137f3eb02a91737e = (store, containerNavigationId)=>{
    const connection = $b3dce18eb6886925$export$26b2f38d0fc342a3(store, containerNavigationId);
    if (!connection) return undefined;
    return connection.getLinkedRecords('edges');
};
const $b3dce18eb6886925$export$58da6593ae071994 = (store, containerNavigationId)=>{
    const edges = $b3dce18eb6886925$export$137f3eb02a91737e(store, containerNavigationId);
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.getLinkedRecord('node');
        const tabId = node?.getValue('appId');
        return {
            itemType: String(node?.getValue('typeKey')).toLowerCase(),
            itemId: tabId ? String(tabId) : undefined,
            // relay will have already updated the changed item, exclude the new default to restore the original values
            defaultTab: Boolean(node?.getValue('isDefault'))
        };
    });
};

});
const $f764d292f97c6de7$export$4653cda61a4943d6 = 75;


parcelRegister("34BMx", function(module, exports) {

$parcel$export(module.exports, "automationMenuContentEntrypoint", () => $580b12aeb8052638$export$4606319c52466ef3);

var $a2DYS = parcelRequire("a2DYS");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $580b12aeb8052638$export$4606319c52466ef3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jQHGT")).then((module)=>module.AutomationPopupMenuContent), {
        moduleId: "21f1ab04",
        moduleName: "AutomationPopupMenuContent"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>{
        return {
            queries: {
                mainQuery: {
                    parameters: $a2DYS.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("a2DYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62eaa5f94455d00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3db9d4bc8d19d19d9cfe37c02c44f0d6>>
 * @relayHash f760e3b2d740a1f6e9c4d2cb3cc89946
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc
const $b62eaa5f94455d00$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc",
        "metadata": {},
        "name": "AutomationPopupMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b62eaa5f94455d00$export$2e2bcd8739ae039 = $b62eaa5f94455d00$var$node;

});

parcelRegister("jQHGT", function(module, exports) {

let $e734c3c009708602$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e734c3c009708602$var$load("h2MrD"),
    $e734c3c009708602$var$load("bYT2S"),
    $e734c3c009708602$var$load("hPzOn"),
    $e734c3c009708602$var$load("cM9em"),
    $e734c3c009708602$var$load("fr9NE"),
    $e734c3c009708602$var$load("1IWsG")
]).then(()=>parcelRequire('97LNn'));

});


parcelRegister("6m2h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae77624dfe3b540$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ae77624dfe3b540$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationButton: {
        "id": "horizontal-nav-header.extra-components-far.automation-button.automation-button",
        "defaultMessage": "Automation"
    }
});

});



parcelRegister("hjXMc", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavProjectBreadcrumbs", () => $b0980bff75b13480$export$da30c3ec9be0517b);

var $kyIvz = parcelRequire("kyIvz");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gpo4s = parcelRequire("gpo4s");
var $8LGam = parcelRequire("8LGam");

var $koVbs = parcelRequire("koVbs");

var $4iSVn = parcelRequire("4iSVn");
const $b0980bff75b13480$var$createProjectUrl = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $b0980bff75b13480$export$da30c3ec9be0517b = ({ projectFragment: projectFragment, shouldShowProjectName: shouldShowProjectName = false })=>{
    const project = (0, $8Uumt.useFragment)((0, $kyIvz.default), projectFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1tke1tcg _nwukvy9e _1o8h13fh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LGam.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
        href: "/jira/projects",
        text: formatMessage((0, $4iSVn.default).projectsTitle)
    }), shouldShowProjectName && project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
        href: $b0980bff75b13480$var$createProjectUrl(project?.key),
        text: project?.name
    })));
};
const $b0980bff75b13480$var$breadcrumbStyles = null;

});
parcelRegister("kyIvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc32ea129d13e4b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d8c448f51169523f40ef830f3470245>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc32ea129d13e4b0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraProject"
};
$fc32ea129d13e4b0$var$node.hash = "ed2f4bc001a364f753ffebfa5a1fa48e";
var $fc32ea129d13e4b0$export$2e2bcd8739ae039 = $fc32ea129d13e4b0$var$node;

});

parcelRegister("gpo4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $697de2828561ef20$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5KCCi = parcelRequire("5KCCi");

var $8Fpav = parcelRequire("8Fpav");

var $kSNMF = parcelRequire("kSNMF");
const $697de2828561ef20$var$itemWrapperStyles = null;
const $697de2828561ef20$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $697de2828561ef20$var$ICON_WIDTH_ESTIMATE = 24;
const $697de2828561ef20$var$staticItemStyles = null;
const $697de2828561ef20$var$staticItemWithTruncationStyles = null;
const $697de2828561ef20$var$staticItemWithoutTruncationStyles = null;
const $697de2828561ef20$var$BreadcrumbsItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $697de2828561ef20$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $697de2828561ef20$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $kSNMF.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$697de2828561ef20$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Fpav.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? dynamicItemStyles : undefined,
        className: (0, $bwpsq.default)([
            "_1rjc1tvq _k48p1hhk _vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$697de2828561ef20$export$2e2bcd8739ae039 = $697de2828561ef20$var$BreadcrumbsItem;

});
parcelRegister("8Fpav", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75f791f622b08ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $cNW3X = parcelRequire("cNW3X");

var $bKnKN = parcelRequire("bKnKN");
const $f75f791f622b08ac$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f75f791f622b08ac$var$noop = (0, $bKnKN.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $f75f791f622b08ac$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $f75f791f622b08ac$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f75f791f622b08ac$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $f75f791f622b08ac$export$2e2bcd8739ae039 = $f75f791f622b08ac$var$Step;

});

parcelRegister("kSNMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2acfd7bafb31a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
function $2a2acfd7bafb31a5$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $5uXOq.useState)((0, $fHpHg.fg)('platform_fix_unnessesary_re-renders_in_breadcrumbs') ? Boolean(shouldCheckWidth) : true);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $5uXOq.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("8LGam", function(module, exports) {

$parcel$export(module.exports, "default", () => $981af12032308ae8$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $cD7p8 = parcelRequire("cD7p8");

var $bKnKN = parcelRequire("bKnKN");

var $6PY2d = parcelRequire("6PY2d");

var $39LvI = parcelRequire("39LvI");
const $981af12032308ae8$var$defaultMaxItems = 8;
const $981af12032308ae8$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $981af12032308ae8$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $981af12032308ae8$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children;
const $981af12032308ae8$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $981af12032308ae8$var$noop = (0, $bKnKN.default);
const $981af12032308ae8$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $981af12032308ae8$var$breadcrumbStyles = null;
const $981af12032308ae8$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $981af12032308ae8$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $981af12032308ae8$var$noop, analyticsContext: analyticsContext, label: label = $981af12032308ae8$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $981af12032308ae8$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $981af12032308ae8$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($981af12032308ae8$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $39LvI.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$981af12032308ae8$var$analyticsAttributes
    });
    const childrenArray = $981af12032308ae8$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6PY2d.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: (0, $cD7p8.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $981af12032308ae8$var$Breadcrumbs = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($981af12032308ae8$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $981af12032308ae8$export$2e2bcd8739ae039 = $981af12032308ae8$var$Breadcrumbs;

});
parcelRegister("6PY2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23df4b96913494f$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $bKnKN = parcelRequire("bKnKN");
const $f23df4b96913494f$var$noop = (0, $bKnKN.default);
const $f23df4b96913494f$var$itemWrapperStyles = null;
const $f23df4b96913494f$var$staticItemStyles = null;
const $f23df4b96913494f$var$EllipsisItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick = $f23df4b96913494f$var$noop, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $bwpsq.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f23df4b96913494f$export$2e2bcd8739ae039 = $f23df4b96913494f$var$EllipsisItem;

});

parcelRegister("39LvI", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $bac20d79b2a0e586$export$e9c4922b2ecf808a);

var $5uXOq = parcelRequire("5uXOq");

var $jOvxk = parcelRequire("jOvxk");
function $bac20d79b2a0e586$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $jOvxk.default)(isExpanded);
    (0, $5uXOq.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("4iSVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0d02585d9d2048$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2f0d02585d9d2048$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsTitle: {
        "id": "horizontal-nav-header.breadcrumbs.project",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("2qjHu", function(module, exports) {

$parcel$export(module.exports, "NavigationTeamButton", () => $6eec8805144787da$export$df0da44d232d7c73);

var $1qITH = parcelRequire("1qITH");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yAxM = parcelRequire("5yAxM");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $14XJw = parcelRequire("14XJw");

var $4R6GH = parcelRequire("4R6GH");
const $6eec8805144787da$export$df0da44d232d7c73 = ({ scope: scope, projectFragment: projectFragment })=>{
    const project = (0, $8Uumt.useFragment)((0, $1qITH.default), projectFragment);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            scope: scope
        }), [
        scope
    ]);
    let TeamButtonComponent = (0, $5yAxM.TeamButtonComponent);
    if ((0, $4R6GH.fg)('team-bi-directional-container-connection-gate')) TeamButtonComponent = $6eec8805144787da$var$TeamButtonComponentWithOrgId;
    if (project?.teamsConnected?.totalCount == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-horizontal-nav-header-team-button",
        packageName: "jira-horizontal-nav",
        fallback: "unmount",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "horizontal-nav-header",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TeamButtonComponent, {
        numberOfTeams: project.teamsConnected.totalCount,
        containerId: project.id,
        Wrapper: $6eec8805144787da$var$CustomWrapper
    })));
};
const $6eec8805144787da$var$TeamButtonComponentWithOrgId = (props)=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yAxM.TeamButtonComponent), {
        ...props,
        orgId: orgId
    });
};
const $6eec8805144787da$var$CustomWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_fsjd4zrn _nwukvy9e _2hwx12x7"
        ])
    }, children);
const $6eec8805144787da$var$wrapperStyle = null;

});
parcelRegister("1qITH", function(module, exports) {

$parcel$export(module.exports, "default", () => $55af27551e9270fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be767f6a8976fb817217e913627de831>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55af27551e9270fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationTeamButton_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
            "kind": "LinkedField",
            "name": "teamsConnected",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$55af27551e9270fb$var$node.hash = "019729bc9738fb0fb680ee6b8a22b084";
var $55af27551e9270fb$export$2e2bcd8739ae039 = $55af27551e9270fb$var$node;

});

parcelRegister("5yAxM", function(module, exports) {

$parcel$export(module.exports, "TeamButtonComponent", () => $3ffa31fa0c3b4786$export$e396067aa8e1cdf9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3wIoS = parcelRequire("3wIoS");

var $grJYf = parcelRequire("grJYf");

var $lNSKD = parcelRequire("lNSKD");

var $js2Ve = parcelRequire("js2Ve");

var $ixjYE = parcelRequire("ixjYE");

var $c80Do = parcelRequire("c80Do");

var $4uBOd = parcelRequire("4uBOd");

var $2FJua = parcelRequire("2FJua");

var $9HhdG = parcelRequire("9HhdG");

var $34Zbb = parcelRequire("34Zbb");

var $9Knzg = parcelRequire("9Knzg");
const $3ffa31fa0c3b4786$export$e396067aa8e1cdf9 = ({ numberOfTeams: numberOfTeams, containerId: containerId, orgId: orgId, Wrapper: Wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment })=>{
    const { fireEvent: fireEvent } = (0, $js2Ve.usePeopleTeamAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        const result = analyticsEvent?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
        fireEvent('ui.teamButton.clicked', {
            teamsCount: numberOfTeams ?? 0,
            scope: result?.attributes?.scope
        });
    }, [
        fireEvent,
        numberOfTeams
    ]);
    if (numberOfTeams === undefined) return null;
    if (numberOfTeams === 0) {
        const isExperimentEnabled = (0, $4uBOd.isTeamBiDirectionalEnabled)(true);
        const siteId = containerId && (0, $c80Do.getSiteId)(containerId);
        if (isExperimentEnabled && siteId && orgId) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3wIoS.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $grJYf.ModalTrigger), {
                entryPoint: (0, $2FJua.asyncAddTeamEntryPoint),
                entryPointProps: {
                    onTeamAdd: ()=>{
                        // TODO: Handle team addition via the createTeamConnectedToContainer mutation
                        return;
                    },
                    siteId: siteId,
                    orgId: orgId
                },
                entryPointParams: {
                    containerId: containerId
                },
                modalProps: {
                    width: 'small'
                },
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Knzg.TeamButtonTrigger), {
                            triggerProps: {
                                ref: ref
                            },
                            numberOfTeams: numberOfTeams,
                            onClick: onClick
                        })
                    })
            })
        });
        return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lNSKD.PopupTrigger), {
        entryPoint: (0, $9HhdG.asyncTeamSelectorEntryPoint),
        entryPointParams: {
            containerId: containerId
        },
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Knzg.TeamButtonTrigger), {
                    triggerProps: triggerProps,
                    numberOfTeams: numberOfTeams,
                    onClick: onClick
                })
            }),
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $34Zbb.default), {}),
        placement: "bottom-start",
        strategy: "absolute",
        popupComponent: (0, $ixjYE.default)
    });
};

});
parcelRegister("js2Ve", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $86c34708c01ec26b$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $86c34708c01ec26b$export$5792e6ebc464482e);

var $5uXOq = parcelRequire("5uXOq");

var $lbMXQ = parcelRequire("lbMXQ");

var $6j2T3 = parcelRequire("6j2T3");

var $1iXG7 = parcelRequire("1iXG7");

var $i7KZ5 = parcelRequire("i7KZ5");
const $86c34708c01ec26b$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $lbMXQ.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $1iXG7.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $5uXOq.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $86c34708c01ec26b$export$b72f2eb2a11f7b8 = ()=>(0, $i7KZ5.useAnalyticsEventsWithTags)();
const $86c34708c01ec26b$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $86c34708c01ec26b$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $5uXOq.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $5uXOq.useMemo)(()=>(0, $6j2T3.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("lbMXQ", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $1f37af346f421238$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $1f37af346f421238$export$831917a198e22e70);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $1f37af346f421238$var$initialState = {
    eventAttributes: {}
};
const $1f37af346f421238$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $1f37af346f421238$var$AnalyticsSubcontextStore = (0, $iXqE5.createStore)({
    initialState: $1f37af346f421238$var$initialState,
    actions: $1f37af346f421238$var$actions
});
const $1f37af346f421238$export$86448e866930ba8d = (0, $3sQ5x.createHook)($1f37af346f421238$var$AnalyticsSubcontextStore);
const $1f37af346f421238$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $1f37af346f421238$export$86448e866930ba8d()[1];
    (0, $5uXOq.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("6j2T3", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $360bf8bfa40c92c9$export$c0c885a04612b38d);

var $cBeZP = parcelRequire("cBeZP");

var $jNZqv = parcelRequire("jNZqv");

var $hnty1 = parcelRequire("hnty1");
function $360bf8bfa40c92c9$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $jNZqv.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $hnty1.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $hnty1.computePerformanceAttributes)(event);
            const errorAttributes = (0, $hnty1.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("jNZqv", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $c41144d779250526$export$9e9a48cf2c297bd1);

var $bFNgM = parcelRequire("bFNgM");

var $d7dku = parcelRequire("d7dku");
class $c41144d779250526$export$9e9a48cf2c297bd1 extends (0, $bFNgM.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options), // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $d7dku.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $d7dku.isErrorStatusCode)((0, $d7dku.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("d7dku", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $f9654bd48f9e2162$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $f9654bd48f9e2162$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $f9654bd48f9e2162$export$9677d7c364ada66c);
var $f9654bd48f9e2162$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $f9654bd48f9e2162$export$cde1786a482f9a1c(error) {
    return $f9654bd48f9e2162$export$9677d7c364ada66c(401, error) || $f9654bd48f9e2162$export$9677d7c364ada66c(403, error);
}
function $f9654bd48f9e2162$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("hnty1", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $62ce1cca8e4440e5$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $62ce1cca8e4440e5$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $62ce1cca8e4440e5$export$b978343735080139);

var $8YP6t = parcelRequire("8YP6t");
function $62ce1cca8e4440e5$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $62ce1cca8e4440e5$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($62ce1cca8e4440e5$var$isFailEvent(event)) attributes.failError = event.error;
    if ($62ce1cca8e4440e5$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $62ce1cca8e4440e5$export$b978343735080139(event) {
    if ($62ce1cca8e4440e5$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $62ce1cca8e4440e5$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $62ce1cca8e4440e5$var$isStopEvent(e) {
    return (0, $8YP6t.isStop)(e);
}
function $62ce1cca8e4440e5$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $62ce1cca8e4440e5$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $62ce1cca8e4440e5$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("8YP6t", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $06d5a4008844e7f5$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $06d5a4008844e7f5$export$57069f5b2ecc9128);
const $06d5a4008844e7f5$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $06d5a4008844e7f5$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("1iXG7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $846adb04960e5acf$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c3d283871d950ad96ce62ded8c21524b>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $6uOvM = parcelRequire("6uOvM");

var $aUhvd = parcelRequire("aUhvd");
const $846adb04960e5acf$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $aUhvd.default)(...params));
        event.fire((0, $6uOvM.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("6uOvM", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $b6acdfd48604f39c$export$3f072f06b90c3985);

var $c9l08 = parcelRequire("c9l08");
const $b6acdfd48604f39c$export$3f072f06b90c3985 = (0, $c9l08.FabricChannel).peopleTeams;

});

parcelRegister("aUhvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $017eef91f510c6d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f6bdf2649443a00944d1014ec7e17d50>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $017eef91f510c6d9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $017eef91f510c6d9$export$2e2bcd8739ae039 = $017eef91f510c6d9$var$createEventPayload;

});


parcelRegister("i7KZ5", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $8e20d334dc78b253$export$e8e0cef07f76dd91);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $6uOvM = parcelRequire("6uOvM");

var $aUhvd = parcelRequire("aUhvd");
const $8e20d334dc78b253$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireEventWithTags = (0, $5uXOq.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $aUhvd.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $6uOvM.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("ixjYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d351e9519476348e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $d351e9519476348e$var$popupStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.background.neutral.subtle'
});
const $d351e9519476348e$var$PopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'data-testid': testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        ...props,
        ref: ref,
        xcss: $d351e9519476348e$var$popupStyles,
        testId: testId
    }));
var $d351e9519476348e$export$2e2bcd8739ae039 = $d351e9519476348e$var$PopupComponent;

});

parcelRegister("c80Do", function(module, exports) {

$parcel$export(module.exports, "getTeamProfileUrl", () => $b1f109dd2d995457$export$782629dc0d11ee5c);
$parcel$export(module.exports, "getSiteId", () => $b1f109dd2d995457$export$3ae2d1e732b25194);

var $1Jl81 = parcelRequire("1Jl81");
var $f8qIA = parcelRequire("f8qIA");
var $6Y2GO = parcelRequire("6Y2GO");
var $j5YhT = parcelRequire("j5YhT");

var $WUBOW = parcelRequire("WUBOW");
const $b1f109dd2d995457$export$e8eac31981efe1fb = (teamAri)=>{
    let teamId;
    const isIdentityTeamsAri = (0, $6Y2GO.IdentityTeamAri).check(teamAri);
    if (isIdentityTeamsAri) {
        const identityTeamId = (0, $6Y2GO.IdentityTeamAri).parse(teamAri).teamId;
        if (identityTeamId !== 'unidentified') teamId = identityTeamId;
        else (0, $WUBOW.logErrorMessage)('Team ID has value "unidentified" in getTeamId', {
            teamAri: teamAri
        });
    } else (0, $WUBOW.logErrorMessage)('Cannot parse IdentityTeamARI in getTeamId', {
        teamAri: teamAri
    });
    return teamId;
};
const $b1f109dd2d995457$export$782629dc0d11ee5c = (containerAri, teamAri)=>{
    let teamProfileUrl;
    const productPath = (0, $f8qIA.ConfluenceSpaceAri).check(containerAri) ? 'wiki' : (0, $j5YhT.JiraProjectAri).check(containerAri) ? 'jira' : undefined;
    let teamId;
    teamId = $b1f109dd2d995457$export$e8eac31981efe1fb(teamAri);
    if (productPath && teamId) teamProfileUrl = `${window.location.origin}/${productPath}/people/team/${teamId}`;
    else (0, $WUBOW.logErrorMessage)('Cannot create teamProfileUrl in getTeamProfileUrl', {
        containerAri: containerAri,
        teamAri: teamAri
    });
    return teamProfileUrl;
};
const $b1f109dd2d995457$export$3ae2d1e732b25194 = (containerAri)=>{
    const siteId = (0, $1Jl81.AnyAri).check(containerAri) && (0, $1Jl81.AnyAri).parse(containerAri).cloudId;
    if (!siteId) {
        (0, $WUBOW.logErrorMessage)('Cannot parse containerAri in getSiteId', {
            containerAri: containerAri
        });
        return;
    }
    return siteId;
};

});
parcelRegister("f8qIA", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAri", () => $b04c540d16412b1a$export$4e1bd9257e1b7213);

var $5OaBv = parcelRequire("5OaBv");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/confluence/space/manifest.ts
var $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5OaBv.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $5OaBv.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $b04c540d16412b1a$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $b04c540d16412b1a$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("5OaBv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $43a9d8fb9c1ae9fc$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $43a9d8fb9c1ae9fc$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $43a9d8fb9c1ae9fc$export$204c4c730af505ce = "confluence", $43a9d8fb9c1ae9fc$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("6Y2GO", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAri", () => $512a6ec26b7551b3$export$33bbb2d79e520118);

var $b24Fz = parcelRequire("b24Fz");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/identity/team/manifest.ts
var $512a6ec26b7551b3$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $b24Fz.IdentityTeamAriResourceOwner),
    resourceType: (0, $b24Fz.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $512a6ec26b7551b3$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._teamId = opts.resourceIdSegmentValues.teamId;
    }
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $512a6ec26b7551b3$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $512a6ec26b7551b3$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $512a6ec26b7551b3$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $512a6ec26b7551b3$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $512a6ec26b7551b3$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $512a6ec26b7551b3$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
};

});
parcelRegister("b24Fz", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAriResourceOwner", () => $808380e2662a0eb8$export$49beddf48ffb3f35);
$parcel$export(module.exports, "IdentityTeamAriResourceType", () => $808380e2662a0eb8$export$b2079a2a841afe32);
// src/identity/team/types.ts
var $808380e2662a0eb8$export$49beddf48ffb3f35 = "identity", $808380e2662a0eb8$export$b2079a2a841afe32 = "team";

});


parcelRegister("WUBOW", function(module, exports) {

$parcel$export(module.exports, "logException", () => $275a7284ad82cfc0$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $275a7284ad82cfc0$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $275a7284ad82cfc0$export$386587bcf05ee8ea);

var $jP0Fy = parcelRequire("jP0Fy");
const $275a7284ad82cfc0$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $275a7284ad82cfc0$export$f86b2a1a2ce291b3 = (0, $jP0Fy.logExceptionWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$ece28f5cfa04608 = (0, $jP0Fy.logErrorMessageWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$386587bcf05ee8ea = (0, $jP0Fy.logInfoMessageWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$9edc7d6f1c33ddc = (0, $jP0Fy.createErrorHandlerWithPackageContext)($275a7284ad82cfc0$var$packageContext);

});


parcelRegister("4uBOd", function(module, exports) {

$parcel$export(module.exports, "isTeamBiDirectionalEnabled", () => $16549985d0c1ff7f$export$444827debf3aeb22);

var $96Irh = parcelRequire("96Irh");
const $16549985d0c1ff7f$export$444827debf3aeb22 = (fireExperimentExposure = false)=>{
    if ((0, $96Irh.default).initializeCompleted()) return (0, $96Irh.default).getExperimentValue('team-bi-directional-container-connection', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
    return false;
};

});

parcelRegister("2FJua", function(module, exports) {

$parcel$export(module.exports, "asyncAddTeamEntryPoint", () => $e569abe4bafdb775$export$68c99cb18e80bb65);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e569abe4bafdb775$export$68c99cb18e80bb65 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("bKigd")), {
        moduleId: "4d90cf55",
        moduleId: 'add-team-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bKigd", function(module, exports) {

let $88d227bfe0f28ddb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $88d227bfe0f28ddb$var$load("hPzOn"),
    $88d227bfe0f28ddb$var$load("h2MrD"),
    $88d227bfe0f28ddb$var$load("bYT2S"),
    $88d227bfe0f28ddb$var$load("cM9em"),
    $88d227bfe0f28ddb$var$load("fr9NE"),
    $88d227bfe0f28ddb$var$load("hetAN")
]).then(()=>parcelRequire('aVwPc'));

});


parcelRegister("9HhdG", function(module, exports) {

$parcel$export(module.exports, "asyncTeamSelectorEntryPoint", () => $fae242521ab09610$export$735620207607ea13);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $9Ze5T = parcelRequire("9Ze5T");
const $fae242521ab09610$var$fetchPolicy = 'network-only';

const $fae242521ab09610$export$735620207607ea13 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("lwvg8")).then(({ AsyncTeamSelectorWithQuery: AsyncTeamSelectorWithQuery })=>AsyncTeamSelectorWithQuery), {
        moduleId: "be449799",
        moduleName: "AsyncTeamSelector",
        moduleId: 'team-selector-entrypoint'
    }),
    getPreloadProps: ({ containerId: containerId })=>({
            queries: {
                getTeamsForContainerQuery: {
                    parameters: $9Ze5T.default,
                    variables: {
                        containerId: containerId
                    },
                    options: {
                        fetchPolicy: $fae242521ab09610$var$fetchPolicy
                    }
                }
            },
            extraProps: {
                containerId: containerId
            }
        })
});

});
parcelRegister("9Ze5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b892fb019be298f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82ec437e484b15d727b5486f743d7169>>
 * @relayHash 47d8c4479b6470646c96359c3d1077bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 62b95e74138e5ee756fe30f2bd0d27931dde6b6947729ce9846fddf1f04eb02f
const $6b892fb019be298f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "consistentRead",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "containerId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamCard_team"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamItem_team"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallAvatarImageUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallHeaderImageUrl"
                                                        },
                                                        {
                                                            "concreteType": "TeamMemberConnectionV2",
                                                            "kind": "LinkedField",
                                                            "name": "members",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TeamMemberV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "member",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "62b95e74138e5ee756fe30f2bd0d27931dde6b6947729ce9846fddf1f04eb02f",
            "metadata": {},
            "name": "AsyncTeamSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6b892fb019be298f$var$node.hash = "779bc23aad7336e03c7b55355d6d87df";
var $6b892fb019be298f$export$2e2bcd8739ae039 = $6b892fb019be298f$var$node;

});

parcelRegister("lwvg8", function(module, exports) {

let $fab4d58c19b7c5a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fab4d58c19b7c5a8$var$load("h2MrD"),
    $fab4d58c19b7c5a8$var$load("bYT2S"),
    $fab4d58c19b7c5a8$var$load("cM9em"),
    $fab4d58c19b7c5a8$var$load("fr9NE"),
    $fab4d58c19b7c5a8$var$load("5Bo1h")
]).then(()=>parcelRequire('h1U1N'));

});


parcelRegister("34Zbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $884d61d00fc77651$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $4uBOd = parcelRequire("4uBOd");

var $2glWA = parcelRequire("2glWA");
const $884d61d00fc77651$var$loadingContainerStyles = (0, $2s57o.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    width: '320px',
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center'
});
const $884d61d00fc77651$var$styles = {
    headerSkeleton: "_ca0qv47k _n3tdu2gc _19bvpxbi _u5f3pxbi",
    badgeSkeleton: "_2rkoiti9 _4t3i7vkz _1bsb1tcg",
    titleSkeleton: "_2rko1q77 _4t3i7vkz _1bsb1lit"
};
const $884d61d00fc77651$var$TeamSelectorSkeleton = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $0yZbT.default), {
        testId: "testId-team-selector-skeleton",
        xcss: $884d61d00fc77651$var$loadingContainerStyles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
                xcss: $884d61d00fc77651$var$styles.headerSkeleton,
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $884d61d00fc77651$var$styles.titleSkeleton,
                        backgroundColor: "color.background.neutral"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $884d61d00fc77651$var$styles.badgeSkeleton,
                        backgroundColor: "color.background.neutral"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
                isList: true,
                children: [
                    ...Array(3)
                ].map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2glWA.ItemSkeleton), {}, index))
            }),
            (0, $4uBOd.isTeamBiDirectionalEnabled)() && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2glWA.ItemSkeleton), {
                    showControl: false
                })
            })
        ]
    });
};
var $884d61d00fc77651$export$2e2bcd8739ae039 = $884d61d00fc77651$var$TeamSelectorSkeleton;

});
parcelRegister("2glWA", function(module, exports) {

$parcel$export(module.exports, "ItemSkeleton", () => $e40724342fc6434f$export$84345645841732c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
const $e40724342fc6434f$var$styles = {
    containerWrapperSkeleton: "_4cvr1h6o _1p57utpp _syaz1fxt _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    containerIconSkeleton: "_2rkoiti9 _4t3i1tcg _1bsb1tcg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    labelSkeleton: "_2rko1q77 _1rjc1b66 _4t3irdoj _1bsb1osq",
    controlSkeleton: "_2rkogqwt _4t3i1crf _1bsb1crf"
};
const $e40724342fc6434f$export$84345645841732c3 = ({ showControl: showControl = true })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        space: "space.100",
        xcss: $e40724342fc6434f$var$styles.containerWrapperSkeleton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $e40724342fc6434f$var$styles.containerIconSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $e40724342fc6434f$var$styles.labelSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            showControl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $e40724342fc6434f$var$styles.controlSkeleton,
                backgroundColor: "color.background.neutral"
            })
        ]
    });
};

});


parcelRegister("9Knzg", function(module, exports) {

$parcel$export(module.exports, "TeamButtonTrigger", () => $83e62842a93e0fae$export$3fe916959ce1a733);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $3kZDu = parcelRequire("3kZDu");

var $g7g8o = parcelRequire("g7g8o");

var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $js2Ve = parcelRequire("js2Ve");

var $9oVsE = parcelRequire("9oVsE");
const $83e62842a93e0fae$var$buttonStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    display: 'flex',
    alignItems: 'center',
    height: '32px',
    width: '32px',
    justifyContent: 'center',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $83e62842a93e0fae$var$buttonStylesWithNumber = (0, $2s57o.xcss)({
    width: '56px'
});
const $83e62842a93e0fae$export$3fe916959ce1a733 = ({ triggerProps: triggerProps, numberOfTeams: numberOfTeams, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireEvent: fireEvent } = (0, $js2Ve.usePeopleTeamAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const result = createAnalyticsEvent({})?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
        fireEvent('ui.teamButton.viewed', {
            teamsCount: numberOfTeams,
            scope: result?.attributes?.scope
        });
    }, [
        createAnalyticsEvent,
        fireEvent,
        numberOfTeams
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gVM6m.default), {
        ...triggerProps,
        onClick: onClick,
        xcss: [
            $83e62842a93e0fae$var$buttonStyles,
            numberOfTeams !== 1 && $83e62842a93e0fae$var$buttonStylesWithNumber
        ],
        testId: "team-button-trigger",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3kZDu))), {
                color: "currentColor",
                label: formatMessage((0, $9oVsE.default).iconLabel)
            }),
            numberOfTeams > 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                as: "span",
                paddingInlineStart: "space.100",
                children: numberOfTeams
            }),
            numberOfTeams === 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                as: "span",
                paddingInlineStart: "space.050",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))), {
                    color: "currentColor",
                    label: formatMessage((0, $9oVsE.default).addTeamIconLabel)
                })
            })
        ]
    });
};

});
parcelRegister("g7g8o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73693506539a99d0ae3d26d395e92ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $030720451248870d$var$_react = $030720451248870d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $030720451248870d$var$_baseNew = $030720451248870d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $030720451248870d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $030720451248870d$var$AddIcon = (props)=>/*#__PURE__*/ $030720451248870d$var$_react.default.createElement($030720451248870d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$030720451248870d$var$AddIcon.displayName = 'AddIcon';
var $030720451248870d$var$_default = module.exports.default = $030720451248870d$var$AddIcon;

});

parcelRegister("9oVsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $20fbe4171bcfc5c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20fbe4171bcfc5c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    iconLabel: {
        id: 'team-button-trigger.icon.label',
        defaultMessage: 'Team button',
        description: 'Label for the team button icon'
    },
    addTeamIconLabel: {
        id: 'team-button-trigger.add-team-icon.label',
        defaultMessage: 'Add team',
        description: 'Label for the add team icon'
    }
});

});





parcelRegister("hzZnF", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $bc92ae250591be70$export$69277e177204bdfd);

var $d9qlz = parcelRequire("d9qlz");

var $hnzkw = parcelRequire("hnzkw");

var $gKnzp = parcelRequire("gKnzp");

var $7FRWc = parcelRequire("7FRWc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $g7crU = parcelRequire("g7crU");


var $9IFFl = parcelRequire("9IFFl");

var $ccuaM = parcelRequire("ccuaM");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $44kzF = parcelRequire("44kzF");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $eC0BO = parcelRequire("eC0BO");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $krB5y = parcelRequire("krB5y");

var $2IzXv = parcelRequire("2IzXv");

var $hjXMc = parcelRequire("hjXMc");

var $2qjHu = parcelRequire("2qjHu");

var $4DmRP = parcelRequire("4DmRP");
const $bc92ae250591be70$export$69277e177204bdfd = (props)=>{
    const { queryFragment: queryFragment, projectFragment: projectFragment } = props;
    const data = (0, $8Uumt.useFragment)((0, $7FRWc.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $gKnzp.default), projectFragment);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            navigationContainer: (0, $68cb678dc917978e$export$b83d0ee9325a2d0a)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc92ae250591be70$var$ProjectHeaderInner, {
        ...props,
        queryFragment: data,
        projectFragment: project
    }));
};
const $bc92ae250591be70$var$ProjectHeaderInner = ({ queryFragment: queryFragment, projectFragment: projectFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { updateProjectName: updateProjectName, validateProjectName: validateProjectName } = (0, $2IzXv.useRenameProject)();
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    const data = (0, $8Uumt.useFragment)((0, $hnzkw.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $d9qlz.default), projectFragment);
    const isBusinessProject = project.projectType === 'BUSINESS';
    const isSoftwareProject = project.projectType === 'SOFTWARE';
    const withInlineEdit = isBusinessProject;
    const isCorePremiumUserSeat = data.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM';
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const hasChangeTheme = canEditProjectConfig && (hasSoftwareTheming || isBusinessProject);
    const icon = (0, $5uXOq.useMemo)(()=>{
        const avatar = (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $bc92ae250591be70$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4DmRP.default), {
            projectRef: project
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4DmRP.default), {
            projectRef: project
        });
        if (withInlineEdit) return avatar;
        if (!project?.avatar?.large) return null;
        return (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIconSmallerSize), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-icon",
            "data-vc": "horizontal-nav-project-icon",
            src: project.avatar.large,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIcon), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-icon",
            "data-vc": "horizontal-nav-project-icon",
            src: project.avatar.large,
            alt: ""
        });
    }, [
        project,
        withInlineEdit
    ]);
    const handleProjectActionDropDownClick = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'projectActionsDropdown', {}), [
        createAnalyticsEvent
    ]);
    const onUpdateProjectName = (0, $5uXOq.useCallback)((name)=>updateProjectName(Number(project?.projectId), name), [
        project?.projectId,
        updateProjectName
    ]);
    let headerProps = {};
    if (withInlineEdit && project?.projectId) {
        const inlineEditProps = {
            withInlineEdit: true,
            onConfirm: onUpdateProjectName,
            onValidate: validateProjectName,
            id: Number(project.projectId)
        };
        headerProps = canEditProjectConfig ? inlineEditProps : {};
    }
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false);
    const extraComponentsClose = (0, $5uXOq.useMemo)(()=>{
        if (!project) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qjHu.NavigationTeamButton), {
            projectFragment: project,
            scope: "project"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-action-menu",
            key: "ProjectActions",
            projectKey: project.key,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            additionalMenuItems: hasChangeTheme && !!project.projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                projectId: Number(project.projectId),
                withAdaptiveColorTheme: isSoftwareProject && (0, $lmBAt.getIsSoftwareThemingEnabled)(),
                /*
       * Render the theme picker popup inside a portal, this ensures it appears above other
       * elements, even when nested deep inside a container.
       * This SHOULD NOT be changed as it will cause the popup to be
       * rendered inside the parent container, which will cause it to appear behind other elements.
       */ shouldRenderToParent: false
            }),
            withThemedTrigger: true,
            onClick: handleProjectActionDropDownClick,
            /*
       * Render the project action menu popup inside a portal, this ensures it appears above other
       * elements, even when nested deep inside a container.
       * This SHOULD NOT be changed as it will cause the popup to be
       * rendered inside the parent container, which will cause it to appear behind other elements.
       */ shouldRenderToParent: false
        }));
    }, [
        project,
        showTeamButton,
        isCorePremiumUserSeat,
        hasChangeTheme,
        isSoftwareProject,
        handleProjectActionDropDownClick
    ]);
    if (!project) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        title: project.name,
        ...headerProps,
        icon: icon,
        isLoading: project == null,
        extraComponentsClose: extraComponentsClose,
        testId: "horizontal-nav-header.ui.project-header.header",
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krB5y.ExtraComponentsFar), {
            projectFragment: project
        }),
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjXMc.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project
        })
    });
};
const $bc92ae250591be70$var$iconStyles = (0, $2s57o.xcss)({
    width: '20px',
    height: '20px',
    boxSizing: 'border-box'
});

});
parcelRegister("d9qlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b7ad977298e8b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f97863cc435b31a11fe6745855512d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31b7ad977298e8b4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectAvatar"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$31b7ad977298e8b4$var$node.hash = "470801e5fae5e2ecdc7e34a5f0a614a1";
var $31b7ad977298e8b4$export$2e2bcd8739ae039 = $31b7ad977298e8b4$var$node;

});

parcelRegister("hnzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afec814313b38ae0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d7b22ff370d9e9a7a741a37c508a145>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afec814313b38ae0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_query",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementLicensing",
                        "kind": "LinkedField",
                        "name": "jwmLicensing",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "currentUserSeatEdition"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$afec814313b38ae0$var$node.hash = "6b10db5d77a3ec3bb1e3665b0de46b2f";
var $afec814313b38ae0$export$2e2bcd8739ae039 = $afec814313b38ae0$var$node;

});

parcelRegister("gKnzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $42567f0c5be6bba1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718f44a9e92e1d7dd77b78909d0471cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42567f0c5be6bba1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_project"
        }
    ],
    "type": "JiraProject"
};
$42567f0c5be6bba1$var$node.hash = "78893912e046c1d6733f1058dcb592a0";
var $42567f0c5be6bba1$export$2e2bcd8739ae039 = $42567f0c5be6bba1$var$node;

});

parcelRegister("7FRWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1082e95b8a54cc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8a0e19e9b9d644207c1ba1389c2482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1082e95b8a54cc0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_query"
        }
    ],
    "type": "Query"
};
$f1082e95b8a54cc0$var$node.hash = "d1740bc312d925b4121b692ded4c84ed";
var $f1082e95b8a54cc0$export$2e2bcd8739ae039 = $f1082e95b8a54cc0$var$node;

});

parcelRegister("ccuaM", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $8b67ffb58d27733b$export$b71a0a4e7f29cfd6);

var $5uXOq = parcelRequire("5uXOq");

var $c8rIN = parcelRequire("c8rIN");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $22OQR = parcelRequire("22OQR");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $03DFc = parcelRequire("03DFc");

var $bMW22 = parcelRequire("bMW22");
const $8b67ffb58d27733b$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))), {
            label: formatMessage((0, $bMW22.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $bMW22.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $8b67ffb58d27733b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, themePicker: themePicker, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03DFc.EntryPointContent), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $3HwlS.getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent,
        ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
            themePicker: themePicker
        }
    });
};

});
parcelRegister("03DFc", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $507768618964e449$export$912f81dce8d58e46);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $2oEQb = parcelRequire("2oEQb");

var $7ju32 = parcelRequire("7ju32");

var $eSIes = parcelRequire("eSIes");
const $507768618964e449$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, themePicker: themePicker, projectName: projectName })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2oEQb.projectActionMenuEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $5uXOq.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                contentProps: contentProps,
                themePicker: themePicker
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSIes.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        themePicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("2oEQb", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $a5951ff1cd0da4db$export$30ec6de22da54fa0);

var $lvLIW = parcelRequire("lvLIW");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $a5951ff1cd0da4db$var$fetchPolicy = 'network-only';

const $a5951ff1cd0da4db$export$30ec6de22da54fa0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("ce2kj")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $lvLIW.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: $a5951ff1cd0da4db$var$fetchPolicy
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("lvLIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29594fd996b113$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d360e49d5eb693192c7fbc1eac496f85>>
 * @relayHash a9a48f3ed05422d23cacd580dcce751d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e
const $8f29594fd996b113$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29594fd996b113$export$2e2bcd8739ae039 = $8f29594fd996b113$var$node;

});

parcelRegister("ce2kj", function(module, exports) {

let $8e6898d627eed951$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8e6898d627eed951$var$load("cM9em"),
    $8e6898d627eed951$var$load("fr9NE"),
    $8e6898d627eed951$var$load("h2MrD"),
    $8e6898d627eed951$var$load("bYT2S"),
    $8e6898d627eed951$var$load("a0WjB")
]).then(()=>parcelRequire('aSeFh'));

});


parcelRegister("7ju32", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $12b2a0349669ab51$export$b286f91cddfedb5a);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $cDvOQ = parcelRequire("cDvOQ");

var $6jY6G = parcelRequire("6jY6G");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $1aCfv = parcelRequire("1aCfv");
const $12b2a0349669ab51$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const handleClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aCfv.MenuTriggerButton), {
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $3HwlS.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $3HwlS.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("cDvOQ", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $89d72d59f9676a7b$export$e07f550759260fd7);

var $5uXOq = parcelRequire("5uXOq");
const $89d72d59f9676a7b$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialState);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("1aCfv", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $697832058741b131$export$a24e6f6ddd974e33);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $4AeHp = parcelRequire("4AeHp");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $UPOcN = parcelRequire("UPOcN");
const $697832058741b131$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AeHp))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)"
            }),
        label: (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $UPOcN.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $UPOcN.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $UPOcN.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("UPOcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5484f6b90ae9d06c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5484f6b90ae9d06c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("eSIes", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $618f6270b8f60e9b$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");
var $eCE62 = parcelRequire("eCE62");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $4DrQd = parcelRequire("4DrQd");
const $618f6270b8f60e9b$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $618f6270b8f60e9b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $618f6270b8f60e9b$var$projectTileSkeleton
    }))));
const $618f6270b8f60e9b$var$wrapperStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $4DrQd.MENU_GROUP_MIN_WIDTH)}px`
});
const $618f6270b8f60e9b$var$projectTileSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});
parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $e2413e530566d4f6$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $e2413e530566d4f6$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $e2413e530566d4f6$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $dDsAl = parcelRequire("dDsAl");

var $6YfOV = parcelRequire("6YfOV");

var $7uikU = parcelRequire("7uikU");

var $5purl = parcelRequire("5purl");

var $gdqFV = parcelRequire("gdqFV");

var $2tGrM = parcelRequire("2tGrM");

var $3pK7p = parcelRequire("3pK7p");

var $dncoP = parcelRequire("dncoP");

var $15tSY = parcelRequire("15tSY");

var $hkaoh = parcelRequire("hkaoh");

var $7PkLr = parcelRequire("7PkLr");

var $aCAjf = parcelRequire("aCAjf");

var $fkyxu = parcelRequire("fkyxu");

var $3kZDu = parcelRequire("3kZDu");

var $l1s8i = parcelRequire("l1s8i");

var $bqwqE = parcelRequire("bqwqE");

var $ab1Yt = parcelRequire("ab1Yt");

var $g95pD = parcelRequire("g95pD");

var $jhS4y = parcelRequire("jhS4y");

var $6x874 = parcelRequire("6x874");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$c52c93cc28495ab0 = Object.values((0, $jhS4y.GLOBAL_APP_MENU_ID));
const $e2413e530566d4f6$export$de634ec0f98ab74b = $e2413e530566d4f6$export$c52c93cc28495ab0;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YfOV)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dncoP)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDsAl)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aCAjf)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7PkLr)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tGrM)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gdqFV)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pK7p)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, $6x874.default)
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7uikU)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3kZDu)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5purl)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fkyxu)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($15tSY)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hkaoh)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g95pD)))
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, $bqwqE.AssetsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, $ab1Yt.GoalsIcon)
    }
};
const $e2413e530566d4f6$export$5034ad0032cd499d = {
    message: (0, $ih7ba.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l1s8i)))
};
const $e2413e530566d4f6$export$b66ae8c18ec95bc6 = {
    message: (0, $ih7ba.default).forYou.defaultMessage
};
const $e2413e530566d4f6$export$da92a6698d96e3f2 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("6x874", function(module, exports) {

$parcel$export(module.exports, "default", () => $079d8146cc6d581f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hivz8 = parcelRequire("hivz8");

var $e7Klx = parcelRequire("e7Klx");

var $4R6GH = parcelRequire("4R6GH");
const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
    if ((0, $4R6GH.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hivz8))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e7Klx))), props);
};
var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    }
});

});

parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$var$OPERATIONS_MENU_ID
};

});




parcelRegister("bMW22", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5136b67e6c38f9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5136b67e6c38f9a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("44kzF", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $f5453100331219b3$export$75505f096a733fb9);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $j5YhT = parcelRequire("j5YhT");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $7VHMR = parcelRequire("7VHMR");

var $g8I5C = parcelRequire("g8I5C");

var $6jY6G = parcelRequire("6jY6G");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ky2ui = parcelRequire("ky2ui");

var $koeKL = parcelRequire("koeKL");

var $jpH5a = parcelRequire("jpH5a");

var $ca7Zi = parcelRequire("ca7Zi");

var $lwRIP = parcelRequire("lwRIP");

var $3LH0C = parcelRequire("3LH0C");

var $gHWtm = parcelRequire("gHWtm");

var $9yzIq = parcelRequire("9yzIq");
const $f5453100331219b3$var$SOURCE_NAME = 'projectThemePicker';
const $f5453100331219b3$var$messages = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $f5453100331219b3$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $f5453100331219b3$var$messages.errorFlagTitle,
    description: $f5453100331219b3$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker.popup-entrypoint-error-flag.error.open-theme-picker-error',
    messageType: 'transactional'
};
const $f5453100331219b3$export$75505f096a733fb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectId: projectId, withAdaptiveColorTheme: withAdaptiveColorTheme, shouldRenderToParent: shouldRenderToParent = true })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $gHWtm.backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $5uXOq.useState)(false);
    const toggleThemePicker = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ky2ui.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen,
            withAdaptiveColorTheme: withAdaptiveColorTheme
        }), [
        setIsThemePickerOpen,
        withAdaptiveColorTheme
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LH0C.ThemePickerButtonItem), {
            ...triggerProps,
            isSelected: isThemePickerOpen,
            testId: "project-theme-components.ui.theme-picker.trigger",
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker
        }), [
        buttonTrigger,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($f5453100331219b3$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca7Zi.ExperienceFailed), {
            experience: (0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yzIq.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $5uXOq.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: $f5453100331219b3$var$SOURCE_NAME,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        content: content,
        trigger: trigger,
        placement: "right-start",
        id: (0, $lwRIP.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker.popup.theme-picker",
        messageType: "transactional"
    })));
});

});
parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gWVyJ = parcelRequire("gWVyJ");
var $l2AH9 = parcelRequire("l2AH9");
var $iCvLW = parcelRequire("iCvLW");
var $56fJj = parcelRequire("56fJj");
var $by9S8 = parcelRequire("by9S8");
var $7Stls = parcelRequire("7Stls");
var $33D3Q = parcelRequire("33D3Q");
var $jreT6 = parcelRequire("jreT6");
var $3IHID = parcelRequire("3IHID");
var $7EYXE = parcelRequire("7EYXE");
var $3fzVB = parcelRequire("3fzVB");
var $02o6B = parcelRequire("02o6B");

var $3HwlS = parcelRequire("3HwlS");

var $geqKu = parcelRequire("geqKu");
var $7YDkZ = parcelRequire("7YDkZ");
var $gXjR2 = parcelRequire("gXjR2");
var $ehQHm = parcelRequire("ehQHm");
var $dkD6V = parcelRequire("dkD6V");
var $jN4ko = parcelRequire("jN4ko");
var $fZJPK = parcelRequire("fZJPK");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkD6V.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33D3Q.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YDkZ.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWVyJ.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZJPK.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EYXE.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCvLW.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by9S8.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fJj.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXjR2.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Stls.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2AH9.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geqKu.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IHID.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehQHm.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jreT6.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3fzVB.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $62b79b702763d93f$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $62b79b702763d93f$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $62b79b702763d93f$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $62b79b702763d93f$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $62b79b702763d93f$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $62b79b702763d93f$export$aeff86a16f13529);

});
// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;




parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $fsi33 = parcelRequire("fsi33");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $fsi33.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ky2ui", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $cb3deafbb4dbbb82$export$a3dbb521061a599a);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("5fQMX")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
$cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $3vs13 = parcelRequire("3vs13");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $3vs13.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $5f07ce956337ba8b$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $5f07ce956337ba8b$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $5f07ce956337ba8b$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $5f07ce956337ba8b$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $5f07ce956337ba8b$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$8ab0859f5b30b013,
    $5f07ce956337ba8b$export$d1f6d18c6698104c,
    $5f07ce956337ba8b$export$e6ee159eee7adc1c,
    $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
    $5f07ce956337ba8b$export$f14c8bffc35200d3,
    $5f07ce956337ba8b$export$36cc22c9997d92a,
    $5f07ce956337ba8b$export$d651cc94a46ff383,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];

});


// JWM Background Colour tour
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("5fQMX", function(module, exports) {

let $3d374d29dd0201c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d374d29dd0201c0$var$load("cM9em"),
    $3d374d29dd0201c0$var$load("fr9NE"),
    $3d374d29dd0201c0$var$load("ebypf")
]).then(()=>parcelRequire('8uIuW'));

});


parcelRegister("jpH5a", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $34fd6f1472f32723$export$9a8c95b97c1ee885);
const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("ca7Zi", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $99088cc1a7014505$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $99088cc1a7014505$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $99088cc1a7014505$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $99088cc1a7014505$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $99088cc1a7014505$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("lwRIP", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $9162f72ca6991e19$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $9162f72ca6991e19$export$8dde8522a4856b87);
const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("3LH0C", function(module, exports) {

$parcel$export(module.exports, "ThemePickerButtonItem", () => $bf1403620c7d37d2$export$27d1624818d3e0be);

var $5uXOq = parcelRequire("5uXOq");

var $cwX8H = parcelRequire("cwX8H");

var $IaDcR = parcelRequire("IaDcR");

var $7H980 = parcelRequire("7H980");

var $koVbs = parcelRequire("koVbs");

var $eCaG4 = parcelRequire("eCaG4");
const $bf1403620c7d37d2$export$27d1624818d3e0be = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IaDcR))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: testId,
        isSelected: isSelected,
        ref: ref,
        ...props
    }, formatMessage((0, $eCaG4.default).setProjectBackgroundMenuItem));
}));

});
parcelRegister("IaDcR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $084c5b57c86b975d$var$_react = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $084c5b57c86b975d$var$_paintBucket = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("hB9a3")));

var $084c5b57c86b975d$var$_backgroundColor = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("17EmJ")));
function $084c5b57c86b975d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $084c5b57c86b975d$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $084c5b57c86b975d$var$_react.default.createElement($084c5b57c86b975d$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $084c5b57c86b975d$var$_backgroundColor.default
    }, props));
$084c5b57c86b975d$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $084c5b57c86b975d$var$_default = module.exports.default = $084c5b57c86b975d$var$PaintBucketIcon;

});
parcelRegister("hB9a3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccfcff99e8186679$var$_react = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccfcff99e8186679$var$_baseNew = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ccfcff99e8186679$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccfcff99e8186679$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $ccfcff99e8186679$var$_react.default.createElement($ccfcff99e8186679$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$ccfcff99e8186679$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $ccfcff99e8186679$var$_default = module.exports.default = $ccfcff99e8186679$var$PaintBucketIcon;

});

parcelRegister("17EmJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d15c1aa5923f306$var$_react = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0d15c1aa5923f306$var$_paintBucket = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("hB9a3")));
function $0d15c1aa5923f306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d15c1aa5923f306$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $0d15c1aa5923f306$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $0d15c1aa5923f306$var$_paintBucket.default
    }));
$0d15c1aa5923f306$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $0d15c1aa5923f306$var$_default = module.exports.default = $0d15c1aa5923f306$var$EditorBackgroundColorIcon;

});


parcelRegister("eCaG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $375a1027f7dcdae1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $375a1027f7dcdae1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setProjectBackgroundMenuItem: {
        "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
        "defaultMessage": "Set project background"
    }
});

});


parcelRegister("gHWtm", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $52bb029027935944$export$e02fb03d7ff1aabe);

var $22q3R = parcelRequire("22q3R");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $4R6GH = parcelRequire("4R6GH");
const $52bb029027935944$var$fetchPolicy = 'network-only';

const $52bb029027935944$export$e02fb03d7ff1aabe = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cu49C")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "e1737386",
        moduleName: "PopupContent"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $22q3R.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50,
                isThemingRelayMigrationEnabled: (0, $4R6GH.fg)('jira_theming_relay_migration')
            },
            options: {
                fetchPolicy: $52bb029027935944$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("22q3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $201654d4ad1f249e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b46a02a37c9c9712faf3f1c3cdb2810>>
 * @relayHash 4b1253adfc4d15a018eec6dd37c2a1a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 567381a90f6d2527c3bad9e3134757d855ffc2d7a4fb51a9a98728011059d85e
const $201654d4ad1f249e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "567381a90f6d2527c3bad9e3134757d855ffc2d7a4fb51a9a98728011059d85e",
        "metadata": {},
        "name": "PopupContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $201654d4ad1f249e$export$2e2bcd8739ae039 = $201654d4ad1f249e$var$node;

});

parcelRegister("cu49C", function(module, exports) {

let $916b824a4bff0433$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $916b824a4bff0433$var$load("h2MrD"),
    $916b824a4bff0433$var$load("bYT2S"),
    $916b824a4bff0433$var$load("hPzOn"),
    $916b824a4bff0433$var$load("cM9em"),
    $916b824a4bff0433$var$load("fr9NE"),
    $916b824a4bff0433$var$load("7Pwl1")
]).then(()=>parcelRequire('97vnf'));

});


parcelRegister("9yzIq", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $828cc9a1e99f3131$export$c3dc17aa42c33254);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");
const $828cc9a1e99f3131$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $828cc9a1e99f3131$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "medium"
    }));
const $828cc9a1e99f3131$var$skeletonStyles = (0, $2s57o.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("a2e2Q", function(module, exports) {

$parcel$export(module.exports, "useSoftwareProjectTheming", () => $376b82e4729cc4d4$export$4c26676caf6bb553);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $86GR9 = parcelRequire("86GR9");
const $376b82e4729cc4d4$export$30f17de515f7ff59 = (routeName, projectType)=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
    const isSoftwareProject = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).includes(routeName) && !isSoftwareCalendarRoute : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).includes(routeName) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).includes(routeName) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).includes(routeName);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $376b82e4729cc4d4$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $376b82e4729cc4d4$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $376b82e4729cc4d4$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).includes(currentRoute) && !isSoftwareCalendarRoute : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).includes(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).includes(currentRoute) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).includes(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $376b82e4729cc4d4$var$useSoftwareProjectThemingNew = ()=>{
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const firstRouterState = (0, $5uXOq.useMemo)(()=>(0, $lODMY.getRouterState)(), []);
    const [softwareProjectThemingState, setSoftwareProjectThemingState] = (0, $5uXOq.useState)(()=>$376b82e4729cc4d4$export$30f17de515f7ff59(firstRouterState.route.name, projectData?.projectType));
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)(({ route: route })=>{
            setSoftwareProjectThemingState((prevState)=>{
                const nextState = $376b82e4729cc4d4$export$30f17de515f7ff59(route.name, projectData?.projectType);
                if (nextState.hasSoftwareTheming !== prevState.hasSoftwareTheming || nextState.isSoftwareFullTheming !== prevState.isSoftwareFullTheming || nextState.isSoftwareProject !== prevState.isSoftwareProject) return nextState;
                return prevState;
            });
        });
        return ()=>unsubscribe();
    }, [
        projectData?.projectType
    ]);
    return softwareProjectThemingState;
};
const $376b82e4729cc4d4$export$4c26676caf6bb553 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('reduce_navigation_rerenders_1'), $376b82e4729cc4d4$var$useSoftwareProjectThemingNew, $376b82e4729cc4d4$export$52b606e2ebcbaae2);

});
parcelRegister("86GR9", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $ef531902bffb6540$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $ef531902bffb6540$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $ef531902bffb6540$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $ef531902bffb6540$export$587ac1561f46cfdc);
const $ef531902bffb6540$export$671a416a5ddfe0ea = [
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
];
const $ef531902bffb6540$export$891915f6cf3ec6e7 = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
];
const $ef531902bffb6540$export$1c7e7f18d2f498fe = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog'
];
const $ef531902bffb6540$export$4edc7739f219df7c = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$891915f6cf3ec6e7
];
const $ef531902bffb6540$export$587ac1561f46cfdc = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$1c7e7f18d2f498fe
];

});


parcelRegister("2IzXv", function(module, exports) {

$parcel$export(module.exports, "useRenameProject", () => $7ed15a1d5fe6d0a8$export$b7c373d314ddf2d4);

var $dJaJK = parcelRequire("dJaJK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $cbTlr = parcelRequire("cbTlr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $9F7ed = parcelRequire("9F7ed");
const $7ed15a1d5fe6d0a8$export$b7c373d314ddf2d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dJaJK.default));
    const updateProjectName = (0, $5uXOq.useCallback)((projectId, name)=>{
        if (!projectId) return;
        const newName = name.trim();
        const nameUpdater = (store)=>{
            const ari = (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const relayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (!relayDataId) return;
            const project = store.get(relayDataId);
            if (project) project.setValue(newName, 'name');
        };
        commitMutation({
            variables: {
                cloudId: cloudId,
                projectIdOrKey: String(projectId),
                name: newName
            },
            optimisticUpdater: nameUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectName?.success) nameUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectName ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName updated');
                else if (error) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName update failed', {
                    error: error
                });
            }
        });
    }, [
        commitMutation,
        cloudId,
        createAnalyticsEvent
    ]);
    const validate = async (title, newValue)=>{
        try {
            const { errors: errors } = await (0, $cbTlr.get)('', newValue);
            if (errors.projectName) {
                // There's an error if the value is being updated to an existing project
                // name, but we can skip this if the value is the current project name
                if (newValue === title) return undefined;
                return errors.projectName;
            }
            return undefined;
        } catch  {
            return formatMessage((0, $9F7ed.default).updateProjectNameError);
        }
    };
    return {
        updateProjectName: updateProjectName,
        validateProjectName: validate
    };
};

});
parcelRegister("dJaJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aaf8f415dbd862d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32f9a62e16ee97abad9b6bce0f869388>>
 * @relayHash 8c9db70971a948f9ab739dd426a6a254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386
const $5aaf8f415dbd862d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386",
            "metadata": {},
            "name": "renameProjectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5aaf8f415dbd862d$var$node.hash = "4eb2a9d3f2e1dbb64dd9331c62625de5";
var $5aaf8f415dbd862d$export$2e2bcd8739ae039 = $5aaf8f415dbd862d$var$node;

});

parcelRegister("cbTlr", function(module, exports) {

$parcel$export(module.exports, "constructEndpoint", () => $e9cd8f4f70921922$export$a5b7a8c3b1c6e775);
$parcel$export(module.exports, "get", () => $e9cd8f4f70921922$export$3988ae62b71be9a3);

var $eusud = parcelRequire("eusud");
const $e9cd8f4f70921922$export$a5b7a8c3b1c6e775 = (baseUrl, projectName)=>`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;
const $e9cd8f4f70921922$export$3988ae62b71be9a3 = (baseUrl, projectKey, abortSignal)=>{
    const url = $e9cd8f4f70921922$export$a5b7a8c3b1c6e775(baseUrl, projectKey);
    return (0, $eusud.performGetRequest)(url, {
        signal: abortSignal
    });
};

});

parcelRegister("9F7ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $6672c219cbb24069$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6672c219cbb24069$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateProjectNameError: {
        "id": "horizontal-nav-common.services.rename-project.update-project-name-error",
        "defaultMessage": "We couldn't update your project name. Try again."
    }
});

});


parcelRegister("4DmRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67664dfa27d6cde7$export$2e2bcd8739ae039);

var $5TjxH = parcelRequire("5TjxH");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9IFFl = parcelRequire("9IFFl");

var $4R6GH = parcelRequire("4R6GH");

var $gThTQ = parcelRequire("gThTQ");

var $dN3HT = parcelRequire("dN3HT");
const $67664dfa27d6cde7$var$ProjectAvatar = ({ projectRef: projectRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $5TjxH.default), projectRef);
    if (data?.projectType === 'BUSINESS') return (0, $4R6GH.fg)('jgfeng_fetch_system_avatars_on_demand') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dN3HT.NavigationKitAvatarPopup), {
        canEdit: data?.canEditProjectConfig?.canPerform ?? false,
        projectId: Number(data?.projectId),
        selectedAvatarUrl: data?.avatar?.large ?? ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gThTQ.NavigationKitAvatar), {
        projectId: Number(data?.projectId),
        selectedAvatarUrl: data?.avatar?.large ?? '',
        canEdit: data?.canEditProjectConfig?.canPerform ?? false
    });
    if (!data.avatar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIcon), {
        src: `${data.avatar.large}?size=xlarge`,
        alt: "",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "horizontal-nav.ui.content.project-avatar",
        "data-vc": "jira-horizontal-nav-project-icon"
    });
};
var $67664dfa27d6cde7$export$2e2bcd8739ae039 = $67664dfa27d6cde7$var$ProjectAvatar;

});
parcelRegister("5TjxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3dcb1e1e6b610c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08604d5776b50fb6002cfdeffab34bbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b3dcb1e1e6b610c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectAvatar",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$6b3dcb1e1e6b610c$var$node.hash = "bf24cf4ceac2f687267bc6a885231cc1";
var $6b3dcb1e1e6b610c$export$2e2bcd8739ae039 = $6b3dcb1e1e6b610c$var$node;

});

parcelRegister("gThTQ", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatar", () => $e32d53c8623402b4$export$51803d203e8fe5b8);

var $5uXOq = parcelRequire("5uXOq");

var $4n53v = parcelRequire("4n53v");

var $dN3HT = parcelRequire("dN3HT");
const $e32d53c8623402b4$export$51803d203e8fe5b8 = ({ projectId: projectId, selectedAvatarUrl: selectedAvatarUrl, canEdit: canEdit })=>{
    const { systemAvatars: systemAvatars, latestCustomAvatar: latestCustomAvatar, updateProjectAvatar: updateProjectAvatar, uploadProjectAvatar: uploadProjectAvatar } = (0, $4n53v.useUpdateAvatars)(projectId, selectedAvatarUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dN3HT.NavigationKitAvatarPopup), {
        selectedAvatarUrl: selectedAvatarUrl,
        systemAvatars: systemAvatars,
        latestCustomAvatar: latestCustomAvatar,
        onSelectAvatar: updateProjectAvatar,
        onUploadAvatar: uploadProjectAvatar,
        canEdit: canEdit,
        projectId: projectId
    });
};

});
parcelRegister("4n53v", function(module, exports) {

$parcel$export(module.exports, "useUpdateAvatars", () => $9db28e7111fc8476$export$1f93d10b6542f36c);

var $dXGkm = parcelRequire("dXGkm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $iKWKg = parcelRequire("iKWKg");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");
const $9db28e7111fc8476$export$1f93d10b6542f36c = (projectId, selectedAvatarUrl)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { selectedAvatar: selectedAvatar, systemAvatars: systemAvatars, customAvatars: customAvatars, latestCustomAvatar: latestCustomAvatar, setLatestCustomAvatar: setLatestCustomAvatar, uploadCustomerIcon: uploadCustomerIcon } = (0, $iKWKg.useAvatars)(projectId, selectedAvatarUrl);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dXGkm.default));
    const getAvatarUrlFromId = (0, $5uXOq.useCallback)((newAvatarId)=>{
        const url = selectedAvatarUrl.substring(0, selectedAvatarUrl.lastIndexOf('/'));
        return `${url}/${String(newAvatarId)}`;
    }, [
        selectedAvatarUrl
    ]);
    const updateProjectAvatar = (0, $5uXOq.useCallback)((avatarId, avatarUrl, onError)=>{
        if (!projectId || selectedAvatar && avatarUrl === selectedAvatar.dataURI) return;
        const avatarUpdater = (store)=>{
            const ari = (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const projectRelayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (!projectRelayDataId) return;
            const project = store.get(projectRelayDataId);
            const avatarRelayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraAvatar');
            if (project && avatarRelayDataId) {
                let avatar = store.get(avatarRelayDataId);
                if (!avatar) avatar = store.create(avatarRelayDataId, 'JiraAvatar');
                avatar.setValue(avatarRelayDataId, 'id');
                avatar.setValue(getAvatarUrlFromId(avatarId), 'large');
                project.setLinkedRecord(avatar, 'avatar');
            }
        };
        commitMutation({
            variables: {
                avatarId: String(avatarId),
                cloudId: cloudId,
                projectIdOrKey: String(projectId)
            },
            optimisticUpdater: avatarUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectAvatar?.success) avatarUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectAvatar ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate succeeded');
                else if (error) {
                    onError?.(true);
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate failed', {
                        error: error
                    });
                }
            },
            onError: (error)=>{
                onError?.(true);
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate failed', {
                    error: error
                });
            }
        });
    }, [
        projectId,
        selectedAvatar,
        commitMutation,
        cloudId,
        getAvatarUrlFromId,
        createAnalyticsEvent
    ]);
    const uploadProjectAvatar = (0, $5uXOq.useCallback)((file, crop, onError)=>{
        return uploadCustomerIcon(projectId, file, crop).then((data)=>{
            const url = getAvatarUrlFromId(data.id);
            updateProjectAvatar(data.id, url, onError);
            setLatestCustomAvatar({
                id: Number(data.id),
                dataURI: url,
                name: ''
            });
        });
    }, [
        uploadCustomerIcon,
        projectId,
        updateProjectAvatar,
        getAvatarUrlFromId,
        setLatestCustomAvatar
    ]);
    return {
        updateProjectAvatar: updateProjectAvatar,
        systemAvatars: systemAvatars,
        customAvatars: customAvatars,
        selectedAvatar: selectedAvatar,
        uploadProjectAvatar: uploadProjectAvatar,
        latestCustomAvatar: latestCustomAvatar
    };
};

});
parcelRegister("dXGkm", function(module, exports) {

$parcel$export(module.exports, "default", () => $656ebc10fc9884d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<880e6824115303095668c92aca5ea73d>>
 * @relayHash 10ea5d3f944add6fa8150d62377cb25c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7caba7f38d56f13f50f022a72c4976d3f19dc7e794559480e3e6b90b9b639461
const $656ebc10fc9884d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "avatarId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "avatarId",
                    "variableName": "avatarId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "updateAvatarsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateAvatarMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectAvatar",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "updateAvatarsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateAvatarMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectAvatar",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7caba7f38d56f13f50f022a72c4976d3f19dc7e794559480e3e6b90b9b639461",
            "metadata": {},
            "name": "updateAvatarsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$656ebc10fc9884d7$var$node.hash = "5b5c8dbdd769b8a2a3a19cf2d08449e7";
var $656ebc10fc9884d7$export$2e2bcd8739ae039 = $656ebc10fc9884d7$var$node;

});

parcelRegister("iKWKg", function(module, exports) {

$parcel$export(module.exports, "useAvatars", () => $7739f22edb0d0427$export$d4b55094163ce82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1J3t1 = parcelRequire("1J3t1");

var $4tcSU = parcelRequire("4tcSU");

var $8zOmE = parcelRequire("8zOmE");

var $ddOoS = parcelRequire("ddOoS");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");


var $36j29 = parcelRequire("36j29");
const $7739f22edb0d0427$export$30d427d8a06a542e = (avatar)=>{
    const avatarId = parseInt(avatar.id, 10);
    return {
        id: avatarId,
        avatarUrl: `/secure/viewavatar?size=xxxlarge@2x&avatarId=${avatarId}&avatarType=project`,
        fileName: avatar?.fileName
    };
};
const $7739f22edb0d0427$export$d3c60b218ff193fd = (projectId)=>(0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performGetRequest)(`/rest/api/2/universal_avatar/type/project/owner/${projectId}`), (0, $0175358ae1e6c114$export$b8b9d90f9e5bd72b), (0, $gl0PU.toErrorId)('getPredefinedAvatars'), (0, $gl0PU.toErrorMessage)('Failed to fetch avatars for project details')).catch(()=>({
            hasError: true,
            system: [],
            custom: []
        }));
const $7739f22edb0d0427$export$137fdb9263c4dbda = (projectId, avatarId)=>(0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performPutRequest)(`/rest/api/2/project/${String(projectId)}`, {
        body: JSON.stringify({
            avatarId: avatarId
        })
    }), 'navigation-app', (0, $gl0PU.toErrorId)('updateProjectIcon'), (0, $gl0PU.toErrorMessage)('Failed to update project Icon'));
const $7739f22edb0d0427$export$a9c70f27f3b2b5f3 = (projectId, file, crop)=>{
    const uploadUrl = `/rest/api/2/universal_avatar/type/project/owner/${projectId}` + // we are getting XSRF token from cookies directly because it is not being in the store and can be outdated
    `?atl_token=${(0, $4tcSU.default)() || ''}` + `&x=${Math.floor(crop.x)}` + `&y=${Math.floor(crop.y)}` + `&size=${Math.floor(crop.size)}`;
    return (0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performPostRequest)(uploadUrl, {
        body: file,
        headers: {}
    }), (0, $0175358ae1e6c114$export$b8b9d90f9e5bd72b), (0, $gl0PU.toErrorId)('uploadProjectAvatar'), (0, $gl0PU.toErrorMessage)('Failed to upload an avatar for project details'));
};
const $7739f22edb0d0427$export$d4b55094163ce82 = (projectId, selectedAvatarUrl)=>{
    const [predefinedSystemAvatars, setPredefinedSystemAvatars] = (0, $5uXOq.useState)([]);
    const [predefinedCustomAvatars, setPredefinedCustomAvatars] = (0, $5uXOq.useState)([]);
    const [latestCustomAvatar, setLatestCustomAvatar] = (0, $5uXOq.useState)(undefined);
    const [fetchingError, setFetchingError] = (0, $5uXOq.useState)(undefined);
    const isFetched = (0, $5uXOq.useRef)(false);
    const { refresh: refresh } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    (0, $5uXOq.useEffect)(()=>{
        if (isFetched.current) return;
        $7739f22edb0d0427$export$d3c60b218ff193fd(projectId).then((response)=>{
            // need to load xxxlarge icons in AvatarModal
            setPredefinedSystemAvatars(response.system.map((avatar)=>{
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(avatar);
                return {
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                };
            }));
            setPredefinedCustomAvatars(response.custom.map((avatar)=>{
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(avatar);
                return {
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                };
            }));
            if (response.custom.length) {
                const lastCustomAvatar = response.custom[response.custom.length - 1];
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(lastCustomAvatar);
                setLatestCustomAvatar({
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                });
            }
            if (response.hasError) setFetchingError(new Error('There is an error in fetching fetching avatar'));
        }).catch((e)=>{
            setFetchingError(e);
        });
        isFetched.current = true;
    }, [
        isFetched,
        projectId,
        intl
    ]);
    const allAvatars = (0, $5uXOq.useMemo)(()=>[
            ...predefinedSystemAvatars,
            ...predefinedCustomAvatars
        ], [
        predefinedSystemAvatars,
        predefinedCustomAvatars
    ]);
    const selectedAvatar = (0, $5uXOq.useMemo)(()=>{
        const selectedAvatarId = parseInt(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1), 10);
        return allAvatars?.find((avatar)=>avatar.id === selectedAvatarId);
    }, [
        allAvatars,
        selectedAvatarUrl
    ]);
    const onError = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            key: 'update-project-icon-error',
            type: 'error',
            title: formatMessage((0, $36j29.default).updateError),
            messageId: 'navigation-apps-sidebar-inline-config-project-header.services.use-avatars.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const updateSelectedAvatar = (0, $5uXOq.useCallback)((avatarUrl, analyticsEvent)=>{
        if (selectedAvatar && avatarUrl === selectedAvatar.dataURI) return;
        const jiraAvatar = allAvatars?.find((avatar)=>avatar.dataURI === avatarUrl);
        if (jiraAvatar) $7739f22edb0d0427$export$137fdb9263c4dbda(projectId, jiraAvatar.id).then(()=>{
            analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project updated', {
                projectType: (0, $2vSU6.SOFTWARE_PROJECT),
                updatedItems: '[projectIcon]'
            });
            refresh();
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            onError();
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'updateProjectIcon',
                    packageName: 'jiraNavigationAppsSidebarInlineConfigProjectHeader',
                    teamName: 'jlove-makkuro'
                }
            });
        });
    }, [
        selectedAvatar,
        allAvatars,
        projectId,
        refresh,
        onError
    ]);
    const uploadCustomerAvatar = (0, $5uXOq.useCallback)((file, crop, analyticsEvent)=>{
        if (file && crop) $7739f22edb0d0427$export$a9c70f27f3b2b5f3(projectId, file, crop).then((data)=>$7739f22edb0d0427$export$137fdb9263c4dbda(projectId, data.id)).then(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project updated', {
                projectType: (0, $2vSU6.SOFTWARE_PROJECT),
                updatedItems: '[projectIcon]'
            });
            refresh();
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            onError();
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'uploadCustomerIcon',
                    packageName: 'jiraNavigationAppsSidebarInlineConfigProjectHeader',
                    teamName: 'jlove-makkuro'
                }
            });
        });
    }, [
        projectId,
        onError,
        refresh
    ]);
    return {
        selectedAvatar: selectedAvatar,
        systemAvatars: predefinedSystemAvatars,
        customAvatars: predefinedCustomAvatars,
        fetchingError: fetchingError,
        updateSelectedAvatar: updateSelectedAvatar,
        uploadCustomerAvatar: uploadCustomerAvatar,
        uploadCustomerIcon: $7739f22edb0d0427$export$a9c70f27f3b2b5f3,
        allAvatars: allAvatars,
        isFetched: isFetched,
        latestCustomAvatar: latestCustomAvatar,
        setLatestCustomAvatar: setLatestCustomAvatar
    };
};

});
parcelRegister("ddOoS", function(module, exports) {

$parcel$export(module.exports, "getAccessibleAvatarName", () => $d91040f0177bcd66$export$b7a0be78db7aa598);

var $hZxwj = parcelRequire("hZxwj");
/**
 * This isn't the greatest of maps. It doesn't guarantee to actually describe all the avatars.
 * It's just the best effort to describe some of the default system avatars.
 * Trouble is that our backend doesn't return any names or alts or anything; all we have are filenames which mostly don't make much sense.
 *
 * See https://hello.atlassian.net/wiki/spaces/~hbegg/pages/1898366234/Updating+Jira+s+project+icons+to+make+them+more+accessible
 *
 * NOTE: this is just a temporary solution, this ticket: https://donut-world-dogfood.atlassian.net/browse/MCRTB-1522 will move this mapping to the back end instead
 *
 * @returns MessageDescriptor if there's an appropriate one; null if the filename is not recognized. If null then use some generic fallback.
 */ const $d91040f0177bcd66$var$filenameToMessageDescriptor = (filename)=>{
    switch(filename){
        case 'project_avatar_alien.svg':
            return (0, $hZxwj.messages).projectAvatarAlien;
        case 'project_avatar_parrot.svg':
            return (0, $hZxwj.messages).projectAvatarParrot;
        case 'project_avatar_cloud.svg':
            return (0, $hZxwj.messages).projectAvatarCloud;
        case 'project_avatar_disc.svg':
            return (0, $hZxwj.messages).projectAvatarDisc;
        case 'project_avatar_code.svg':
            return (0, $hZxwj.messages).projectAvatarCode;
        case 'project_avatar_coffee.svg':
            return (0, $hZxwj.messages).projectAvatarCoffee;
        case 'project_avatar_design.svg':
            return (0, $hZxwj.messages).projectAvatarDesign;
        case 'project_avatar_drill.svg':
            return (0, $hZxwj.messages).projectAvatarDrill;
        case 'project_avatar_food.svg':
            return (0, $hZxwj.messages).projectAvatarFood;
        case 'project_avatar_koala.svg':
            return (0, $hZxwj.messages).projectAvatarKoala;
        case 'project_avatar_mobile.svg':
            return (0, $hZxwj.messages).projectAvatarMobile;
        case 'project_avatar_money.svg':
            return (0, $hZxwj.messages).projectAvatarMoney;
        case 'project_avatar_website.svg':
            return (0, $hZxwj.messages).projectAvatarWebsite;
        case 'project_avatar_nature.svg':
            return (0, $hZxwj.messages).projectAvatarNature;
        case 'project_avatar_notes.svg':
            return (0, $hZxwj.messages).projectAvatarNotes;
        case 'project_avatar_plane.svg':
            return (0, $hZxwj.messages).projectAvatarPlane;
        case 'project_avatar_power.svg':
            return (0, $hZxwj.messages).projectAvatarPower;
        case 'project_avatar_flag.svg':
            return (0, $hZxwj.messages).projectAvatarFlag;
        case 'project_avatar_refresh.svg':
            return (0, $hZxwj.messages).projectAvatarRefresh;
        case 'project_avatar_rocket.svg':
            return (0, $hZxwj.messages).projectAvatarRocket;
        case 'project_avatar_science.svg':
            return (0, $hZxwj.messages).projectAvatarScience;
        case 'project_avatar_settings.svg':
            return (0, $hZxwj.messages).projectAvatarSettings;
        case 'project_avatar_spanner.svg':
            return (0, $hZxwj.messages).projectAvatarSpanner;
        case 'project_avatar_storm.svg':
            return (0, $hZxwj.messages).projectAvatarStorm;
        case 'project_avatar_support.svg':
            return (0, $hZxwj.messages).projectAvatarSupport;
        case 'project_avatar_yeti.svg':
            return (0, $hZxwj.messages).projectAvatarYeti;
        default:
            return null;
    }
};
const $d91040f0177bcd66$export$b7a0be78db7aa598 = (avatar)=>{
    if (avatar?.fileName) {
        const messageDescriptor = $d91040f0177bcd66$var$filenameToMessageDescriptor(avatar.fileName);
        if (messageDescriptor) return (intl)=>intl.formatMessage(messageDescriptor);
    }
    // Custom avatars have no alt because customers do not provide any when uploading images
    return ()=>'';
};

});
parcelRegister("hZxwj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $911dca1b9bee6042$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $911dca1b9bee6042$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectAvatarAlien: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-alien",
        "defaultMessage": "One-eyed alien in spaceship"
    },
    projectAvatarParrot: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-parrot",
        "defaultMessage": "Smiling bird with yellow beak"
    },
    projectAvatarCloud: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-cloud",
        "defaultMessage": "Happy cloud"
    },
    projectAvatarDisc: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-disc",
        "defaultMessage": "Vinyl record"
    },
    projectAvatarCode: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-code",
        "defaultMessage": "Computer browser"
    },
    projectAvatarCoffee: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-coffee",
        "defaultMessage": "Coffee cup"
    },
    projectAvatarDesign: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-design",
        "defaultMessage": "Painting of landscape resting on easel"
    },
    projectAvatarDrill: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-drill",
        "defaultMessage": "Yellow electric drill"
    },
    projectAvatarFood: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-food",
        "defaultMessage": "Hot dog with mustard"
    },
    projectAvatarKoala: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-koala",
        "defaultMessage": "Smiling koala eating leaf"
    },
    projectAvatarMobile: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-mobile",
        "defaultMessage": "Smartphone with smiley face"
    },
    projectAvatarMoney: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-money",
        "defaultMessage": "Wallet with money sticking out"
    },
    projectAvatarWebsite: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-website",
        "defaultMessage": "Computer browser with cursor in centre"
    },
    projectAvatarNature: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-nature",
        "defaultMessage": "Snow-capped mountains with sun behind"
    },
    projectAvatarNotes: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-notes",
        "defaultMessage": "Notebook with pencil"
    },
    projectAvatarPlane: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-plane",
        "defaultMessage": "Airplane flying skyward"
    },
    projectAvatarPower: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-power",
        "defaultMessage": "Purple and orange battery with plus symbol"
    },
    projectAvatarFlag: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-flag",
        "defaultMessage": "Red flag on pole"
    },
    projectAvatarRefresh: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-refresh",
        "defaultMessage": "Two circular arrows representing refresh icon"
    },
    projectAvatarRocket: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-rocket",
        "defaultMessage": "Rocket flying through space"
    },
    projectAvatarScience: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-science",
        "defaultMessage": "Science bottle full of bubbling red liquid"
    },
    projectAvatarSettings: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-settings",
        "defaultMessage": "Settings control panel with vertical sliders"
    },
    projectAvatarSpanner: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-spanner",
        "defaultMessage": "Silver wrench"
    },
    projectAvatarStorm: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-storm",
        "defaultMessage": "Storm cloud with rain and lightning"
    },
    projectAvatarSupport: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-support",
        "defaultMessage": "Red and white life buoy on blue background"
    },
    projectAvatarYeti: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-yeti",
        "defaultMessage": "Frowning abominable snowman"
    }
});

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("koFzm", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $eb8b95f475174133$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $eb8b95f475174133$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $1RLjE = parcelRequire("1RLjE");
const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
        (0, $1RLjE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;

});
parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $2YZCu.default).unsafeErrorWithCustomerData(location, message, error);
};

});


const $0175358ae1e6c114$export$b8b9d90f9e5bd72b = 'inlineConfigProjectHeader';
const $0175358ae1e6c114$export$7525482b5931e326 = 'input';
const $0175358ae1e6c114$export$9957974f8b4d8f74 = 'configurableProjectHeader';

parcelRegister("36j29", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7d3ba4afd2d7be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea7d3ba4afd2d7be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateError: {
        "id": "navigation-apps-sidebar-inline-config-project-header.services.use-avatars.update-error",
        "defaultMessage": "Something went wrong while updating the project icon. Try again."
    }
});

});



parcelRegister("dN3HT", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatarPopup", () => $7260ed61cff550ef$export$500ef2645bac918e);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $9KMcd = parcelRequire("9KMcd");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $ccste = parcelRequire("ccste");

var $aEzXU = parcelRequire("aEzXU");
const $7260ed61cff550ef$export$500ef2645bac918e = ({ canEdit: canEdit, projectId: projectId, selectedAvatarUrl: selectedAvatarUrl, systemAvatars: // TODO: JGFENG-1029 - Clean up legacy props
systemAvatars, latestCustomAvatar: latestCustomAvatar, onSelectAvatar: onSelectAvatar, onUploadAvatar: onUploadAvatar })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onAvatarClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const selectedAvatarId = Number(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aEzXU.navigationKitAvatarPopupContentEntrypoint), {});
    const entrypointTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('jgfeng_fetch_system_avatars_on_demand') ? {
            onClose: onClose,
            projectId: projectId,
            selectedAvatarId: selectedAvatarId,
            selectedAvatarUrl: selectedAvatarUrl
        } : {
            latestCustomAvatar: latestCustomAvatar,
            onClose: onClose,
            onSelectAvatar: onSelectAvatar,
            onUploadAvatar: onUploadAvatar,
            projectId: projectId,
            selectedAvatarId: selectedAvatarId,
            systemAvatars: systemAvatars,
            selectedAvatarUrl: selectedAvatarUrl
        }, [
        onClose,
        projectId,
        selectedAvatarId,
        selectedAvatarUrl,
        latestCustomAvatar,
        onSelectAvatar,
        onUploadAvatar,
        systemAvatars
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "horizontal-nav.ui.content.header.project-header.project-avatar.navigation-kit-avatar-popup.jira-popup.popup",
        messageType: "transactional",
        placement: "bottom-start",
        role: "dialog",
        label: formatMessage((0, $ccste.default).title),
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-avatar.popup-content",
                packageName: "jiraNavigationKitAvatarPopupContent",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: runtimeProps
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                ref: entrypointTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KMcd.EditableAvatar), {
                avatarUrl: selectedAvatarUrl,
                canEdit: canEdit,
                onClick: onAvatarClick,
                triggerProps: triggerProps
            }));
        }
    });
};

});
parcelRegister("9KMcd", function(module, exports) {

$parcel$export(module.exports, "EditableAvatar", () => $7f651364a7a8bfa5$export$fd3a492e0b2eddae);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $1Seuh = parcelRequire("1Seuh");

var $45xDm = parcelRequire("45xDm");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $9IFFl = parcelRequire("9IFFl");

var $9nJ5Z = parcelRequire("9nJ5Z");
const $7f651364a7a8bfa5$var$EditIconWithTransparentBackground = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $7f651364a7a8bfa5$var$iconBackgroundStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45xDm))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $7f651364a7a8bfa5$var$ProjectAvatar = ({ src: src, testId: testId })=>(0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIconSmallerSize), {
        "data-testid": testId && `${testId}--image`,
        "data-vc": "editable-avatar-project",
        src: src,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: src,
        testId: testId,
        "data-vc": "editable-avatar-project"
    });
const $7f651364a7a8bfa5$export$fd3a492e0b2eddae = (props)=>{
    const { avatarUrl: avatarUrl, canEdit: canEdit, triggerProps: triggerProps = {}, onClick: onClick } = props;
    const [isHover, setIsHover] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $9nJ5Z.default).editIconLabel),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $7f651364a7a8bfa5$var$editableAvatarContainerStyles
        }, isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $7f651364a7a8bfa5$var$smallerIconButtonWrapperStyles : $7f651364a7a8bfa5$var$iconButtonWrapperStyles,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            appearance: "subtle",
            icon: $7f651364a7a8bfa5$var$EditIconWithTransparentBackground,
            label: formatMessage((0, $9nJ5Z.default).editIconLabel),
            spacing: "compact",
            ...triggerProps,
            onClick: onClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
            src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
            testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon-editable"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
        src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
        testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon"
    })));
};
const $7f651364a7a8bfa5$var$iconBackgroundStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.background.neutral.pressed',
    borderRadius: '2px'
});
const $7f651364a7a8bfa5$var$editableAvatarContainerStyles = (0, $2s57o.xcss)({
    position: 'relative'
});
const $7f651364a7a8bfa5$var$iconButtonWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-025, 2px)",
    top: "var(--ds-space-025, 2px)"
});
const $7f651364a7a8bfa5$var$smallerIconButtonWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-negative-025, -2px)",
    top: "var(--ds-space-negative-025, -2px)"
});

});
parcelRegister("45xDm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fa1b806f5b29ed7$var$_react = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2fa1b806f5b29ed7$var$_edit = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("084bx")));

var $2fa1b806f5b29ed7$var$_editFilled = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("glcam")));
function $2fa1b806f5b29ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fa1b806f5b29ed7$var$EditIcon = (props)=>/*#__PURE__*/ $2fa1b806f5b29ed7$var$_react.default.createElement($2fa1b806f5b29ed7$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $2fa1b806f5b29ed7$var$_editFilled.default
    }, props));
$2fa1b806f5b29ed7$var$EditIcon.Name = 'EditIconMigration';
var $2fa1b806f5b29ed7$var$_default = module.exports.default = $2fa1b806f5b29ed7$var$EditIcon;

});
parcelRegister("084bx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0006420a77150094$var$_react = $0006420a77150094$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0006420a77150094$var$_baseNew = $0006420a77150094$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0006420a77150094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0006420a77150094$var$EditIcon = (props)=>/*#__PURE__*/ $0006420a77150094$var$_react.default.createElement($0006420a77150094$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$0006420a77150094$var$EditIcon.displayName = 'EditIcon';
var $0006420a77150094$var$_default = module.exports.default = $0006420a77150094$var$EditIcon;

});

parcelRegister("glcam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be580b73570dd198$var$_react = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $be580b73570dd198$var$_edit = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("084bx")));
function $be580b73570dd198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be580b73570dd198$var$EditFilledIcon = (props)=>/*#__PURE__*/ $be580b73570dd198$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $be580b73570dd198$var$_edit.default
    }));
$be580b73570dd198$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $be580b73570dd198$var$_default = module.exports.default = $be580b73570dd198$var$EditFilledIcon;

});


parcelRegister("9nJ5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c30433ca2f8a3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51c30433ca2f8a3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editIconLabel: {
        "id": "navigation-apps-sidebar-inline-config-project-header.editable-avatar.edit-icon-label",
        "defaultMessage": "Edit project icon"
    }
});

});


parcelRegister("ccste", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9146bab84326dfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9146bab84326dfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-kit-avatar.title",
        "defaultMessage": "Select an avatar"
    },
    close: {
        "id": "navigation-kit-avatar.close",
        "defaultMessage": "Close avatar selection"
    },
    error: {
        "id": "navigation-kit-avatar.error",
        "defaultMessage": "Error updating project avatar."
    },
    cancelUpload: {
        "id": "navigation-kit-avatar.cancel-upload",
        "defaultMessage": "Cancel"
    },
    submitUpload: {
        "id": "navigation-kit-avatar.submit-upload",
        "defaultMessage": "Submit"
    },
    uploadImageErrorMessage: {
        "id": "navigation-kit-avatar.upload-image-error-message",
        "defaultMessage": "We couldn't upload the image. Check your connection and try again."
    },
    updateAvatarErrorMessage: {
        "id": "navigation-kit-avatar.update-avatar-error-message",
        "defaultMessage": "We couldn't save the changes. Check your connection and try again."
    },
    imageUrlInvalidError: {
        "id": "navigation-kit-avatar.image-url-invalid-error",
        "defaultMessage": "Could not load image, the url is invalid."
    },
    imageFormatInvalidError: {
        "id": "navigation-kit-avatar.image-format-invalid-error",
        "defaultMessage": "Could not load image, the format is invalid."
    },
    imageSizeTooLargeError: {
        "id": "navigation-kit-avatar.image-size-too-large-error",
        "defaultMessage": "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    selectImageToUploadOrDragAndDrop: {
        "id": "navigation-kit-avatar.select-image-to-upload-or-drag-and-drop",
        "defaultMessage": "<link>Select an image to upload</link> or drag and drop it here"
    }
});

});

parcelRegister("aEzXU", function(module, exports) {

$parcel$export(module.exports, "navigationKitAvatarPopupContentEntrypoint", () => $9fb8f38fe799294e$export$6c49070d2ac14f7c);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $9fb8f38fe799294e$export$6c49070d2ac14f7c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("kfntp")).then((module)=>module.NavigationKitAvatarPopupContentEntryPoint), {
        moduleId: "48abd2fb",
        moduleName: "NavigationKitAvatarPopupContent"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kfntp", function(module, exports) {

let $ebd76aa8dec9d8f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ebd76aa8dec9d8f5$var$load("h2MrD"),
    $ebd76aa8dec9d8f5$var$load("bYT2S"),
    $ebd76aa8dec9d8f5$var$load("cM9em"),
    $ebd76aa8dec9d8f5$var$load("fr9NE"),
    $ebd76aa8dec9d8f5$var$load("hPzOn"),
    $ebd76aa8dec9d8f5$var$load("bod0B")
]).then(()=>parcelRequire('7rm6U'));

});






parcelRegister("4VBHB", function(module, exports) {

$parcel$export(module.exports, "UserBoardHeader", () => $37b9529943499b75$export$adc7514276e418cb);

var $bgCb0 = parcelRequire("bgCb0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $eC0BO = parcelRequire("eC0BO");

var $9FHy9 = parcelRequire("9FHy9");

var $Bvv5R = parcelRequire("Bvv5R");
const $37b9529943499b75$export$adc7514276e418cb = ({ boardFragment: boardFragment })=>{
    const boardData = (0, $8Uumt.useFragment)((0, $bgCb0.default), boardFragment);
    const extraComponentsFar = (0, $5uXOq.useMemo)(()=>{
        const board = {
            id: boardData.boardId,
            name: boardData.name,
            type: boardData.boardType === 'SCRUM' ? 'scrum' : 'kanban',
            isProjectBoard: false
        };
        const components = [];
        if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
            key: "fullscreen"
        }));
        components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FHy9.ShareButton), {
            key: "share",
            data: board
        }));
        return components;
    }, [
        boardData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        testId: "horizontal-nav-header.ui.user-board-header",
        title: boardData.name,
        extraComponentsClose: [],
        extraComponentsFar: extraComponentsFar
    });
};

});
parcelRegister("bgCb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f01c9de42ceb21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<daca393877d4cdc54117aeb3cb333c2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e6f01c9de42ceb21$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserBoardHeader_board",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        }
    ],
    "type": "JiraBoard"
};
$e6f01c9de42ceb21$var$node.hash = "8e9eefe98b582988ed6ecfcea8baeeac";
var $e6f01c9de42ceb21$export$2e2bcd8739ae039 = $e6f01c9de42ceb21$var$node;

});



parcelRegister("inpPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0fd34946c90537$export$2e2bcd8739ae039);
/* NavWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2GZKW = parcelRequire("2GZKW");
var $2s57o = parcelRequire("2s57o");

var $5tDD0 = parcelRequire("5tDD0");

var $6cG4N = parcelRequire("6cG4N");

var $g7crU = parcelRequire("g7crU");

var $4R6GH = parcelRequire("4R6GH");
const $ff0fd34946c90537$var$NavWrapper = ({ children: children })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $5tDD0.default), {
        name: "jira-horizontal-nav"
    }, /*#__PURE__*/ $5uXOq.createElement("header", {
        id: "ak-project-view-navigation",
        "data-testid": "horizontal-nav.ui.content.horizontal-nav",
        className: (0, $bwpsq.default)([
            "_11q71iew _vchhusvi _18k9ad7r"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2GZKW.default), {
        gap: "space.050",
        alignItems: "end",
        xcss: [
            (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $ff0fd34946c90537$var$contentStylesWithReducedPadding : $ff0fd34946c90537$var$contentStyles,
            !isFullscreen && ((0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $ff0fd34946c90537$var$minHeightStyleReduced : $ff0fd34946c90537$var$minHeightStyle)
        ]
    }, children)));
};
var $ff0fd34946c90537$export$2e2bcd8739ae039 = $ff0fd34946c90537$var$NavWrapper;
const $ff0fd34946c90537$var$minHeightStyle = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $6cG4N.NAV4_HORIZONTAL_NAV_HEIGHT)}px`
});
const $ff0fd34946c90537$var$minHeightStyleReduced = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $6cG4N.NAV4_HORIZONTAL_NAV_HEIGHT_NEW)}px`
});
const $ff0fd34946c90537$var$contentStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.300'
});
const $ff0fd34946c90537$var$contentStylesWithReducedPadding = (0, $2s57o.xcss)({
    paddingTop: 'space.150'
});
const $ff0fd34946c90537$var$headerStyles = null;

});

parcelRegister("jPgWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f2eb1c78758048$export$2e2bcd8739ae039);

var $5dQAY = parcelRequire("5dQAY");

var $gR1iK = parcelRequire("gR1iK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $c9Ur7 = parcelRequire("c9Ur7");

var $3bQtK = parcelRequire("3bQtK");

var $bJYvM = parcelRequire("bJYvM");


var $aMlsI = parcelRequire("aMlsI");

var $7UhxN = parcelRequire("7UhxN");

var $k1ALc = parcelRequire("k1ALc");



var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $iqMDF = parcelRequire("iqMDF");

var $3hiNj = parcelRequire("3hiNj");

var $aQoCL = parcelRequire("aQoCL");
const $07f2eb1c78758048$var$TabsContent = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $gR1iK.default), queryFragment);
    const projectData = (0, $8Uumt.useFragment)((0, $5dQAY.default), projectFragment);
    const { handleError: handleError } = (0, $aMlsI.useHandleError)();
    const { data: shortcutsData, loading: loading } = (0, $7UhxN.useShortcutsData)();
    const containerNavigation = data.jira.containerNavigation?.__typename === 'JiraContainerNavigation' ? data.jira.containerNavigation : null;
    const navigationItems = containerNavigation ? containerNavigation?.navigationItems : null;
    (0, $5uXOq.useEffect)(()=>{
        const containerNavigationQueryError = data.jira.containerNavigation?.__typename === 'QueryError' ? data.jira.containerNavigation : null;
        if (navigationItems?.errors && navigationItems?.errors?.length > 0) {
            const error = navigationItems.errors[0];
            handleError(new (0, $c9Ur7.QueryError)(error));
        } else if (containerNavigationQueryError) handleError(new (0, $c9Ur7.QueryError)(containerNavigationQueryError));
        else if (navigationItems?.edges == null) handleError(new Error('navigationItems.edges failed to load'));
    }, [
        containerNavigation?.navigationItems,
        data,
        handleError,
        navigationItems?.edges,
        navigationItems?.errors
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            projectType: (projectData?.projectType ?? '').toLowerCase(),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            withContainerNav: true
        }), [
        projectData?.projectType
    ]);
    return containerNavigation && navigationItems && !navigationItems.errors && navigationItems?.edges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "horizontalNavJiraTabsContent",
        containerType: (0, $5da7873a71c45b64$export$fe791c4fa892e400),
        containerId: String(projectData?.projectId ?? ''),
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
        data: shortcutsData,
        loading: loading,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqMDF.ContainerNavigationTabs), {
        containerFragment: data.jira.containerNavigation,
        tabsDescriptor: (0, $3hiNj.JIRA_TABS),
        label: formatMessage((0, $aQoCL.default).projectNavigation)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $bJYvM.VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE).experience,
        attributes: {
            withContainerNav: true
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $07f2eb1c78758048$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($07f2eb1c78758048$var$TabsContent);

});
parcelRegister("5dQAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b2fdb44f41a91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39573effa1e570b3c0fd3e77351ee0aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d70b2fdb44f41a91$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabsContent_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$d70b2fdb44f41a91$var$node.hash = "abf520acd7725543508b669e38084bfa";
var $d70b2fdb44f41a91$export$2e2bcd8739ae039 = $d70b2fdb44f41a91$var$node;

});

parcelRegister("gR1iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ee72a00e43d51bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b33ff9402499ad0ca2b928e76d3e95d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ee72a00e43d51bd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerNavigationInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "TabsContent_query",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "input",
                                        "variableName": "containerNavigationInput"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ContainerNavigationTabs_container"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "first",
                                                        "variableName": "first"
                                                    }
                                                ],
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v0 /*: any*/ 
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v1 /*: any*/ ,
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.containerNavigation"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$3ee72a00e43d51bd$var$node.hash = "dddbbf10cf502c2f1eddd90f2abbde72";
var $3ee72a00e43d51bd$export$2e2bcd8739ae039 = $3ee72a00e43d51bd$var$node;

});

parcelRegister("c9Ur7", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

parcelRegister("bJYvM", function(module, exports) {

$parcel$export(module.exports, "VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE", () => $def0ba677e839891$export$416a2d57dd33ec31);
$parcel$export(module.exports, "HANDLED_STATUS_CODES", () => $def0ba677e839891$export$ad73a344b1bd5415);
const $def0ba677e839891$export$416a2d57dd33ec31 = {
    experience: 'viewHorizontalNavigation',
    analyticsSource: 'jiraHorizontalNav'
};
const $def0ba677e839891$export$ad73a344b1bd5415 = [
    401,
    403,
    404
];

});

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';

parcelRegister("aMlsI", function(module, exports) {

$parcel$export(module.exports, "useHandleError", () => $22caae009dceffc3$export$7ab84fea33af0d21);

var $5uXOq = parcelRequire("5uXOq");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jcw0u = parcelRequire("jcw0u");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $pa9q9 = parcelRequire("pa9q9");

var $2DNQF = parcelRequire("2DNQF");

var $bJYvM = parcelRequire("bJYvM");
const $22caae009dceffc3$export$7ab84fea33af0d21 = ()=>{
    const abortExperience = (0, $8dXDG.useExperienceAbort)((0, $bJYvM.VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE));
    const failExperience = (0, $93jKl.useExperienceFail)((0, $bJYvM.VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE));
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        const statusCode = error && 'statusCode' in error ? Number(error.statusCode) : 0;
        const flagDetails = (0, $2DNQF.getFlagDetails)(statusCode);
        (0, $pa9q9.showFlag)(flagDetails);
        if ((0, $bJYvM.HANDLED_STATUS_CODES).includes(statusCode)) {
            abortExperience('handled client side error');
            return;
        }
        failExperience('loading horizontal navigation failed', error);
        // only fire error analytics for non-handled query errors
        if (error instanceof (0, $c9Ur7.QueryError)) (0, $jcw0u.default)({
            meta: {
                id: 'jiraHorizontalNavigationQuery',
                packageName: 'jiraHorizontalNav',
                teamName: 'jira-cosmos'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        abortExperience,
        failExperience
    ]);
    return {
        handleError: handleError
    };
};

});
parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("2DNQF", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $5738a7896cb026e3$export$e0141c03826f0c2c);

var $8piKN = parcelRequire("8piKN");
const $5738a7896cb026e3$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $8piKN.default).defaultErrorTitle,
    description: (0, $8piKN.default).defaultErrorMessage,
    messageId: 'horizontal-nav-common.common.get-flag-details.default-error-flag.error.error.default-error-flag',
    messageType: 'transactional'
};
const $5738a7896cb026e3$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $8piKN.default).unauthenticatedUserErrorTitle,
                description: (0, $8piKN.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.401',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $8piKN.default).unauthorizedUserErrorTitle,
                description: (0, $8piKN.default).unauthorizedUserErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.403',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $8piKN.default).projectNotFoundErrorTitle,
                description: (0, $8piKN.default).projectNotFoundErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.404',
                messageType: 'transactional'
            };
        default:
            return $5738a7896cb026e3$var$DEFAULT_ERROR_FLAG;
    }
};

});
parcelRegister("8piKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $61798863c2faac20$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61798863c2faac20$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    defaultErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.default-error-message",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    defaultErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.default-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    unauthorizedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-title",
        "defaultMessage": "You don't have permission"
    },
    unauthorizedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-message",
        "defaultMessage": "You don't have permission to view this project."
    },
    projectNotFoundErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-title",
        "defaultMessage": "Project not found"
    },
    projectNotFoundErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-message",
        "defaultMessage": "The project might have been deleted or you don't have permission."
    }
});

});



parcelRegister("7UhxN", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $799685b63be28a3b$export$47d387d66bf16cb);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iEUaw = parcelRequire("iEUaw");

var $324W5 = parcelRequire("324W5");

var $5hv0u = parcelRequire("5hv0u");

var $89Akw = parcelRequire("89Akw");
const $799685b63be28a3b$var$transformShortcutsMemo = (0, $8QpSo.default)((a, b)=>(0, $89Akw.transformShortcuts)(a, b));
const $799685b63be28a3b$var$emptyData = [];
const $799685b63be28a3b$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $5hv0u.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $iEUaw.staticSidebarShortcutsResource), customContext);
    const items = (0, $5uXOq.useMemo)(()=>data && $799685b63be28a3b$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $799685b63be28a3b$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5hv0u", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $e888d8394c5baf80$export$cf4f3a9f01fdc8a7);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $dhuBw = parcelRequire("dhuBw");
const $e888d8394c5baf80$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    return (0, $5uXOq.useMemo)(()=>data && (0, $dhuBw.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("dhuBw", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $050e711b4fac24d4$export$c64b03ccce2c3de);
const $050e711b4fac24d4$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $050e711b4fac24d4$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("89Akw", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $c195049077f99f76$export$1fc4378e3ea910d0);
const $c195049077f99f76$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $c195049077f99f76$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $c195049077f99f76$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("k1ALc", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $6885b5bf730cd03e$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $6885b5bf730cd03e$export$2c1990af0fa688a3);

var $5uXOq = parcelRequire("5uXOq");

var $6P0Kj = parcelRequire("6P0Kj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4bqWq = parcelRequire("4bqWq");
const $6885b5bf730cd03e$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $6885b5bf730cd03e$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $6885b5bf730cd03e$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $6885b5bf730cd03e$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $4bqWq.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $6885b5bf730cd03e$export$e324594224ef24da = {
    addItem: $6885b5bf730cd03e$export$fb9705de59d96855,
    deleteItem: $6885b5bf730cd03e$export$8d8542dbbc23fe1a,
    editItem: $6885b5bf730cd03e$export$60832f4899fbf6a1,
    editItems: $6885b5bf730cd03e$export$8c896bccb18e1db1,
    updateContainer: $6885b5bf730cd03e$export$ed2a7beca2c9674
};
const $6885b5bf730cd03e$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $6885b5bf730cd03e$var$Store = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: $6885b5bf730cd03e$export$d4c72bab9d6cc13a,
    actions: $6885b5bf730cd03e$export$e324594224ef24da
});
var $6885b5bf730cd03e$export$2e2bcd8739ae039 = $6885b5bf730cd03e$var$Store;
const $6885b5bf730cd03e$export$df449cf702d8e0fd = (0, $gg7kZ.createContainer)($6885b5bf730cd03e$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $6885b5bf730cd03e$export$2c1990af0fa688a3 = (0, $3sQ5x.createHook)($6885b5bf730cd03e$var$Store);

});
parcelRegister("4bqWq", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $5f237ed4c010c05c$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $32ra4 = parcelRequire("32ra4");

var $a8Wzb = parcelRequire("a8Wzb");

var $h6M2t = parcelRequire("h6M2t");
const $5f237ed4c010c05c$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $5f237ed4c010c05c$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6M2t.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $5f237ed4c010c05c$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $5f237ed4c010c05c$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($32ra4));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8Wzb));
    }
};
const $5f237ed4c010c05c$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($5f237ed4c010c05c$var$getLinkParts(linkId));
const $5f237ed4c010c05c$export$d37d2882f5261346 = (linkId)=>linkId;
const $5f237ed4c010c05c$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($5f237ed4c010c05c$var$getLinkParts(linkId)).join('.');
const $5f237ed4c010c05c$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $5f237ed4c010c05c$export$3cec694c50bc695d(linkId);
    const shortcutType = $5f237ed4c010c05c$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $5f237ed4c010c05c$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("ixUGT", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $d80748aee2c24c33$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $dM3Z8(array, 0, -1) : [];
}
module.exports = $d80748aee2c24c33$var$initial;

});

parcelRegister("32ra4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2366a0b0419b8fbf$var$_react = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $2366a0b0419b8fbf$var$_angleBrackets = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("elXz8")));
function $2366a0b0419b8fbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2366a0b0419b8fbf$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $2366a0b0419b8fbf$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $2366a0b0419b8fbf$var$_angleBrackets.default
    }));
$2366a0b0419b8fbf$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $2366a0b0419b8fbf$var$_default = module.exports.default = $2366a0b0419b8fbf$var$BitbucketReposIcon;

});
parcelRegister("elXz8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7313b5c9f1080d6$var$_react = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a7313b5c9f1080d6$var$_baseNew = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a7313b5c9f1080d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7313b5c9f1080d6$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $a7313b5c9f1080d6$var$_react.default.createElement($a7313b5c9f1080d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$a7313b5c9f1080d6$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $a7313b5c9f1080d6$var$_default = module.exports.default = $a7313b5c9f1080d6$var$AngleBracketsIcon;

});


parcelRegister("h6M2t", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $8d4219c64b075729$export$5fc1066e677788d4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $8d4219c64b075729$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $8d4219c64b075729$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $8d4219c64b075729$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



const $5da7873a71c45b64$export$fe791c4fa892e400 = 'project';
const $5da7873a71c45b64$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $3TR0I.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("iqMDF", function(module, exports) {

$parcel$export(module.exports, "ContainerNavigationTabs", () => $2073bb46d233bc8a$export$90f95fd237a475b3);

var $g1Isn = parcelRequire("g1Isn");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $Pxnvj = parcelRequire("Pxnvj");

var $lODMY = parcelRequire("lODMY");
var $lVJAU = parcelRequire("lVJAU");

var $goodq = parcelRequire("goodq");

var $7KMzu = parcelRequire("7KMzu");
var $6bvKu = parcelRequire("6bvKu");

var $7z86O = parcelRequire("7z86O");

var $bYbah = parcelRequire("bYbah");

var $cUcEa = parcelRequire("cUcEa");

var $fFClA = parcelRequire("fFClA");

var $5QXyw = parcelRequire("5QXyw");
const $2073bb46d233bc8a$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);
/**
 * The logic in this hook determines the selected tab in the horizontal navigation and
 * redirects the user to the not found page if the selected tab is not found.
 *
 * There are a few caveats to this logic:
 * - We do not want to redirect to the not found page if the user is on the browse page.
 * - We do not want to redirect to the not found page if the user just removed the tab
 *   they were on and redirection to the default tab is yet to happen.
 *
 * For this reason, we only recalculate the selected tab id when the route or the navigation container has changed.
 */ const $2073bb46d233bc8a$var$useSelectedTabId = (containerData)=>{
    const prevUrl = (0, $5uXOq.useRef)(null);
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const location = $2073bb46d233bc8a$export$45d76561a5302f2b();
    const currentUrl = location.pathname + location.search;
    const selectedTabIdRef = (0, $5uXOq.useRef)(null);
    const notFoundUrl = `${containerData.scopeUrl}/not-found`;
    // if the current URL or the container has changed, reset the selected tab id
    if (prevUrl.current !== currentUrl) {
        selectedTabIdRef.current = null;
        prevUrl.current = currentUrl;
    }
    // if the selected tab id hasn't been set yet, try to find it
    if (selectedTabIdRef.current == null && containerData?.navigationItems?.edges && location.pathname !== notFoundUrl) {
        let fullMatchResult = null;
        let partialMatchResult = null;
        const sortedItems = containerData.navigationItems.edges.flatMap((edge)=>{
            const url = edge?.node.url;
            if (!url) return [];
            const id = edge.node.id;
            const item = {
                url: url,
                id: id
            };
            // consider URLs of nested apps
            if (edge.node.typeKey === 'APP') {
                const sections = edge.node.sections;
                if (sections) {
                    const appItems = [];
                    sections.forEach((section)=>{
                        section?.links?.forEach((link)=>{
                            if (link?.url) appItems.push({
                                url: link.url,
                                id: id
                            });
                        });
                    });
                    return [
                        item,
                        ...appItems
                    ];
                }
            }
            return item;
        }).sort((a, b)=>{
            if (!a.url || !b.url) return 0;
            return a.url.length - b.url.length;
        });
        const legacySelectedItem = new URLSearchParams(location.search).get('selectedItem');
        // check for matches of the tab url with the current url
        for (const item of sortedItems){
            // in case of legacy pages, we only check for the selectedItem query param
            if (legacySelectedItem) {
                const itemQueryParams = new URLSearchParams(item.url.split('?')[1]);
                if (itemQueryParams.get('selectedItem') === legacySelectedItem) {
                    fullMatchResult = item.id;
                    break;
                }
                continue;
            }
            // if the url is a full match, return straight away
            if (item.url === currentUrl) {
                fullMatchResult = item.id;
                break;
            }
            // if the start of the path matches, store the id and continue checking
            if (item.url && currentUrl.startsWith(item.url)) partialMatchResult = item.id;
        }
        selectedTabIdRef.current = fullMatchResult ?? partialMatchResult;
    }
    const selectedTabId = selectedTabIdRef.current;
    const shouldRedirectToNotFound = !selectedTabId && location.pathname !== notFoundUrl && !location.pathname.startsWith('/browse/');
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRedirectToNotFound) replace(notFoundUrl);
    }, [
        shouldRedirectToNotFound,
        notFoundUrl,
        replace
    ]);
    return selectedTabId;
};
const $2073bb46d233bc8a$export$90f95fd237a475b3 = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, label: label })=>{
    const [itemWithRename, setItemWithRename] = (0, $5uXOq.useState)(null);
    const tabListRef = (0, $5uXOq.useRef)(null);
    const containerData = (0, $8Uumt.useFragment)((0, $g1Isn.default), containerFragment);
    const selectedTabId = $2073bb46d233bc8a$var$useSelectedTabId(containerData);
    const onAddItem = (0, $5uXOq.useCallback)(({ id: id, typeKey: typeKey })=>{
        if (typeKey === 'APP' || !containerData?.navigationItems?.edges) // ignore apps
        return;
        // check whether there is already a tab with the same typeKey
        const hasItemOfType = containerData.navigationItems.edges.some((edge)=>edge?.node.typeKey === typeKey);
        // if an item with the same typeKey already exists, trigger the rename form for it
        if (hasItemOfType) setItemWithRename(id);
    }, [
        containerData?.navigationItems?.edges
    ]);
    const { tabsAndIds: tabsAndIds, droppableTabs: droppableTabs } = (0, $5uXOq.useMemo)(()=>{
        const tabs = Array.from(containerData?.navigationItems?.edges ?? []).filter(Boolean);
        const tabElements = tabs?.map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QXyw.NavigationItemTab), {
                key: edge.node.id,
                position: index,
                tabFragment: edge.node,
                containerFragment: containerData,
                beforeItemId: index === 0 ? null : tabs[index - 1]?.node?.id,
                afterItemId: index === tabs.length - 1 ? null : tabs[index + 1]?.node?.id,
                tabsDescriptor: tabsDescriptor,
                isRenaming: edge.node.id === itemWithRename,
                onRenamingChange: (isRenaming)=>setItemWithRename(isRenaming ? edge.node.id : null)
            }));
        return {
            tabsAndIds: tabs?.map((edge, index)=>({
                    id: edge?.node?.id,
                    tab: tabElements[index]
                })) ?? [],
            droppableTabs: tabs.map((tab)=>({
                    id: tab.node.id,
                    typeKey: tab.node.typeKey,
                    appId: tab.node.appId,
                    dataId: tab.node.__id
                }))
        };
    }, [
        containerData,
        itemWithRename,
        tabsDescriptor
    ]);
    (0, $fFClA.useDroppableTabList)(droppableTabs, containerData.id ?? '', containerData.scopeId ?? '');
    const projectNavigationId = (0, $7KMzu.usePrefixedUID)();
    (0, $6bvKu.useSkipLink)(projectNavigationId, label, 3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYbah.TabShortcutsContextProvider), {
        navigationName: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goodq.TabListWithAnalytics), {
        id: projectNavigationId,
        ref: tabListRef,
        label: label,
        addTab: containerData.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
            name: "container-navigation-tabs-add-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7z86O.default), {
            containerFragment: containerData,
            tabsDescriptor: tabsDescriptor,
            onAddItem: onAddItem
        })),
        selectedTabId: selectedTabId,
        tabs: tabsAndIds
    }), containerData.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUcEa.SavedViewsOnboardingInitializer), null));
};

});
parcelRegister("g1Isn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f3a7d8a6d923ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9474c50d6dcef05bf6e97ec35f61d531>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4f3a7d8a6d923ba$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "ContainerNavigationTabs_container",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "NavigationItemTab_container"
            },
            {
                "kind": "FragmentSpread",
                "name": "AddTab_container"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        "action": "THROW",
                        "path": "canEdit"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "navigationItems.edges.node.id"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "NavigationItemTab_tab"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "navigationItems.edges.node"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraContainerNavigation"
            }
        ],
        "type": "JiraContainerNavigationResult",
        "abstractKey": "__isJiraContainerNavigationResult"
    };
}();
$f4f3a7d8a6d923ba$var$node.hash = "109e1b7e3cf26fe989509a4a6ab41afc";
var $f4f3a7d8a6d923ba$export$2e2bcd8739ae039 = $f4f3a7d8a6d923ba$var$node;

});

parcelRegister("goodq", function(module, exports) {

$parcel$export(module.exports, "TabListWithAnalytics", () => $e8ac0b46fbab5182$export$3bb2a319997eb2f8);

var $5uXOq = parcelRequire("5uXOq");

var $byTKd = parcelRequire("byTKd");




var $3F9p6 = parcelRequire("3F9p6");

var $fy9q4 = parcelRequire("fy9q4");

var $6Lyip = parcelRequire("6Lyip");

var $5NM6P = parcelRequire("5NM6P");
const $e8ac0b46fbab5182$export$3bb2a319997eb2f8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ addTab: addTab, id: id, label: label, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalyticsWithContext)({
        itemType: 'more',
        navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
        stage: (0, $3F9p6.getNav4Rollout)().stage,
        navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
        navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
        isInMore: false
    });
    const onMoreClick = (0, $5uXOq.useCallback)(({ overflowingTabCount: overflowingTabCount })=>{
        triggerAnalytics({
            childCount: overflowingTabCount
        });
    }, [
        triggerAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).TAB_NAV_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fy9q4.default), {
        addTab: addTab,
        id: id,
        label: label,
        onMoreClick: onMoreClick,
        ref: ref,
        selectedTabId: selectedTabId,
        tabs: tabs
    }));
});

});
parcelRegister("byTKd", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalyticsWithContext", () => $5d900e51da8fced2$export$38dbad9cfa07995);
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $5d900e51da8fced2$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $5d900e51da8fced2$export$38dbad9cfa07995 = (analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((context)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        const { childCount: childCount } = context ?? {};
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectNavigationTab', {
            ...analytics,
            childCount: childCount ?? analytics.childCount
        });
    }, [
        analytics,
        createAnalyticsEvent
    ]);
};
const $5d900e51da8fced2$export$444d136efe970fd3 = (analytics)=>{
    const triggerAnalytics = $5d900e51da8fced2$export$38dbad9cfa07995(analytics);
    return (0, $5uXOq.useCallback)(()=>{
        triggerAnalytics();
    }, [
        triggerAnalytics
    ]);
};

});

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7qZOo = parcelRequire("7qZOo");

var $hUCm2 = parcelRequire("hUCm2");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");

var $laQnH = parcelRequire("laQnH");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_existing-customers'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_sandboxes'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, $laQnH.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("hUCm2", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9);

var $1i1R1 = parcelRequire("1i1R1");
const $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        };

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1i1R1 = parcelRequire("1i1R1");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
    });

});

parcelRegister("laQnH", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $8c7cc40a2449f7a7$export$99bed161b1040362);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $1i1R1 = parcelRequire("1i1R1");

var $7qZOo = parcelRequire("7qZOo");
const $8c7cc40a2449f7a7$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptOut: (0, $1i1R1.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptIn: (0, $1i1R1.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("fy9q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4fac1e49144922$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $3Du7S = parcelRequire("3Du7S");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");


var $aHd4d = parcelRequire("aHd4d");

var $giq95 = parcelRequire("giq95");

var $bOBpO = parcelRequire("bOBpO");

var $iDpaq = parcelRequire("iDpaq");

var $OQqsD = parcelRequire("OQqsD");
const $3b4fac1e49144922$var$calculateOverflowTabs = (tabContainer, showMoreButton, selectedTabIndex)=>{
    const TAB_GAP_VALUE = (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? (0, $b99d1770e7224860$export$b61e6f89a9db76de) : (0, $b99d1770e7224860$export$6e51fff3d6bf4e8a);
    const overflowTabs = new Set();
    if (tabContainer.current == null) return overflowTabs;
    // All the tabs fit in the container, no need to calculate overflow.
    if (tabContainer.current.scrollWidth <= tabContainer.current.offsetWidth) return overflowTabs;
    // Show the more button as it takes up space in the tab list. This ensures we
    // calculate the tab container width correctly below.
    const resetMoreButtonStyles = showMoreButton();
    // Calculate the tab container width by subtracting padding from the tab container offset width.
    const tabContainerComputedStyle = window.getComputedStyle(tabContainer.current);
    const tabContainerPadding = parseFloat(tabContainerComputedStyle.paddingLeft) + parseFloat(tabContainerComputedStyle.paddingRight);
    const tabContainerWidth = tabContainer.current.offsetWidth - tabContainerPadding;
    const tabs = tabContainer.current.children;
    const selectedTabWidth = tabs[selectedTabIndex]?.offsetWidth || 0;
    const selectedTabGap = selectedTabIndex === -1 ? 0 : TAB_GAP_VALUE;
    const availableWidth = tabContainerWidth - selectedTabWidth - selectedTabGap;
    let tabsWidth = 0;
    let gapCount = 0;
    for(let i = 0; i < tabs.length; i++){
        // Skip the selected tab, as it should always be visible. Its width and gap are already accounted for above.
        if (i === selectedTabIndex) continue;
        tabsWidth += tabs[i].offsetWidth;
        if (tabsWidth > availableWidth - TAB_GAP_VALUE * gapCount) overflowTabs.add(i);
        gapCount++;
    }
    resetMoreButtonStyles();
    return overflowTabs;
};
const $3b4fac1e49144922$var$initialOverflowState = {
    mustRecalculateOverflowTabs: false,
    overflowTabs: new Set()
};
const $3b4fac1e49144922$var$overflowReducer = (state, action)=>{
    switch(action.type){
        case 'SET_MUST_RECALCULATE':
            return {
                ...state,
                mustRecalculateOverflowTabs: true,
                overflowTabs: new Set()
            };
        case 'SET_OVERFLOW_TABS':
            return {
                ...state,
                mustRecalculateOverflowTabs: false,
                overflowTabs: action.payload
            };
        default:
            return state;
    }
};
const $3b4fac1e49144922$var$TabList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ addTab: addTab, id: id, label: label, onMoreClick: onMoreClick, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const navRef = (0, $5uXOq.useRef)(null);
    const internalTabContainerRef = (0, $5uXOq.useRef)(null);
    const tabContainerRef = (0, $3Du7S.useMergeRefs)([
        ref,
        internalTabContainerRef
    ]);
    const moreButtonWrapperRef = (0, $5uXOq.useRef)(null);
    const [{ mustRecalculateOverflowTabs: mustRecalculateOverflowTabs, overflowTabs: overflowTabs }, dispatch] = (0, $5uXOq.useReducer)($3b4fac1e49144922$var$overflowReducer, $3b4fac1e49144922$var$initialOverflowState);
    const selectedTabIndex = tabs.findIndex(({ id: id })=>id === selectedTabId);
    const overflowingTabCount = overflowTabs.size;
    const hasOverflowTabs = overflowingTabCount > 0;
    const debouncedCalculateOverflowTabs = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            dispatch({
                type: 'SET_MUST_RECALCULATE'
            });
        }, 300, {
            leading: true
        }), []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        debouncedCalculateOverflowTabs();
    }, [
        debouncedCalculateOverflowTabs,
        selectedTabId,
        tabs
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (mustRecalculateOverflowTabs) {
            const showMoreButton = ()=>{
                if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.style.display = 'block';
                return ()=>{
                    if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.removeAttribute('style');
                };
            };
            dispatch({
                type: 'SET_OVERFLOW_TABS',
                payload: $3b4fac1e49144922$var$calculateOverflowTabs(internalTabContainerRef, showMoreButton, selectedTabIndex)
            });
        }
    }, [
        mustRecalculateOverflowTabs,
        selectedTabIndex
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const resizeObserver = new ResizeObserver(debouncedCalculateOverflowTabs);
        if (navRef.current) resizeObserver.observe(navRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        debouncedCalculateOverflowTabs
    ]);
    const onMoreTabClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen((prev)=>!prev);
        if (onMoreClick) onMoreClick({
            overflowingTabCount: overflowingTabCount
        });
    }, [
        onMoreClick,
        overflowingTabCount
    ]);
    const { overflowingTabs: overflowingTabs, visibleTabs: visibleTabs } = (0, $5uXOq.useMemo)(()=>{
        const visibleTabs = [];
        const overflowingTabs = [];
        tabs.forEach(({ tab: tab, id: id }, index)=>{
            const tabContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aHd4d.TabProvider), {
                id: id,
                isOverflowing: overflowTabs.has(index),
                isSelected: id === selectedTabId,
                children: tab
            }, id);
            if (overflowTabs.has(index)) overflowingTabs.push(tabContent);
            else visibleTabs.push(tabContent);
        });
        return {
            overflowingTabs: overflowingTabs,
            visibleTabs: visibleTabs
        };
    }, [
        overflowTabs,
        selectedTabId,
        tabs
    ]);
    const closeMore = (0, $5uXOq.useCallback)(()=>setIsMoreOpen(false), []);
    const renderPopupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iDpaq.MoreMenuContents), {
            close: closeMore,
            selectedTabId: selectedTabId,
            children: overflowingTabs
        });
    }, [
        closeMore,
        overflowingTabs,
        selectedTabId
    ]);
    const renderPopupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: moreButtonWrapperRef,
            className: (0, $bwpsq.default)([
                $3b4fac1e49144922$var$styles.moreButtonWrapper,
                !hasOverflowTabs && $3b4fac1e49144922$var$styles.moreButtonWrapperHidden
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OQqsD.MoreTrigger), {
                onClick: onMoreTabClick,
                count: overflowingTabCount,
                ...triggerProps,
                isOpen: isMoreOpen
            })
        }), [
        hasOverflowTabs,
        isMoreOpen,
        onMoreTabClick,
        overflowingTabCount
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $giq95.default), {
        id: id,
        ref: navRef,
        label: label,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOBpO.default), {
                ref: tabContainerRef,
                children: visibleTabs
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                content: renderPopupContent,
                isOpen: isMoreOpen,
                onClose: closeMore,
                placement: "bottom-end",
                testId: "navigation-kit-ui-tab-list.ui.more-popup",
                trigger: renderPopupTrigger
            }),
            addTab && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $3b4fac1e49144922$var$styles.addTabWrapper,
                    (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $3b4fac1e49144922$var$styles.addTabWrapperWithPadding
                ]),
                children: addTab
            })
        ]
    });
});
const $3b4fac1e49144922$var$styles = {
    addTabWrapper: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw",
    addTabWrapperWithPadding: "_1rjc1b66",
    moreButtonWrapper: "_16jlidpf _1o9zidpf _i0dl1wug",
    moreButtonWrapperHidden: "_1e0cglyw"
};
var $3b4fac1e49144922$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3b4fac1e49144922$var$TabList);

});
const $b99d1770e7224860$export$4e0ee83a0c7b54a2 = 2;
const $b99d1770e7224860$export$d1b9ea3245b6a5de = 3;
const $b99d1770e7224860$export$d07bba395c9390f1 = 32;
const $b99d1770e7224860$export$29911ec08ab2ca2d = 5;
const $b99d1770e7224860$export$6e51fff3d6bf4e8a = 12;
const $b99d1770e7224860$export$b61e6f89a9db76de = 4;
const $b99d1770e7224860$export$7fd2e391116c6ef5 = 9;
const $b99d1770e7224860$export$e1633e494d305bfb = 'MORE';
const $b99d1770e7224860$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $b99d1770e7224860$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $b99d1770e7224860$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $b99d1770e7224860$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $b99d1770e7224860$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $b99d1770e7224860$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $b99d1770e7224860$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $b99d1770e7224860$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $b99d1770e7224860$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $b99d1770e7224860$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("aHd4d", function(module, exports) {

$parcel$export(module.exports, "TabProvider", () => $6d192c6bb7aa1da3$export$c0b2172d40e0c73a);
$parcel$export(module.exports, "useTabId", () => $6d192c6bb7aa1da3$export$911531f343f02bcc);
$parcel$export(module.exports, "useIsTabOverflowing", () => $6d192c6bb7aa1da3$export$216050693e50d04b);
$parcel$export(module.exports, "useIsTabSelected", () => $6d192c6bb7aa1da3$export$fa88b0450f456017);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $6d192c6bb7aa1da3$var$TabContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6d192c6bb7aa1da3$export$c0b2172d40e0c73a = ({ children: children, id: id, isOverflowing: isOverflowing, isSelected: isSelected })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            id: id,
            isOverflowing: isOverflowing,
            isSelected: isSelected
        }), [
        id,
        isOverflowing,
        isSelected
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6d192c6bb7aa1da3$var$TabContext.Provider, {
        value: value,
        children: children
    });
};
const $6d192c6bb7aa1da3$var$useTab = ()=>{
    const context = (0, $5uXOq.useContext)($6d192c6bb7aa1da3$var$TabContext);
    if (!context) throw new Error('useTab must be used within a TabProvider');
    return context;
};
const $6d192c6bb7aa1da3$export$911531f343f02bcc = ()=>{
    const { id: id } = $6d192c6bb7aa1da3$var$useTab();
    return id;
};
const $6d192c6bb7aa1da3$export$216050693e50d04b = ()=>{
    const { isOverflowing: isOverflowing } = $6d192c6bb7aa1da3$var$useTab();
    return isOverflowing;
};
const $6d192c6bb7aa1da3$export$fa88b0450f456017 = ()=>{
    const { isSelected: isSelected } = $6d192c6bb7aa1da3$var$useTab();
    return isSelected;
};

});

parcelRegister("giq95", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ee6b23f48c2d8c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $88ee6b23f48c2d8c$var$ResponsiveNav = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, label: label, id: id }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: ref,
        id: id,
        className: (0, $bwpsq.default)([
            $88ee6b23f48c2d8c$var$styles.root,
            (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $88ee6b23f48c2d8c$var$styles.smallerDividerLine,
            (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $88ee6b23f48c2d8c$var$styles.new
        ]),
        children: children
    }));
const $88ee6b23f48c2d8c$var$styles = {
    root: "_zulp1crf _1e0c1txw _kqswh2mm _1ul9idpf _19bv1ejb _u5f31ejb _1s6km7gv _1kt9b3bt _1cs8stnw _19woidpf _kfgtv77o _qnecidpf _oounidpf",
    smallerDividerLine: "_kfgtt94y",
    new: "_zulp1y44 _19bvpxbi _u5f3pxbi"
};
var $88ee6b23f48c2d8c$export$2e2bcd8739ae039 = $88ee6b23f48c2d8c$var$ResponsiveNav;

});

parcelRegister("bOBpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b7745c94d42589$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $16b7745c94d42589$var$TabWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            $16b7745c94d42589$var$styles.root,
            (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $16b7745c94d42589$var$styles.new
        ]),
        children: children
    }));
const $16b7745c94d42589$var$styles = {
    root: "_zulp1crf _1reo15vq _18m915vq _vchhusvi _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _otyrze3t _18u0xmi2 _2hwxxmi2 _19pkze3t _n3tdze3t _19bvutpp _u5f3utpp _ca0qze3t",
    new: "_zulp1y44"
};
var $16b7745c94d42589$export$2e2bcd8739ae039 = $16b7745c94d42589$var$TabWrapper;

});

parcelRegister("iDpaq", function(module, exports) {

$parcel$export(module.exports, "MoreMenuContents", () => $1e0abf1950095e67$export$acf06d2aac619450);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kUSGs = parcelRequire("kUSGs");
const $1e0abf1950095e67$export$acf06d2aac619450 = ({ children: children, close: close, selectedTabId: selectedTabId })=>{
    const menuContentsRef = (0, $5uXOq.useRef)(null);
    const previousSelectedTabId = (0, $5uXOq.useRef)(selectedTabId);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedTabId !== previousSelectedTabId.current && close) close();
        else previousSelectedTabId.current = selectedTabId;
    }, [
        selectedTabId,
        close
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!menuContentsRef.current) return;
        (0, $kUSGs.autoScrollForElements)({
            element: menuContentsRef.current
        });
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: menuContentsRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: (0, $bwpsq.default)([
            "_1rjct94y _c71lyly2 _18m91wug"
        ]),
        children: children
    });
};
const $1e0abf1950095e67$var$moreMenuContentsStyles = null;

});
parcelRegister("kUSGs", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $6bf6c721298921df$export$4b66ee8317094cdb);

var $4nayr = parcelRequire("4nayr");

var $8m7FJ = parcelRequire("8m7FJ");
const $6bf6c721298921df$var$api = (0, $8m7FJ.makeApi)({
    monitor: (0, $4nayr.monitorForElements)
});
const $6bf6c721298921df$export$4b66ee8317094cdb = $6bf6c721298921df$var$api.autoScroll;
const $6bf6c721298921df$export$c9168f41de61f525 = $6bf6c721298921df$var$api.autoScrollWindow;

});
parcelRegister("8m7FJ", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $df654215406fce06$export$b8fa21320a811083);

var $l5MhD = parcelRequire("l5MhD");

var $MUbtE = parcelRequire("MUbtE");

var $4gWxZ = parcelRequire("4gWxZ");

var $9Q0sJ = parcelRequire("9Q0sJ");
function $df654215406fce06$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $l5MhD.combine)((0, $4gWxZ.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $9Q0sJ.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $MUbtE.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("MUbtE", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $39c2ab61af696aa1$export$5cff7ac265db316a);
parcelRequire("9aDmr");
var $cbcqZ = parcelRequire("cbcqZ");

var $k0i4w = parcelRequire("k0i4w");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $39c2ab61af696aa1$var$schedulers = new Map();
function $39c2ab61af696aa1$export$5cff7ac265db316a(monitor) {
    const scheduler = $39c2ab61af696aa1$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $39c2ab61af696aa1$var$makeScheduler(monitor);
    $39c2ab61af696aa1$var$schedulers.set(monitor, created);
    return created;
}
function $39c2ab61af696aa1$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $cbcqZ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $k0i4w.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $k0i4w.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("9aDmr", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cbcqZ")).getElementFromPointWithoutHoneypot);

var $cbcqZ = parcelRequire("cbcqZ");

});

parcelRegister("k0i4w", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $e2629d5e10987ff8$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $e2629d5e10987ff8$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $e2629d5e10987ff8$export$13ae770ed39b71ea);
const $e2629d5e10987ff8$var$ledger = new Map();
const $e2629d5e10987ff8$var$requested = new Set();
function $e2629d5e10987ff8$export$8c764c3f2fc3d2d2(element) {
    $e2629d5e10987ff8$export$1cb7cbb266b6f6fa(element);
    const entry = $e2629d5e10987ff8$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $e2629d5e10987ff8$var$ledger.set(element, fresh);
    return fresh;
}
function $e2629d5e10987ff8$export$1cb7cbb266b6f6fa(element) {
    $e2629d5e10987ff8$var$requested.add(element);
}
function $e2629d5e10987ff8$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $e2629d5e10987ff8$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $e2629d5e10987ff8$var$ledger.forEach((_, element)=>{
        if (!$e2629d5e10987ff8$var$requested.has(element)) $e2629d5e10987ff8$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $e2629d5e10987ff8$var$requested.clear();
}
function $e2629d5e10987ff8$export$13ae770ed39b71ea() {
    $e2629d5e10987ff8$var$ledger.clear();
}

});


parcelRegister("4gWxZ", function(module, exports) {

$parcel$export(module.exports, "selector", () => $f1c4ee70a11135d7$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $f1c4ee70a11135d7$export$4ec12fb57dfebd53);
const $f1c4ee70a11135d7$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $f1c4ee70a11135d7$export$aea217a45095ce11 = `[${$f1c4ee70a11135d7$export$4b152ab55cad4fd6}="true"]`;
function $f1c4ee70a11135d7$export$4ec12fb57dfebd53(element) {
    element.setAttribute($f1c4ee70a11135d7$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($f1c4ee70a11135d7$export$4b152ab55cad4fd6);
}

});

parcelRegister("9Q0sJ", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $222b2c3ce6e23b15$export$233199807749476d);

var $fUWrt = parcelRequire("fUWrt");

var $k0i4w = parcelRequire("k0i4w");

var $4gWxZ = parcelRequire("4gWxZ");

var $ac6Lo = parcelRequire("ac6Lo");
function $222b2c3ce6e23b15$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $222b2c3ce6e23b15$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$222b2c3ce6e23b15$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4gWxZ.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $222b2c3ce6e23b15$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $k0i4w.markAndGetEngagement)(element);
    const config = (0, $fUWrt.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $ac6Lo.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $222b2c3ce6e23b15$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $k0i4w.markAndGetEngagement)(element);
        const config = (0, $fUWrt.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $ac6Lo.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $222b2c3ce6e23b15$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $222b2c3ce6e23b15$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$222b2c3ce6e23b15$var$isScrollingAvailable(remainder)) return;
    $222b2c3ce6e23b15$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("fUWrt", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $b88ad23aaba96e73$export$e96028ec7ff9d079);
const $b88ad23aaba96e73$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $b88ad23aaba96e73$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $b88ad23aaba96e73$export$e96028ec7ff9d079(provided) {
    return {
        ...$b88ad23aaba96e73$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $b88ad23aaba96e73$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("ac6Lo", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $80dd99b78a801dc7$export$6cfa6dfe6898b98f);

var $dOCCq = parcelRequire("dOCCq");

var $dVbO8 = parcelRequire("dVbO8");

var $5ZJA3 = parcelRequire("5ZJA3");

var $cobHf = parcelRequire("cobHf");

var $2itzM = parcelRequire("2itzM");

var $fcgVh = parcelRequire("fcgVh");
function $80dd99b78a801dc7$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $80dd99b78a801dc7$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $80dd99b78a801dc7$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $dVbO8.edges).reduce((map, edge)=>{
        const hitbox = (0, $5ZJA3.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $dVbO8.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $2itzM.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $fcgVh.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $dOCCq.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("dOCCq", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $a1756d2ddd1d2634$export$ccd6d9407403fcad);
const $a1756d2ddd1d2634$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("dVbO8", function(module, exports) {

$parcel$export(module.exports, "edges", () => $6b1785d57f727834$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $6b1785d57f727834$export$7fc144124ccf8292);
const $6b1785d57f727834$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $6b1785d57f727834$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("5ZJA3", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $508bfab179104f0a$export$b9a449c20abb0e9);

var $24px3 = parcelRequire("24px3");

var $gvIMT = parcelRequire("gvIMT");
function $508bfab179104f0a$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $24px3.axisLookup)[axis];
        const side = (0, $gvIMT.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $508bfab179104f0a$export$b9a449c20abb0e9 = {
    top: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("24px3", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $72807107540ca29a$export$42e42cdab35a2b96);
const $72807107540ca29a$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $72807107540ca29a$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $72807107540ca29a$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $72807107540ca29a$var$vertical,
        crossAxis: $72807107540ca29a$var$horizontal
    },
    horizontal: {
        mainAxis: $72807107540ca29a$var$horizontal,
        crossAxis: $72807107540ca29a$var$vertical
    }
};

});

parcelRegister("gvIMT", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4a686423f5f596e8$export$a45c0cd714a4dbaa);
const $4a686423f5f596e8$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("cobHf", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $61b9c7ca468f8173$export$470a2ff46db8cee8);

var $24px3 = parcelRequire("24px3");

var $iMXw0 = parcelRequire("iMXw0");

var $gvIMT = parcelRequire("gvIMT");
// We want a consistent scroll speed across devices, regardless of framerate
function $61b9c7ca468f8173$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $61b9c7ca468f8173$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $24px3.axisLookup)[axis];
    const side = (0, $gvIMT.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $iMXw0.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $iMXw0.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $61b9c7ca468f8173$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $61b9c7ca468f8173$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $61b9c7ca468f8173$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $iMXw0.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $gvIMT.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("iMXw0", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $14875ee4d61bf17c$export$1a29de000a332d74);
function $14875ee4d61bf17c$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("2itzM", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $613244e96caeaa46$export$7120fdbd90bd1292);
function $613244e96caeaa46$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("fcgVh", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $8989672f56ebb0f6$export$cda7a9d4399bf2e3);
function $8989672f56ebb0f6$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});






parcelRegister("OQqsD", function(module, exports) {

$parcel$export(module.exports, "MoreTrigger", () => $2b15f60bb1dccce2$export$8220169239c5b5cd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2esxr = parcelRequire("2esxr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");


var $bX1Wg = parcelRequire("bX1Wg");
var $aHd4d = parcelRequire("aHd4d");

var $dBMyd = parcelRequire("dBMyd");
const $2b15f60bb1dccce2$var$ThemedBadge = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2esxr.default), {
        ...props,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color: `var(${(0, $b99d1770e7224860$export$cf26c31143daa350)}, ${"var(--ds-text-subtle, #44546F)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: `var(${(0, $b99d1770e7224860$export$be4d7e23cb48401e)}, ${"var(--ds-background-neutral, #091E420F)"})`
        }
    });
};
const $2b15f60bb1dccce2$export$8220169239c5b5cd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ count: count, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aHd4d.TabProvider), {
        id: (0, $b99d1770e7224860$export$e1633e494d305bfb),
        isOverflowing: false,
        isSelected: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bX1Wg.default), {
            ...rest,
            ref: ref,
            name: formatMessage((0, $dBMyd.default).moreTabWithBadge),
            type: "dropdown-trigger",
            isMoreMenu: true,
            isChevronHidden: true,
            testId: "navigation-kit-ui-tab-list.ui.more-trigger.more-tab",
            elemAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    ' ',
                    // no wrapper is required for count > 9 as the badge will always contain 9+ so will be the same width
                    count > (0, $b99d1770e7224860$export$7fd2e391116c6ef5) ? /*#__PURE__*/ (0, $2OMIu.jsx)($2b15f60bb1dccce2$var$ThemedBadge, {
                        max: (0, $b99d1770e7224860$export$7fd2e391116c6ef5),
                        children: count
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        as: "span",
                        xcss: $2b15f60bb1dccce2$var$moreDigitBadgeWrapperStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($2b15f60bb1dccce2$var$ThemedBadge, {
                            max: (0, $b99d1770e7224860$export$7fd2e391116c6ef5),
                            children: count
                        })
                    })
                ]
            })
        })
    });
});
const $2b15f60bb1dccce2$var$moreDigitBadgeWrapperStyles = (0, $2s57o.xcss)({
    display: 'flex',
    minWidth: "var(--ds-space-250, 20px)"
});

});
parcelRegister("bX1Wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeea53e7fb11b67d$export$2e2bcd8739ae039);

var $9bVbz = parcelRequire("9bVbz");

var $aHd4d = parcelRequire("aHd4d");
var $eeea53e7fb11b67d$export$2e2bcd8739ae039 = (0, $9bVbz.default);

});
parcelRegister("9bVbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1a535fde32ae12$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ar1Vw = parcelRequire("ar1Vw");

var $2fwbH = parcelRequire("2fwbH");
const $bd1a535fde32ae12$var$OuterTab = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, outerRef)=>{
    if (props.type === 'dropdown-trigger') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ar1Vw.default), {
        ...props,
        ref: outerRef
    });
    if (props.type === 'anchor' || props.type === 'router-link' || props.type === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2fwbH.default), {
        ...props,
        ref: outerRef
    });
    return null;
}));
var $bd1a535fde32ae12$export$2e2bcd8739ae039 = $bd1a535fde32ae12$var$OuterTab;

});
parcelRegister("ar1Vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec18ce6fdb40add9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Du7S = parcelRequire("3Du7S");

var $dGKFs = parcelRequire("dGKFs");

var $cwX8H = parcelRequire("cwX8H");

var $7H980 = parcelRequire("7H980");
var $2COCu = parcelRequire("2COCu");

var $5sLH0 = parcelRequire("5sLH0");

var $29qFo = parcelRequire("29qFo");

var $cZC9u = parcelRequire("cZC9u");

var $96XEk = parcelRequire("96XEk");

var $kNrCC = parcelRequire("kNrCC");

var $jHbMS = parcelRequire("jHbMS");

var $hfFM5 = parcelRequire("hfFM5");

var $7jSog = parcelRequire("7jSog");

var $6kYEN = parcelRequire("6kYEN");

var $aHd4d = parcelRequire("aHd4d");

var $edMsE = parcelRequire("edMsE");
const $ec18ce6fdb40add9$var$HeadingWhenSelected = ({ isSelected: isSelected, children: children })=>{
    /* eslint-disable-next-line @atlaskit/design-system/use-heading */ return isSelected ? /*#__PURE__*/ (0, $2OMIu.jsx)($ec18ce6fdb40add9$var$HeadingWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $ec18ce6fdb40add9$export$471d16b0e03bf864 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, isChevronHidden: isChevronHidden = false, isDraggable: isDraggable = false, isMoreMenu: isMoreMenu, isOpen: isOpen = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, ...buttonPassthroughProps }, outerRef)=>{
    const isSelected = (0, $aHd4d.useIsTabSelected)();
    const id = (0, $aHd4d.useTabId)();
    const isOverflowing = (0, $aHd4d.useIsTabOverflowing)();
    const elementRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $3Du7S.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const isActive = isOpen || isSelected;
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { closestEdge: closestEdge, isActiveDropZone: isActiveDropZone, dragState: dragState, isDragging: isDragging } = (0, $edMsE.useDraggableTabs)({
        isDragEnabled: isDraggable,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        isMoreMenu: isMoreMenu,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    const rightChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    const downChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    if (isOverflowing) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kNrCC.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isActive,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2COCu.default), {
                    component: (0, $hfFM5.RenameMenuItemComponent),
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jSog.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZC9u.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7H980.default), {
                    ...buttonPassthroughProps,
                    ref: mergedRefs,
                    onClick: onClick,
                    testId: testId,
                    "aria-current": isSelected ? 'page' : undefined,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    isSelected: isActive,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZC9u.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHbMS.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi21jfw _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNrCC.default), {
        isSelected: isActive,
        isOpen: isMenuOpen,
        hasMenu: hasMenu,
        isRenaming: isRenaming,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6kYEN.default), {
            isSelected: isActive,
            isDragging: isDragging,
            ref: mergedRefs,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": "navigation-kit-ui-tab.ui.dropdown-trigger-tab.tab-button",
                    className: (0, $bwpsq.default)([
                        "_1ul91ris",
                        isActiveDropZone && "_bfhk1af1"
                    ]),
                    children: isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        "data-delegated-focus-ring": true,
                        "data-testid": testId,
                        className: (0, $bwpsq.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                            isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                            isSelected && "_syaz1yx7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96XEk.default), {
                                elementBefore: elemBefore
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jSog.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29qFo.default), {
                                elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                    alignBlock: "center",
                                    children: [
                                        elemAfter,
                                        downChevron
                                    ]
                                }) : downChevron,
                                closestEdge: closestEdge,
                                dragState: dragState,
                                name: name
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($ec18ce6fdb40add9$var$HeadingWhenSelected, {
                        isSelected: isSelected,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
                            ...buttonPassthroughProps,
                            "data-delegated-focus-ring": true,
                            "data-testid": testId,
                            type: "button",
                            onClick: onClick,
                            "aria-current": isSelected ? 'page' : undefined,
                            className: (0, $bwpsq.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                                isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                                isSelected && "_syaz1yx7"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96XEk.default), {
                                    elementBefore: elemBefore
                                }),
                                name,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29qFo.default), {
                                    elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                        alignBlock: "center",
                                        children: [
                                            elemAfter,
                                            downChevron
                                        ]
                                    }) : downChevron,
                                    closestEdge: closestEdge,
                                    dragState: dragState,
                                    name: name
                                })
                            ]
                        })
                    })
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHbMS.default), {
                    children: renderMenu != null && renderMenu({
                        isOpen: isMenuOpen,
                        setIsOpen: setIsMenuOpen
                    })
                })
            ]
        })
    });
}));
const $ec18ce6fdb40add9$var$boxStyles = null;
const $ec18ce6fdb40add9$var$boxHighlightedStyles = null;
const $ec18ce6fdb40add9$var$currentTabLabelStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ec18ce6fdb40add9$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4n7od",
            __cmplp.className
        ])
    });
});
const $ec18ce6fdb40add9$var$tabStyles = null;
const $ec18ce6fdb40add9$var$overflowItemWrapperStyles = null;
const $ec18ce6fdb40add9$var$overflowNameWrapperStyles = null;
const $ec18ce6fdb40add9$var$actionItemsWrapperStyles = null;
/**
 * Although these variables are used in the Badge, they are defined here so they can change on tab
 * hover/focus/active states.
 */ const $ec18ce6fdb40add9$var$moreButtonBadgeStyles = null;
var $ec18ce6fdb40add9$export$2e2bcd8739ae039 = $ec18ce6fdb40add9$export$471d16b0e03bf864;

});
parcelRegister("29qFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c7be6a5b606b509$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $elaEw = parcelRequire("elaEw");

var $fHpHg = parcelRequire("fHpHg");

var $lrco3 = parcelRequire("lrco3");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");


var $acaKv = parcelRequire("acaKv");
const $9c7be6a5b606b509$var$DropIndicator = ({ closestEdge: closestEdge, testId: testId })=>(closestEdge && /*#__PURE__*/ (0, $2OMIu.jsx)($9c7be6a5b606b509$var$DropIndicatorWrapper, {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrco3.DropIndicator), {
            edge: closestEdge,
            gap: `${(0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? (0, $b99d1770e7224860$export$b61e6f89a9db76de) : (0, $b99d1770e7224860$export$6e51fff3d6bf4e8a)}px`
        })
    })) ?? null;
const $9c7be6a5b606b509$export$905ab40ac2179daa = ({ elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements.drag-preview",
        className: (0, $bwpsq.default)([
            "_zulp1b66 _h7al1vdr _1e0c1txw _4cvr1h6o _13lipd34 _qrwqpd34 _syaz1f7t _bfhk1h36 _ca0qidpf _u5f3u2gc _n3tdidpf _19bv1b66 _4t3izwfg _qdn51txw",
            !(0, $acaKv.isSafari)() && "_139e1smy"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: name
            }),
            elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $9c7be6a5b606b509$var$elemAfterContainerStyle,
                children: elemAfter
            })
        ]
    });
const $9c7be6a5b606b509$var$AfterElements = ({ elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $9c7be6a5b606b509$var$elemAfterContainerStyle,
                children: elemAfter
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($9c7be6a5b606b509$var$DropIndicator, {
                testId: "navigation-kit-ui-tab-common.ui.after-elements.drag-indicator",
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)($9c7be6a5b606b509$export$905ab40ac2179daa, {
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $9c7be6a5b606b509$var$elemAfterContainerStyle = (0, $2s57o.xcss)({
    display: 'flex'
});
const $9c7be6a5b606b509$var$tiltStyles = null;
const $9c7be6a5b606b509$var$previewStyles = null;
var $9c7be6a5b606b509$export$2e2bcd8739ae039 = $9c7be6a5b606b509$var$AfterElements;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c7be6a5b606b509$var$DropIndicatorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154i1b66 _1ltvidpf _1bsb1osq _4t3imslj _z1i310m9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lrco3", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $cc76973c2ae8fbb2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c6UJt = parcelRequire("c6UJt");

var $6Lt23 = parcelRequire("6Lt23");
function $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6UJt.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $6Lt23.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$cc76973c2ae8fbb2$export$2e2bcd8739ae039 = $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6;

});
parcelRegister("c6UJt", function(module, exports) {

$parcel$export(module.exports, "Line", () => $4187af2f62a33e74$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6Lt23 = parcelRequire("6Lt23");
const $4187af2f62a33e74$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $4187af2f62a33e74$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $4187af2f62a33e74$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $4187af2f62a33e74$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $4187af2f62a33e74$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $4187af2f62a33e74$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $6Lt23.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $6Lt23.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $4187af2f62a33e74$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $4187af2f62a33e74$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $4187af2f62a33e74$var$baseStyles.root,
            $4187af2f62a33e74$var$orientationStyles[orientation],
            $4187af2f62a33e74$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$4187af2f62a33e74$export$2e2bcd8739ae039 = $4187af2f62a33e74$export$17d680238e50603e;

});
parcelRegister("6Lt23", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $c5dbe78bd4d684b9$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $c5dbe78bd4d684b9$export$45db03aa04b685e3);
const $c5dbe78bd4d684b9$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $c5dbe78bd4d684b9$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("acaKv", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $66e47372e0b88a16$export$95df08bae54cb4df);
const $66e47372e0b88a16$export$95df08bae54cb4df = ()=>{
    if (typeof navigator !== 'undefined') /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return false;
};

});


parcelRegister("cZC9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc31f8d8bc91829a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $44qT7 = parcelRequire("44qT7");

var $lrco3 = parcelRequire("lrco3");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");


var $acaKv = parcelRequire("acaKv");
const $cc31f8d8bc91829a$var$DropIndicator = ({ closestEdge: closestEdge })=>closestEdge ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements-more-item.drag-indicator",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrco3.DropIndicator), {
            edge: closestEdge
        })
    }) : null;
const $cc31f8d8bc91829a$export$905ab40ac2179daa = ({ elemBefore: elemBefore, elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: [
            $cc31f8d8bc91829a$var$previewStyles,
            !(0, $acaKv.isSafari)() && $cc31f8d8bc91829a$var$tiltStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
            iconBefore: elemBefore,
            iconAfter: elemAfter,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: name
            })
        })
    });
const $cc31f8d8bc91829a$var$AfterElementsMoreItem = ({ elemBefore: elemBefore, elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($cc31f8d8bc91829a$var$DropIndicator, {
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)($cc31f8d8bc91829a$export$905ab40ac2179daa, {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $cc31f8d8bc91829a$var$tiltStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    rotate: `${(0, $b99d1770e7224860$export$29911ec08ab2ca2d)}deg`
});
const $cc31f8d8bc91829a$var$previewStyles = (0, $2s57o.xcss)({
    backgroundColor: 'elevation.surface'
});
var $cc31f8d8bc91829a$export$2e2bcd8739ae039 = $cc31f8d8bc91829a$var$AfterElementsMoreItem;

});

parcelRegister("96XEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0a44fe72141576$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $0a0a44fe72141576$var$BeforeTab = ({ elementBefore: elementBefore })=>elementBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
            xcss: (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $0a0a44fe72141576$var$elementBeforeStyles : $0a0a44fe72141576$var$elementBeforeStylesOld,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'var(--display-icon-before, flex)'
            },
            children: elementBefore
        })
    }) : null;
const $0a0a44fe72141576$var$elementBeforeStylesOld = (0, $2s57o.xcss)({
    inlineSize: "var(--ds-space-250, 20px)",
    blockSize: "var(--ds-space-250, 20px)",
    alignItems: 'center',
    justifyContent: 'center'
});
const $0a0a44fe72141576$var$elementBeforeStyles = (0, $2s57o.xcss)({
    inlineSize: "var(--ds-space-300, 24px)",
    blockSize: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    justifyContent: 'center'
});
var $0a0a44fe72141576$export$2e2bcd8739ae039 = $0a0a44fe72141576$var$BeforeTab;

});

parcelRegister("kNrCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8481409c7d7b1781$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $8481409c7d7b1781$var$MenuContainerWrapper = ({ isSelected: isSelected, isOpen: isOpen, hasMenu: hasMenu, children: children, isOverflowing: isOverflowing, isRenaming: isRenaming })=>{
    const [delayedIsOpen, setDelayedIsOpen] = (0, $5uXOq.useState)(isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) window.setTimeout(()=>{
            // we need the menu trigger to stick around to allow focus to return to it when it is closed
            setDelayedIsOpen(false);
        }, 500);
        else setDelayedIsOpen(true);
    }, [
        isOpen,
        setDelayedIsOpen
    ]);
    const isOpenOrDelayed = isOpen || delayedIsOpen;
    const withMenu = hasMenu && !isRenaming;
    const withPeekMenu = withMenu && (isSelected || isOverflowing);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_qdn51txw _1ifwglyw",
            withMenu && isOpen && "_qdn5glyw _1ifw1ule",
            withMenu && "_15y3glyw _1k7x1ule",
            withPeekMenu && "_1v2gglyw _y07k1ule",
            withPeekMenu && isOpenOrDelayed && "_qdn5glyw _1ifw1ule"
        ]),
        children: children
    });
};
const $8481409c7d7b1781$var$wrapperTabStyles = null;
const $8481409c7d7b1781$var$showingMenuStyles = null;
const $8481409c7d7b1781$var$focusMenuStyles = null;
const $8481409c7d7b1781$var$hoverMenuStyles = null;
var $8481409c7d7b1781$export$2e2bcd8739ae039 = $8481409c7d7b1781$var$MenuContainerWrapper;

});

parcelRegister("jHbMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c10086ed76bda8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");
const $67c10086ed76bda8$var$MenuWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c16ua",
            (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && "_2hwx1b66"
        ]),
        children: children
    });
const $67c10086ed76bda8$var$menuWrapperStyles = null;
const $67c10086ed76bda8$var$menuWrapperStylesNew = null;
var $67c10086ed76bda8$export$2e2bcd8739ae039 = $67c10086ed76bda8$var$MenuWrapper;

});

parcelRegister("hfFM5", function(module, exports) {

$parcel$export(module.exports, "RenameMenuItemComponent", () => $a2df9f2edaeb5ac8$export$26e03447880d5bba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a2df9f2edaeb5ac8$export$26e03447880d5bba = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1a37ugt7 _1cwg1i6y"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...props,
            children: children
        })
    });
const $a2df9f2edaeb5ac8$var$tabRenamingStyles = null;

});

parcelRegister("7jSog", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c263d9c7f55ffd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7folp = parcelRequire("7folp");

var $7U0eo = parcelRequire("7U0eo");
const $02c263d9c7f55ffd$var$TabRenameForm = ({ defaultValue: defaultValue, onCancel: onCancel, onConfirm: onConfirm })=>{
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const inputRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        setTimeout(()=>{
            // automatically focus and select the text of the input on mount
            inputRef.current?.focus();
            inputRef.current?.select();
        }, 0);
    }, []);
    const handleSubmitAndBlur = ()=>{
        if (value === defaultValue || value.trim() === '') {
            onCancel?.();
            return;
        }
        onConfirm?.(value.trim());
    };
    const handleChange = (e)=>{
        setValue(e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape') {
            e.stopPropagation();
            onCancel?.();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7folp.default), {
        onSubmit: handleSubmitAndBlur,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                ...formProps,
                className: (0, $bwpsq.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-value": value,
                    className: (0, $bwpsq.default)([
                        "_1e0c1n7u _4cvr1h6o _ckog1yjy _aetrzxco _uy7x15vq _1qjl1jtm"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        "aria-label": formatMessage((0, $7U0eo.default).tabNameInputLabel),
                        autoComplete: "off",
                        "data-delegated-focus-ring": true,
                        maxLength: 80,
                        name: "tab-name",
                        onBlur: handleSubmitAndBlur,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        ref: inputRef,
                        required: true,
                        /*
         * We set the size to 1 to ensure the input will not be wider than the
         * text it contains. Without this the input width will be the default width
         * based on the user agent.
         */ size: 1,
                        type: "text",
                        value: value,
                        className: (0, $bwpsq.default)([
                            "_11q7glyw _19itglyw _11c81kw7 _nd5l1yjy _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu18uv _1hms1kw7 _ajmmnqa1 _syaz1kw7 _o5721kw7 _nt751r31 _49pcglyw _1hvw1o36"
                        ])
                    })
                })
            })
    });
};
const $02c263d9c7f55ffd$var$formStyles = null;
/**
 * This allows the input to grow & shrink as the user types in it.
 * See: https://css-tricks.com/auto-growing-inputs-textareas/
 *
 * This can be replaced by the `field-sizing: content;` property when/if it
 * becomes available in browsers.
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/field-sizing
 */ const $02c263d9c7f55ffd$var$inputSizerStyles = null;
const $02c263d9c7f55ffd$var$inputStyles = null;
var $02c263d9c7f55ffd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($02c263d9c7f55ffd$var$TabRenameForm);

});
parcelRegister("7U0eo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e216489222d0e6ff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e216489222d0e6ff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tabNameInputLabel: {
        id: 'navigation-kit-ui-tab-list.tab-rename-form.tab-name-input-label',
        defaultMessage: 'Tab name',
        description: 'This text is used as aria-label text for the input element in the tab rename form'
    }
});

});


parcelRegister("6kYEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e4b97e18f365031$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");
const $7e4b97e18f365031$var$TabWrapper = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isSelected: isSelected = false, isDragging: isDragging = false }, ref)=>{
    if ((0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation')) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: ref,
            className: (0, $bwpsq.default)([
                "_2rkoiti9 _1rjc1b66 _19bv12x7 _u5f312x7 _1e0c1txw _kqswh2mm _1kz6zwfg _vchhusvi _uhwn1ris _4cvr1h6o _2lx21sbv _1cwg1i6y _y31iugt7 _ixiwstnw _1wtq12x7 _1j2w12x7 _9di1ze3t _l3ja1wug _1boqb3bt _1kmz1l7b _4tpu1yx7 _x2d61mrw",
                isDragging && "_tzy41kuy",
                isSelected && "_18postnw _19do12x7 _32rx12x7 _1x88ze3t _15l21wug _aetrb3bt _1qdg1l7b _1hfk1yx7 _1bqq1mrw"
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _1kz6zwfg _vchhusvi _uhwn1ris _4cvr1h6o _2lx21sbv _1cwg1i6y _1s1giti9 _5fbciti9 _y31iugt7 _sf7st94y _qrdit94y _a11rstnw _ixiwstnw _1g02ze3t _1wtqze3t _1uljze3t _1j2wze3t _2x5bze3t _9di1ze3t _1g681wug _l3ja1wug _1k0fb3bt _1boqb3bt _1gzyv77o _1kmzv77o _1ssi1yx7 _4tpu1yx7",
            isSelected && "_14mjt94y _18postnw _19doze3t _32rxze3t _1x88ze3t _15l21wug _aetrb3bt _1qdgv77o _1hfk1yx7",
            isDragging && "_tzy41kuy"
        ]),
        children: children
    });
}));
const $7e4b97e18f365031$var$themedUnderlineOld = null;
const $7e4b97e18f365031$var$wrapperTabStylesOld = null;
const $7e4b97e18f365031$var$wrapperTabStyles = null;
const $7e4b97e18f365031$var$selectedWrapperTabStyles = null;
/*
	This container is used to ensure that the outline is above the tab underline by creating a new stacking context
	around the tab wrapper (which has the ::after pseudo-element inside it).
*/ const $7e4b97e18f365031$var$containerStyles = null;
const $7e4b97e18f365031$var$draggingTabStyles = null;
var $7e4b97e18f365031$export$2e2bcd8739ae039 = $7e4b97e18f365031$var$TabWrapper;

});

parcelRegister("edMsE", function(module, exports) {

$parcel$export(module.exports, "useDraggableTabs", () => $d7d356e864393674$export$9fa04411e270c5cb);

var $5uXOq = parcelRequire("5uXOq");

var $8iGQq = parcelRequire("8iGQq");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");
parcelRequire("ajXww");
var $2wxnH = parcelRequire("2wxnH");
parcelRequire("7mduf");
var $kdSEN = parcelRequire("kdSEN");
function $d7d356e864393674$export$9fa04411e270c5cb({ isDragEnabled: isDragEnabled, isDropEnabled: isDropEnabled = true, position: position, id: id, handleDrag: handleDrag, isSelected: isSelected, isOverflowing: isOverflowing, isMoreMenu: isMoreMenu, elementRef: elementRef }) {
    const [isActiveDropZone, setIsActiveDropZone] = (0, $5uXOq.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        if (!element) return;
        // the more menu is configured differently,
        // and works as a single drop zone that cannot be dragged
        if (isMoreMenu) return (0, $4nayr.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab',
            getIsSticky: ()=>true,
            getData: ()=>({
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu
                }),
            onDragEnter: ()=>{
                setIsActiveDropZone(true);
            },
            onDragLeave: ()=>{
                setIsActiveDropZone(false);
            },
            onDrop: ()=>{
                setIsActiveDropZone(false);
            }
        });
        return (0, $l5MhD.combine)((0, $4nayr.draggable)({
            element: element,
            onGenerateDragPreview ({ location: location, nativeSetDragImage: nativeSetDragImage }) {
                (0, $kdSEN.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $2wxnH.preserveOffsetOnSource)({
                        element: element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'dragging'
                            });
                    }
                });
            },
            canDrag: ()=>isDragEnabled,
            onDragStart: handleDrag,
            onDrag: ()=>{
                setDragState({
                    type: 'dragging'
                });
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            },
            getInitialData () {
                return {
                    position: position,
                    id: id,
                    type: 'tab',
                    isOverflowing: isOverflowing
                };
            }
        }), (0, $4nayr.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab' && isDropEnabled,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: dataElement })=>{
                const data = {
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu,
                    isOverflowing: isOverflowing
                };
                return (0, $8iGQq.attachClosestEdge)(data, {
                    input: input,
                    element: dataElement,
                    allowedEdges: isOverflowing ? [
                        'top',
                        'bottom'
                    ] : [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge((0, $8iGQq.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ()=>{
                setClosestEdge(null);
            }
        }));
    }, [
        isDragEnabled,
        isOverflowing,
        position,
        id,
        isSelected,
        elementRef,
        handleDrag,
        isMoreMenu,
        isDropEnabled
    ]);
    const isDragging = Boolean(dragState && dragState.type === 'dragging');
    return {
        closestEdge: closestEdge,
        isActiveDropZone: isActiveDropZone,
        dragState: dragState,
        isDragging: isDragging
    };
}

});
parcelRegister("8iGQq", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $567c9724221c2374$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $567c9724221c2374$export$945a571f3b658bf);
const $567c9724221c2374$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $567c9724221c2374$var$uniqueKey = Symbol('closestEdge');
function $567c9724221c2374$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $567c9724221c2374$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$567c9724221c2374$var$uniqueKey]: addClosestEdge
    };
}
function $567c9724221c2374$export$945a571f3b658bf(userData) {
    return userData[$567c9724221c2374$var$uniqueKey] ?? null;
}

});

parcelRegister("ajXww", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("2wxnH")).preserveOffsetOnSource);

var $2wxnH = parcelRequire("2wxnH");

});
parcelRegister("2wxnH", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $4bcba9b5fd951d2c$export$8830e7ac6eee750e);
function $4bcba9b5fd951d2c$export$8830e7ac6eee750e({ element: element, input: input }) {
    return ({ container: container })=>{
        const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("7mduf", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kdSEN")).setCustomNativeDragPreview);

var $kdSEN = parcelRequire("kdSEN");

});
parcelRegister("kdSEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $320831611590d912$export$52d889c66db0f96e);

var $bAMyk = parcelRequire("bAMyk");

var $374Vm = parcelRequire("374Vm");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $320831611590d912$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $320831611590d912$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $320831611590d912$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $56611718a37028ae$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $374Vm.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $bAMyk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $56611718a37028ae$export$7d0a15ee70427305 = 2147483647;





parcelRegister("2fwbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e6b97fb3f03490$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");

var $3Du7S = parcelRequire("3Du7S");

var $2COCu = parcelRequire("2COCu");
var $44qT7 = parcelRequire("44qT7");

var $fHpHg = parcelRequire("fHpHg");

var $29qFo = parcelRequire("29qFo");

var $cZC9u = parcelRequire("cZC9u");

var $96XEk = parcelRequire("96XEk");

var $kNrCC = parcelRequire("kNrCC");

var $jHbMS = parcelRequire("jHbMS");

var $hfFM5 = parcelRequire("hfFM5");

var $7jSog = parcelRequire("7jSog");

var $6kYEN = parcelRequire("6kYEN");

var $aHd4d = parcelRequire("aHd4d");

var $edMsE = parcelRequire("edMsE");
const $a8e6b97fb3f03490$var$NonInteractiveTab = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component, children: children, isRenaming: isRenaming, isSelected: isSelected }, outerRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: isRenaming ? undefined : 0,
        ref: outerRef,
        "data-testid": "navigation-kit-ui-tab.ui.link-tab.non-interactive-tab",
        "aria-current": "page",
        "data-delegated-focus-ring": true,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
            (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && "_bozgze3t _y4ti1b66",
            isSelected && "_syaz1yx7"
        ]),
        children: children
    })));
const $a8e6b97fb3f03490$export$6a360a5612cb30b8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, href: href, isDraggable: isDraggable = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, type: type }, outerRef)=>{
    const isSelected = (0, $aHd4d.useIsTabSelected)();
    const id = (0, $aHd4d.useTabId)();
    const isOverflowing = (0, $aHd4d.useIsTabOverflowing)();
    const elementRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $3Du7S.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { closestEdge: closestEdge, dragState: dragState, isDragging: isDragging } = (0, $edMsE.useDraggableTabs)({
        isDragEnabled: isDraggable && !isRenaming,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    if (isOverflowing) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kNrCC.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isSelected,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2COCu.default), {
                    component: (0, $hfFM5.RenameMenuItemComponent),
                    iconAfter: elemAfter,
                    iconBefore: elemBefore,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jSog.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZC9u.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $44qT7.default), {
                    testId: "navigation-kit-ui-tab.ui.link-tab.link-item",
                    ref: mergedRefs,
                    href: href,
                    "aria-current": isSelected ? 'page' : undefined,
                    className: className,
                    onClick: onClick,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter,
                    isSelected: isSelected,
                    UNSAFE_isDraggable: isDraggable,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZC9u.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHbMS.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi2pxbi _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    const renderTabContent = ()=>{
        const inside = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96XEk.default), {
                    elementBefore: elemBefore
                }),
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jSog.default), {
                    defaultValue: name,
                    onCancel: onRenameCancel,
                    onConfirm: onRenameComplete
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: name
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29qFo.default), {
                    elemAfter: elemAfter,
                    closestEdge: closestEdge,
                    dragState: dragState,
                    name: name
                })
            ]
        });
        if (isSelected || isRenaming) return /*#__PURE__*/ (0, $2OMIu.jsx)($a8e6b97fb3f03490$var$NonInteractiveTab, {
            as: isRenaming ? 'div' : 'h2',
            isRenaming: Boolean(isRenaming),
            isSelected: isSelected,
            children: inside
        });
        if (type === 'anchor') return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
            href: href,
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && "_bozgze3t _y4ti1b66",
                className
            ]),
            onClick: onClick,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab.tab-anchor",
            draggable: "false",
            "data-delegated-focus-ring": true,
            children: inside
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hjSul.Link), {
            "data-delegated-focus-ring": true,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab",
            to: href,
            prefetch: "hover",
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                (0, $fHpHg.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && "_bozgze3t _y4ti1b66",
                className
            ]),
            onClick: onClick,
            draggable: "false",
            children: inside
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: mergedRefs,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNrCC.default), {
            isSelected: isSelected,
            isOpen: isMenuOpen,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6kYEN.default), {
                isSelected: isSelected,
                isDragging: isDragging,
                children: [
                    renderTabContent(),
                    hasMenu && renderMenu != null && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHbMS.default), {
                        children: renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    }, "menu")
                ]
            })
        })
    });
}));
/* eslint-enable @atlaskit/design-system/no-unsafe-style-overrides */ /* eslint-enable @atlaskit/ui-styling-standard/no-classname-prop */ const $a8e6b97fb3f03490$var$currentTabLabelStyles = null;
// merge to main styling and remove it when cleaning blu-6305_tab_item_styling_in_horizontal_navigation
const $a8e6b97fb3f03490$var$tabStylesNew = null;
const $a8e6b97fb3f03490$var$tabStyles = null;
const $a8e6b97fb3f03490$var$overflowItemWrapperStyles = null;
const $a8e6b97fb3f03490$var$overflowNameWrapperStyles = null;
const $a8e6b97fb3f03490$var$actionItemsWrapperStyles = null;
var $a8e6b97fb3f03490$export$2e2bcd8739ae039 = $a8e6b97fb3f03490$export$6a360a5612cb30b8;

});



parcelRegister("dBMyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ca7ef166f616e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b0ca7ef166f616e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreTabWithBadge: {
        id: 'navigation-kit-ui-tab-list.more-trigger.more-tab-with-badge',
        defaultMessage: 'More',
        description: 'When the navigation links do not fit on the screen we show a "More [5]" tab which is a dropdown menu containing all the tabs that do not fit in the screen.'
    }
});

});



parcelRegister("6Lyip", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $ea144642b34a7c1d$export$77e61d078c8501ca);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $4R6GH = parcelRequire("4R6GH");
function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $4R6GH.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});

parcelRegister("5NM6P", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $b94a87b237943b7f$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $b94a87b237943b7f$export$c1a4e03cc30032f5);
const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});


parcelRegister("7z86O", function(module, exports) {

$parcel$export(module.exports, "default", () => $340082cdbeafcda0$export$2e2bcd8739ae039);

var $jpNRc = parcelRequire("jpNRc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $j7m8K = parcelRequire("j7m8K");

var $7XluA = parcelRequire("7XluA");

var $47gW9 = parcelRequire("47gW9");

var $4mO32 = parcelRequire("4mO32");



var $41Jyf = parcelRequire("41Jyf");

var $4H0hX = parcelRequire("4H0hX");

var $6FtZ8 = parcelRequire("6FtZ8");
const $340082cdbeafcda0$var$AddTab = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, onAddItem: onAddItem })=>{
    const containerData = (0, $8Uumt.useFragment)((0, $jpNRc.default), containerFragment);
    const scopeId = containerData.scopeId ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const onOpenChange = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
    }, []);
    const closeMenu = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownMenuOpen(false);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6FtZ8.addTabContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            scopeId: scopeId,
            first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
        }), [
        scopeId
    ]));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const trigger = ({ isSelected: isMenuOpen, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41Jyf.default), {
            onClick: (event)=>{
                onClick && onClick(event);
            },
            isSelected: isDropdownMenuOpen,
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                typeof triggerProps.triggerRef === 'function' && triggerProps.triggerRef(element);
            },
            testId: "navigation-kit-add-tab.ui.trigger"
        });
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onAddItem: onAddItem,
            onClose: closeMenu,
            tabsDescriptor: tabsDescriptor
        }), [
        closeMenu,
        onAddItem,
        tabsDescriptor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        trigger: trigger,
        placement: "bottom-start",
        testId: "navigation-kit-add-tab.ui.dropdown-menu",
        isOpen: isDropdownMenuOpen,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $340082cdbeafcda0$var$addTabContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "navigation-kit-add-tab-content",
        packageName: "jiraNavigationKitAddTab",
        runtimeProps: runtimeProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4H0hX.LoadingSkeleton), null)
    })));
};
var $340082cdbeafcda0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($340082cdbeafcda0$var$AddTab);
const $340082cdbeafcda0$var$addTabContentWrapperStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $bd7d4a47a650a2da$export$5e641a5f03919b38)}px`
});

});
parcelRegister("jpNRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4684027da85e3e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44ed7ddeaad1fa52a71d05534d04501a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fd4684027da85e3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AddTab_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    "action": "THROW",
                    "path": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$fd4684027da85e3e$var$node.hash = "5c730fc8f652490d6ab22bf4e7225d95";
var $fd4684027da85e3e$export$2e2bcd8739ae039 = $fd4684027da85e3e$var$node;

});

const $bd7d4a47a650a2da$export$5e641a5f03919b38 = 600;
const $bd7d4a47a650a2da$export$7a5cc88a67fa13ae = 'APP';

parcelRegister("41Jyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f889fc19c0e11e12$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g16BY = parcelRequire("g16BY");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $glIsx = parcelRequire("glIsx");
const $f889fc19c0e11e12$var$AddTabTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ presentational: presentational, noTooltip: noTooltip, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        spacing: "none",
        appearance: "subtle",
        role: presentational ? 'presentation' : undefined,
        name: formatMessage((0, $glIsx.default).addTabTriggerLabel),
        ref: ref,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g16BY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $glIsx.default).addTabTriggerLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $f889fc19c0e11e12$var$boxStyles
    }, noTooltip ? button : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $glIsx.default).addTabTriggerLabel),
        hideTooltipOnMouseDown: true
    }, button));
});
var $f889fc19c0e11e12$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f889fc19c0e11e12$var$AddTabTrigger);
const $f889fc19c0e11e12$var$boxStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '0',
    position: 'relative',
    alignSelf: 'center'
});

});
parcelRegister("glIsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $260f8a50e51dfd8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $260f8a50e51dfd8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addTabTriggerLabel: {
        "id": "navigation-kit-add-tab.add-tab-trigger.add-tab-trigger-label",
        "defaultMessage": "Add to navigation"
    }
});

});


parcelRegister("4H0hX", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $094e034c84929e6f$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aOrxC = parcelRequire("aOrxC");
var $eCE62 = parcelRequire("eCE62");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

const $094e034c84929e6f$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$listSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: 280
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $094e034c84929e6f$var$detailsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$SkeletonPreview, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$SkeletonButton, null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $094e034c84929e6f$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _bfhkn82g _1bsbmgvx _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$SkeletonPreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $094e034c84929e6f$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3in0hr",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$SkeletonButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $094e034c84929e6f$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbo7ol _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$skeletonWrapperStyles = (0, $2s57o.xcss)({
    height: '100%',
    display: 'flex',
    flexDirection: 'row'
});
const $094e034c84929e6f$var$titleSkeletonWrapperStyles = (0, $2s57o.xcss)({
    height: '42px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInlineStart: 'space.250'
});
const $094e034c84929e6f$var$listSkeletonWrapperStyles = (0, $2s57o.xcss)({
    paddingBlockStart: 'space.100',
    blockSize: '100%',
    inlineSize: '280px'
});
const $094e034c84929e6f$var$detailsSkeletonWrapperStyles = (0, $2s57o.xcss)({
    alignItems: 'start',
    backgroundColor: 'elevation.surface.sunken',
    blockSize: '100%',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderInlineStartWidth: 'border.width',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200',
    inlineSize: '320px',
    justifyContent: 'start',
    padding: 'space.500'
});
const $094e034c84929e6f$var$wrapperStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    color: 'color.text',
    blockSize: '385px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $bd7d4a47a650a2da$export$5e641a5f03919b38)}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});

parcelRegister("6FtZ8", function(module, exports) {

$parcel$export(module.exports, "addTabContentEntryPoint", () => $a6d385136730113d$export$196d3b4618d24c77);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $jfvhV = parcelRequire("jfvhV");

const $a6d385136730113d$export$196d3b4618d24c77 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7VSJj")), {
        moduleId: "6cee7023",
        moduleName: "AddTabContent"
    }),
    getPreloadProps: ({ scopeId: scopeId, first: first })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $jfvhV.default),
                    variables: {
                        first: first,
                        containerNavigationInput: {
                            scopeId: scopeId
                        }
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("jfvhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $97918f10dad5c196$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a0446fac6b067110cd459141e87422a>>
 * @relayHash f84ccf2ded04668e2e31e188f70e9484
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef
const $97918f10dad5c196$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "scopeId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v9 /*: any*/ 
        ]
    }, v11 = [
        v8 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.scopeId"
                                                },
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "addableNavigationItemTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemTypeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v3 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.typeKey"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraAppNavigationItemType"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "ViewItem_item"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "appItem_horizontalNavAddTab"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "AddTabDetails_item"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.addableNavigationItemTypes.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "addableNavigationItemTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItemType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "label"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItemType"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v11 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef",
            "metadata": {},
            "name": "AddTabContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97918f10dad5c196$var$node.hash = "41079ddf0412e6da3b6d9525a2b7f747";
var $97918f10dad5c196$export$2e2bcd8739ae039 = $97918f10dad5c196$var$node;

});

parcelRegister("7VSJj", function(module, exports) {

let $5c684f7c8396fedd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c684f7c8396fedd$var$load("hPzOn"),
    $5c684f7c8396fedd$var$load("cM9em"),
    $5c684f7c8396fedd$var$load("fr9NE"),
    $5c684f7c8396fedd$var$load("8I8t1")
]).then(()=>parcelRequire('lpMzx'));

});



parcelRegister("bYbah", function(module, exports) {

$parcel$export(module.exports, "TabShortcutsContextProvider", () => $b6c13989dd8d2573$export$8b136156551d140a);
$parcel$export(module.exports, "useTabShortcuts", () => $b6c13989dd8d2573$export$4b7664145fd3fd6f);

var $5uXOq = parcelRequire("5uXOq");

var $7qDUb = parcelRequire("7qDUb");

var $3YnyA = parcelRequire("3YnyA");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $5p1kJ = parcelRequire("5p1kJ");

var $879xD = parcelRequire("879xD");

var $5SjJK = parcelRequire("5SjJK");
const $b6c13989dd8d2573$export$eb842c33bb500fce = /*#__PURE__*/ (0, $5uXOq.createContext)({
    /**
   * Registers a tab with TabShortcutsContextProvider so it can be assigned a keyboard shortcut
   * returns a function to deregister.
   */ // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    registerTab: (_)=>()=>{}
});
const $b6c13989dd8d2573$export$8b136156551d140a = ({ navigationName: navigationName, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [rawTabs, setRawTabs] = (0, $5uXOq.useState)([]);
    const registerTab = (0, $5uXOq.useCallback)((newTab)=>{
        setRawTabs((existingTabs)=>[
                ...existingTabs,
                newTab
            ]);
        return ()=>{
            setRawTabs((existingTabs)=>existingTabs.filter((tab)=>tab.index !== newTab.index));
        };
    }, [
        setRawTabs
    ]);
    /**
   * Generate a keyMap from the rawTabs. The tabs may be out of order, and there may be gaps in the index (some tabs will return null before they get to register)
   * so we sort first and use our own index for the trigger key.
   */ const generateKeyMap = ()=>{
        const keyMap = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(rawTabs, 'index').slice(0, 9).forEach((tab, index)=>{
            keyMap[String(index + 1)] = {
                callback: tab.callback,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $5SjJK.messages).goTo,
                    values: {
                        label: tab.label
                    }
                }),
                registerInCommandPalette: {
                    id: `tab${index + 1}-${tab.label}`,
                    name: formatMessage((0, $5SjJK.messages).goTo, {
                        label: tab.label
                    }),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YnyA))), {
                                spacing: "spacious",
                                label: ""
                            })
                    },
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation
                }
            };
        });
        return keyMap;
    };
    const valueMemo = (0, $5uXOq.useMemo)(()=>({
            registerTab: registerTab
        }), [
        registerTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c13989dd8d2573$export$eb842c33bb500fce.Provider, {
        value: valueMemo
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: generateKeyMap(),
        label: navigationName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, navigationName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5SjJK.messages).projectNavigation)
    }));
};
const $b6c13989dd8d2573$export$4b7664145fd3fd6f = ()=>{
    const context = (0, $5uXOq.useContext)($b6c13989dd8d2573$export$eb842c33bb500fce);
    if (!context) throw new Error('useTabShortcuts must be used within a TabShortcutsContextProvider');
    return context;
};

});
parcelRegister("3YnyA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e493f924d83b9dd$var$_react = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e493f924d83b9dd$var$_arrowRight = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("kAczT")));

var $2e493f924d83b9dd$var$_arrowRight2 = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("k9YqY")));
function $2e493f924d83b9dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e493f924d83b9dd$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2e493f924d83b9dd$var$_react.default.createElement($2e493f924d83b9dd$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $2e493f924d83b9dd$var$_arrowRight2.default
    }, props));
$2e493f924d83b9dd$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $2e493f924d83b9dd$var$_default = module.exports.default = $2e493f924d83b9dd$var$ArrowRightIcon;

});
parcelRegister("kAczT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efc0ed230d3ca890$var$_react = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efc0ed230d3ca890$var$_baseNew = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efc0ed230d3ca890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efc0ed230d3ca890$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $efc0ed230d3ca890$var$_react.default.createElement($efc0ed230d3ca890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$efc0ed230d3ca890$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $efc0ed230d3ca890$var$_default = module.exports.default = $efc0ed230d3ca890$var$ArrowRightIcon;

});

parcelRegister("k9YqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead386e1a3ec2bd9$var$_react = $ead386e1a3ec2bd9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $ead386e1a3ec2bd9$var$_arrowRight = $ead386e1a3ec2bd9$var$_interopRequireDefault((parcelRequire("kAczT")));
function $ead386e1a3ec2bd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead386e1a3ec2bd9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $ead386e1a3ec2bd9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $ead386e1a3ec2bd9$var$_arrowRight.default
    }));
$ead386e1a3ec2bd9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $ead386e1a3ec2bd9$var$_default = module.exports.default = $ead386e1a3ec2bd9$var$ArrowRightIcon;

});


parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("879xD", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $6700f9962d7215c2$export$7ff7e4fe85a5960a);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $jh7L9 = parcelRequire("jh7L9");

var $3Tty1 = parcelRequire("3Tty1");
const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $5uXOq.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $jh7L9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $izip4 = parcelRequire("izip4");

var $8yVxK = parcelRequire("8yVxK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $8yVxK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $izip4.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $8yVxK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $8yVxK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $izip4.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const FIELD_TYPE_MAP = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $8ikZj.FIELD_TYPE_MAP) : (0, $8ikZj.FIELD_TYPE_MAP_OLD);
    const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes
            });
            assigneeId && $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                assigneeId: assigneeId
            });
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey) && (0, $4R6GH.fg)('one_event_rules_them_all_fg');
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                    is_new_1event: true
                }
            });
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...currentAttributes,
                ...attributes
            });
        } else $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", () => $ba1d12fd09beb370$export$403ea87111529de);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});










parcelRegister("5SjJK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $95c4262fb06a7b0d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $95c4262fb06a7b0d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectNavigation: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.project-navigation",
        "defaultMessage": "Project navigation"
    },
    goTo: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.go-to",
        "defaultMessage": "Go to {label}"
    }
});

});


parcelRegister("cUcEa", function(module, exports) {

$parcel$export(module.exports, "RENAME_ONBOARDING", () => $dcaed4e80c6c1d23$export$8b943171fca14870);
$parcel$export(module.exports, "SAVE_VIEW_ONBOARDING", () => $dcaed4e80c6c1d23$export$a5717569cf53d503);
$parcel$export(module.exports, "SavedViewsOnboardingInitializer", () => $dcaed4e80c6c1d23$export$816ee139d9a87d77);
$parcel$export(module.exports, "useOnboarding", () => $dcaed4e80c6c1d23$export$5520b3b17c256ea3);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $i205g = parcelRequire("i205g");

var $6s1PB = parcelRequire("6s1PB");
const $dcaed4e80c6c1d23$var$TTL_SEEN = 31536000000; // ~ 365 days
const $dcaed4e80c6c1d23$export$8b943171fca14870 = 'board-saved-views-rename';
const $dcaed4e80c6c1d23$export$a5717569cf53d503 = 'board-saved-views-save-view';
const $dcaed4e80c6c1d23$var$actions = {
    initialize: (seenItResponse)=>({ setState: setState })=>{
            setState({
                [$dcaed4e80c6c1d23$export$8b943171fca14870]: seenItResponse[$dcaed4e80c6c1d23$export$8b943171fca14870]?.status !== true,
                [$dcaed4e80c6c1d23$export$a5717569cf53d503]: seenItResponse[$dcaed4e80c6c1d23$export$a5717569cf53d503]?.status !== true
            });
        },
    markAsSeen: (key)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                [key]: false
            })
};
const $dcaed4e80c6c1d23$var$store = (0, $iXqE5.createStore)({
    name: 'SavedViewsOnboardingStore',
    initialState: {
        [$dcaed4e80c6c1d23$export$8b943171fca14870]: false,
        [$dcaed4e80c6c1d23$export$a5717569cf53d503]: false
    },
    actions: $dcaed4e80c6c1d23$var$actions
});
const $dcaed4e80c6c1d23$var$useActions = (0, $3sQ5x.createActionsHook)($dcaed4e80c6c1d23$var$store);
const $dcaed4e80c6c1d23$var$getOnboardingByKey = (state, args)=>state[args[0]];
const $dcaed4e80c6c1d23$var$useOnboardingState = (0, $3sQ5x.createStateHook)($dcaed4e80c6c1d23$var$store, {
    selector: $dcaed4e80c6c1d23$var$getOnboardingByKey
});
const $dcaed4e80c6c1d23$export$816ee139d9a87d77 = ()=>{
    const { initialize: initialize } = $dcaed4e80c6c1d23$var$useActions();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $6s1PB.expVal)('saved_views', 'enabled', false)) return;
        if (false) return;
        (0, $i205g.getFlags)({
            [$dcaed4e80c6c1d23$export$8b943171fca14870]: {},
            [$dcaed4e80c6c1d23$export$a5717569cf53d503]: {}
        }).then(initialize).catch(()=>{
        // Ignore errors
        });
    }, [
        initialize
    ]);
    return null;
};
const $dcaed4e80c6c1d23$export$5520b3b17c256ea3 = (key)=>{
    const { markAsSeen: markAsSeen } = $dcaed4e80c6c1d23$var$useActions();
    const isOnboardingVisible = $dcaed4e80c6c1d23$var$useOnboardingState([
        key
    ]);
    const markOnboardingAsSeen = (0, $5uXOq.useCallback)(()=>{
        markAsSeen(key);
        (0, $i205g.setFlag)(key, $dcaed4e80c6c1d23$var$TTL_SEEN);
    }, [
        key,
        markAsSeen
    ]);
    return [
        isOnboardingVisible,
        markOnboardingAsSeen
    ];
};

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});

parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("fFClA", function(module, exports) {

$parcel$export(module.exports, "useDroppableTabList", () => $ca201e8f80d95342$export$ecea8c8c33275ef5);

var $5uXOq = parcelRequire("5uXOq");

var $8iGQq = parcelRequire("8iGQq");

var $cAQ2Q = parcelRequire("cAQ2Q");

var $4nayr = parcelRequire("4nayr");

var $8dXDG = parcelRequire("8dXDG");

var $kaHBi = parcelRequire("kaHBi");

var $feuVB = parcelRequire("feuVB");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $ca201e8f80d95342$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $ca201e8f80d95342$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $ca201e8f80d95342$var$BEFORE = 'before';
const $ca201e8f80d95342$var$AFTER = 'after';
const $ca201e8f80d95342$export$ecea8c8c33275ef5 = (tabs, containerNavigationId, scopeId)=>{
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$ca201e8f80d95342$export$f1e608dba99fa330,
        analyticsSource: $ca201e8f80d95342$export$b8b9d90f9e5bd72b
    });
    const onExperienceAbort = (0, $8dXDG.useExperienceAbort)($ca201e8f80d95342$export$f1e608dba99fa330);
    const [rankNavigationItem] = (0, $feuVB.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>(0, $4nayr.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.type === 'tab';
            },
            onDrop ({ source: source, location: location }) {
                onStartExperience();
                const destination = location.current.dropTargets[0];
                if (!destination) {
                    onExperienceAbort('Dropped outside of drop targets');
                    return;
                }
                if (source.data.type === 'tab' && source.data.id !== destination.data.id) {
                    const sourceTabIndex = tabs.findIndex((tab)=>tab.id === source.data.id);
                    let targetTabIndex;
                    let closestEdgeOfTarget;
                    if (destination.data.isMoreMenu) {
                        // assume no pagination and move it to the bottom of the list
                        targetTabIndex = tabs.length - 1;
                        closestEdgeOfTarget = 'bottom';
                    } else {
                        targetTabIndex = tabs.findIndex((tab)=>tab.id === destination.data.id);
                        closestEdgeOfTarget = (0, $8iGQq.extractClosestEdge)(destination.data);
                    }
                    const reorderedTabs = (0, $cAQ2Q.reorderWithEdge)({
                        list: tabs,
                        startIndex: sourceTabIndex,
                        indexOfTarget: targetTabIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: destination.data.isOverflowing ? 'vertical' : 'horizontal'
                    });
                    if (reorderedTabs && tabs.every((value, index)=>value === reorderedTabs[index])) return;
                    const placement = closestEdgeOfTarget === 'left' || closestEdgeOfTarget === 'top' ? $ca201e8f80d95342$var$BEFORE : $ca201e8f80d95342$var$AFTER;
                    const { id: id, typeKey: typeKey, appId: appId, dataId: dataId } = tabs[sourceTabIndex];
                    const beforeItemId = placement === $ca201e8f80d95342$var$BEFORE ? tabs[targetTabIndex].id : null;
                    const afterItemId = placement === $ca201e8f80d95342$var$AFTER ? tabs[targetTabIndex].id : null;
                    if (id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem dragged', 'projectNavigationTab', {
                        itemType: typeKey && typeKey.toLowerCase(),
                        itemId: appId,
                        draggedFromMore: Boolean(source.data.isOverflowing),
                        draggedToMore: Boolean(destination.data.isOverflowing || destination.data.isMoreMenu)
                    });
                    rankNavigationItem({
                        placement: placement,
                        sourceTabIndex: sourceTabIndex,
                        targetTabIndex: targetTabIndex,
                        id: id,
                        beforeItemId: beforeItemId,
                        afterItemId: afterItemId,
                        dataId: dataId,
                        actionType: 'dragged',
                        containerNavigationId: containerNavigationId,
                        scopeId: scopeId
                    });
                }
            }
        }), [
        tabs,
        rankNavigationItem,
        onStartExperience,
        onExperienceAbort,
        containerNavigationId,
        scopeId,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("cAQ2Q", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $4c4baa50093f5356$export$d0bc664d2812b3ba);
parcelRequire("d1glB");
var $ku7Q5 = parcelRequire("ku7Q5");

var $d5s7y = parcelRequire("d5s7y");
function $4c4baa50093f5356$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $ku7Q5.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $d5s7y.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("d1glB", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("ku7Q5")).reorder);

var $ku7Q5 = parcelRequire("ku7Q5");

});
parcelRegister("ku7Q5", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $d88914ebc0116ecf$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $d88914ebc0116ecf$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("d5s7y", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $e5831fb06fa17ad8$export$846f792f51b92b6e);
function $e5831fb06fa17ad8$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("feuVB", function(module, exports) {

$parcel$export(module.exports, "useRankNavigationItem", () => $205726356a7c0e8e$export$d474c994a9313e38);

var $bVfi8 = parcelRequire("bVfi8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cAQ2Q = parcelRequire("cAQ2Q");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");


var $j4hty = parcelRequire("j4hty");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $erN97 = parcelRequire("erN97");

var $fhJ4C = parcelRequire("fhJ4C");
const $205726356a7c0e8e$var$BEFORE = 'before';
const $205726356a7c0e8e$var$AFTER = 'after';
const $205726356a7c0e8e$var$HANDLED_STATUS_CODES = [
    401,
    403,
    404
];
const $205726356a7c0e8e$var$ERROR_TYPE = 'error';
const $205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG = {
    type: $205726356a7c0e8e$var$ERROR_TYPE,
    title: (0, $fhJ4C.default).errorTitle,
    description: (0, $fhJ4C.default).errorMessage,
    messageId: 'horizontal-nav-rank-item-service.services.rank-navigation-error-flag.flag.error',
    messageType: 'transactional'
};
const $205726356a7c0e8e$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $205726356a7c0e8e$export$111d365fc37d2de3 = 'reorderView';
const $205726356a7c0e8e$export$f1e608dba99fa330 = {
    experience: $205726356a7c0e8e$export$111d365fc37d2de3
};
const $205726356a7c0e8e$var$getFlagDetails = (error)=>{
    const statusCode = error instanceof (0, $eCBf9.MutationError) ? error.extensions?.statusCode ?? null : error.extensions?.[0]?.statusCode ?? null;
    switch(statusCode){
        case 401:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).unauthenticatedUserErrorTitle,
                description: (0, $fhJ4C.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.unauthenticated-user-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).authorisationErrorTitle,
                description: (0, $fhJ4C.default).authorisationErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.authorisation-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).viewNotFoundErrorTitle,
                description: (0, $fhJ4C.default).viewNotFoundErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $205726356a7c0e8e$export$d474c994a9313e38 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitMutation, isLoading] = (0, $8Uumt.useMutation)((0, $bVfi8.default));
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$205726356a7c0e8e$export$f1e608dba99fa330,
            attributes: {
                withContainerNav: true
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const sendErrorAnalytics = (0, $5uXOq.useCallback)((error)=>{
        onExperienceFail($205726356a7c0e8e$export$b8b9d90f9e5bd72b, error);
        (0, $jcw0u.default)({
            meta: {
                id: $205726356a7c0e8e$export$111d365fc37d2de3,
                packageName: $205726356a7c0e8e$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail
    ]);
    const rankNavigationItem = (0, $5uXOq.useCallback)(({ placement: placement, sourceTabIndex: sourceTabIndex, targetTabIndex: targetTabIndex, id: id, beforeItemId: beforeItemId, afterItemId: afterItemId, dataId: dataId, actionType: actionType, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        commitMutation({
            variables: {
                input: {
                    id: id,
                    beforeItemId: beforeItemId,
                    afterItemId: afterItemId,
                    scopeId: scopeId
                },
                first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
            },
            optimisticUpdater: (store)=>{
                const relayId = (0, $erN97.default)({
                    id: containerNavigationId
                }, 'JiraContainerNavigation');
                const connection = relayId && store.get(relayId)?.getLinkedRecord('navigationItems', {
                    first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
                });
                if (!connection) return;
                const existingEdges = connection?.getLinkedRecords('edges') || [];
                initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const tabs = Array.from(existingEdges || []);
                const reorderedTabs = (0, $cAQ2Q.reorderWithEdge)({
                    list: tabs,
                    startIndex: sourceTabIndex,
                    indexOfTarget: targetTabIndex,
                    closestEdgeOfTarget: placement === $205726356a7c0e8e$var$BEFORE ? 'left' : 'right',
                    axis: 'horizontal'
                });
                const edges = reorderedTabs.map((tab)=>existingEdges.find((edge)=>tab?.getLinkedRecord('node')?.getDataID() === edge.getLinkedRecord('node')?.getDataID())).filter(Boolean);
                connection?.setLinkedRecords(edges, 'edges');
            },
            updater: (store, response)=>{
                if (!response?.jira?.rankNavigationItem?.success) return;
                const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const itemType = dataId && store.get(dataId)?.getValue('typeKey');
                const itemId = dataId && store.get(dataId)?.getValue('appId');
                let finalTabIndex = targetTabIndex;
                if (placement === $205726356a7c0e8e$var$AFTER && sourceTabIndex > targetTabIndex) // placing it after the tab which will keep the same index, hence the destination is the target + 1
                finalTabIndex += 1;
                else if (placement === $205726356a7c0e8e$var$BEFORE && sourceTabIndex < targetTabIndex) // dropping it before the tab which will keep the same index, hence the destination is the target - 1
                finalTabIndex -= 1;
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                    originalItems: initialTabOrder,
                    updatedItems: finalTabOrder,
                    itemType: String(itemType).toLowerCase(),
                    itemId: itemId && String(itemId),
                    action: 'reordered',
                    method: actionType,
                    initialTabIndex: sourceTabIndex,
                    finalTabIndex: finalTabIndex
                });
            },
            onCompleted: (data)=>{
                const { errors: errors, success: success, containerNavigation: containerNavigation } = data?.jira?.rankNavigationItem ?? {};
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (errors && errors?.length > 0 || containerNavigation?.__typename && containerNavigation.__typename === 'QueryError') {
                    const { ...queryError } = containerNavigation ?? {};
                    const error = errors ? new (0, $eCBf9.MutationError)(errors[0]) : new (0, $c9Ur7.QueryError)(queryError);
                    const flagDetails = $205726356a7c0e8e$var$getFlagDetails(error) ?? $205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG;
                    showFlag(flagDetails);
                    if ($205726356a7c0e8e$var$HANDLED_STATUS_CODES.includes(error.statusCode ?? -1)) {
                        onExperienceSuccess();
                        return;
                    }
                    sendErrorAnalytics(error);
                    return;
                }
                showFlag($205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG);
            },
            onError: (error)=>{
                const err = new (0, $eCBf9.MutationError)(error);
                showFlag($205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG);
                sendErrorAnalytics(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        showFlag,
        onExperienceSuccess,
        sendErrorAnalytics
    ]);
    return [
        rankNavigationItem,
        isLoading
    ];
};

});
parcelRegister("bVfi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5867d4c1044857$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94134f02495ac20f6a39bed337f7c2c>>
 * @relayHash 7dca2046022ad34e2d2a772b39ff5c6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86
const $2b5867d4c1044857$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ContainerNavigationTabs_container"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "first",
                                                            "variableName": "first"
                                                        }
                                                    ],
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isDefault"
                                                                        },
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRename"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canSetAsDefault"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "appId"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraAppSection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "sections",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "envLabel"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraNavigationItem",
                                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                                }
                                                                            ],
                                                                            "type": "JiraAppNavigationItem"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEdit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeUrl"
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86",
            "metadata": {},
            "name": "servicesRankNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2b5867d4c1044857$var$node.hash = "34762fae8622a1c18cbdffa633de3226";
var $2b5867d4c1044857$export$2e2bcd8739ae039 = $2b5867d4c1044857$var$node;

});

parcelRegister("fhJ4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df0cabf7f3c712e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8df0cabf7f3c712e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "navigation-kit-rank-item-service.services.error-message",
        "defaultMessage": "Refresh the page and try again."
    },
    errorTitle: {
        "id": "navigation-kit-rank-item-service.services.error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    authorisationErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-title",
        "defaultMessage": "You don't have permission"
    },
    authorisationErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-message",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-message",
        "defaultMessage": "The tab you're trying to move can't be found"
    }
});

});



parcelRegister("5QXyw", function(module, exports) {

$parcel$export(module.exports, "NavigationItemTab", () => $c86636f03fa9de2d$export$8123409ae5ebd68);

var $jOFFy = parcelRequire("jOFFy");

var $lKRoQ = parcelRequire("lKRoQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dE5tT = parcelRequire("dE5tT");

var $8hXfI = parcelRequire("8hXfI");

var $bHBFf = parcelRequire("bHBFf");
const $c86636f03fa9de2d$export$8123409ae5ebd68 = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId, tabsDescriptor: tabsDescriptor, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const tabData = (0, $8Uumt.useFragment)((0, $lKRoQ.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $jOFFy.default), containerFragment);
    if (tabData.__typename === 'JiraAppNavigationItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hXfI.AppTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    if (tabData.typeKey === 'SHORTCUTS') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHBFf.ShortcutsTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
    if (tabData.url == null) return null;
    const Icon = tabsDescriptor[tabData.typeKey]?.Icon ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dE5tT.DefaultTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        icon: Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: "",
            size: "small"
        }),
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
};

});
parcelRegister("jOFFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c285de238cd83205$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6618727869e83c51134b946cb67b705d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c285de238cd83205$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$c285de238cd83205$var$node.hash = "9e2c189c40e4bc3dcbb1cf10c08a8bf2";
var $c285de238cd83205$export$2e2bcd8739ae039 = $c285de238cd83205$var$node;

});

parcelRegister("lKRoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f555ed0481afc184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ec91a07017fe901c44dfc3df36f84e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f555ed0481afc184$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_tab",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$f555ed0481afc184$var$node.hash = "751fa7ab98212b17632e93d1c53dfc75";
var $f555ed0481afc184$export$2e2bcd8739ae039 = $f555ed0481afc184$var$node;

});

parcelRegister("dE5tT", function(module, exports) {

$parcel$export(module.exports, "DefaultTab", () => $e838ae8b80cf7320$export$15a1012301673c71);

var $9Tk15 = parcelRequire("9Tk15");

var $42ZFa = parcelRequire("42ZFa");

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $8Uumt = parcelRequire("8Uumt");

var $lVJAU = parcelRequire("lVJAU");

var $bYbah = parcelRequire("bYbah");

var $3F9p6 = parcelRequire("3F9p6");




var $byTKd = parcelRequire("byTKd");

var $aHd4d = parcelRequire("aHd4d");

var $haoad = parcelRequire("haoad");
const $e838ae8b80cf7320$export$15a1012301673c71 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, isRenaming: isRenaming, onRenamingChange: onRenamingChange, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId }, ref)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isSelected = (0, $aHd4d.useIsTabSelected)();
    const tabData = (0, $8Uumt.useFragment)((0, $42ZFa.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $9Tk15.default), containerFragment);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemId: 'undefined',
            itemType: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(tabData.typeKey),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.typeKey
    ]));
    const { registerTab: registerTab } = (0, $bYbah.useTabShortcuts)();
    (0, $5uXOq.useEffect)(()=>registerTab({
            index: position,
            callback: ()=>{
                if (!isSelected) push(tabData.url);
            },
            label: tabData.label
        }), [
        registerTab,
        tabData,
        position,
        push,
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
        elemBefore: icon,
        elemAfter: elemAfter,
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: triggerAnalytics,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange,
        testId: testId,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: ref
    });
});

});
parcelRegister("9Tk15", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f802d8a3d3c2129$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<435ec6e3648eea9642eecd6b274b907f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9f802d8a3d3c2129$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$9f802d8a3d3c2129$var$node.hash = "f01c95b8f6d1cd80c4ac15d2546c116d";
var $9f802d8a3d3c2129$export$2e2bcd8739ae039 = $9f802d8a3d3c2129$var$node;

});

parcelRegister("42ZFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c1f93cf43b28872$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6762e3865e5c3a56f13719a55b9547c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c1f93cf43b28872$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "url"
            },
            "action": "THROW",
            "path": "url"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$3c1f93cf43b28872$var$node.hash = "9da2b497cf3cffcac56da38a0c7d758a";
var $3c1f93cf43b28872$export$2e2bcd8739ae039 = $3c1f93cf43b28872$var$node;

});

parcelRegister("haoad", function(module, exports) {

$parcel$export(module.exports, "TabWithMenu", () => $01e294c795eeb8f9$export$be4d5a66758483a8);

var $jcsb1 = parcelRequire("jcsb1");

var $kovwN = parcelRequire("kovwN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $d0cdX = parcelRequire("d0cdX");

var $1vy6C = parcelRequire("1vy6C");

var $bX1Wg = parcelRequire("bX1Wg");
const $01e294c795eeb8f9$export$be4d5a66758483a8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, isRenaming: isRenaming, onRenamingChange: onRenamingChange, ...tabProps }, ref)=>{
    const renameNavigationItem = (0, $1vy6C.useRenameNavigationItem)();
    const tabData = (0, $8Uumt.useFragment)((0, $kovwN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $jcsb1.default), containerFragment);
    const canEdit = Boolean(containerData?.canEdit);
    const handleRenameComplete = (0, $5uXOq.useCallback)((newName)=>{
        renameNavigationItem?.({
            id: tabData.id,
            label: newName,
            scopeId: containerData.scopeId,
            typeKey: tabData.typeKey,
            __typename: tabData.__typename
        });
        onRenamingChange?.(false);
    }, [
        renameNavigationItem,
        tabData.id,
        tabData.typeKey,
        tabData.__typename,
        containerData.scopeId,
        onRenamingChange
    ]);
    const handleRenameClick = (0, $5uXOq.useCallback)(()=>{
        onRenamingChange?.(true);
    }, [
        onRenamingChange
    ]);
    const handleRenameCancel = (0, $5uXOq.useCallback)(()=>{
        onRenamingChange?.(false);
    }, [
        onRenamingChange
    ]);
    const renderMenu = (0, $5uXOq.useCallback)(({ isOverflowing: isOverflowing, isOpen: isMenuOpen, setIsOpen: setIsMenuOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d0cdX.TabMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            position: tabProps.position,
            isOverflowing: isOverflowing,
            isOpen: isMenuOpen,
            setIsOpen: setIsMenuOpen,
            onRenameClick: handleRenameClick
        }), [
        tabData,
        containerData,
        beforeItemId,
        afterItemId,
        tabProps.position,
        handleRenameClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bX1Wg.default), {
        name: tabData.label,
        isDraggable: canEdit,
        renderMenu: canEdit ? renderMenu : undefined,
        onRenameComplete: handleRenameComplete,
        onRenameCancel: handleRenameCancel,
        isRenaming: isRenaming,
        ...tabProps,
        ref: ref
    });
});

});
parcelRegister("jcsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $486706af25a2f26a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb585c529bab9cef4749ed2a03ab95a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $486706af25a2f26a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$486706af25a2f26a$var$node.hash = "6224b42f30483a79a7b9e5f35d80a3f9";
var $486706af25a2f26a$export$2e2bcd8739ae039 = $486706af25a2f26a$var$node;

});

parcelRegister("kovwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db0a428cde57540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e15ac5f88b72d8037f90a2c27f9b342e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0db0a428cde57540$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$0db0a428cde57540$var$node.hash = "c2661c839237a566a5adce01990a7427";
var $0db0a428cde57540$export$2e2bcd8739ae039 = $0db0a428cde57540$var$node;

});

parcelRegister("d0cdX", function(module, exports) {

$parcel$export(module.exports, "TabMenu", () => $958d18a4f28c163e$export$60204bfd6efac94c);

var $aFatU = parcelRequire("aFatU");

var $d3b44 = parcelRequire("d3b44");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $1Seuh = parcelRequire("1Seuh");

var $3jAdT = parcelRequire("3jAdT");

var $elaEw = parcelRequire("elaEw");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $6cG4N = parcelRequire("6cG4N");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $22OQR = parcelRequire("22OQR");

var $hCCtP = parcelRequire("hCCtP");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $e9UUa = parcelRequire("e9UUa");

var $1xdDa = parcelRequire("1xdDa");

var $8q6eC = parcelRequire("8q6eC");

var $7LJ25 = parcelRequire("7LJ25");

var $6Y96S = parcelRequire("6Y96S");
const $958d18a4f28c163e$export$60204bfd6efac94c = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isOverflowing: isOverflowing, isOpen: isOpen, setIsOpen: setIsOpen, onRenameClick: onRenameClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const tabData = (0, $8Uumt.useFragment)((0, $d3b44.default), tabFragment);
    const canRename = Boolean(tabData?.canRename) && (0, $6s1PB.expVal)('saved_views', 'enabled', false);
    const canRemove = Boolean(tabData?.canRemove);
    const canSetAsDefault = Boolean(tabData?.canSetAsDefault);
    const containerData = (0, $8Uumt.useFragment)((0, $aFatU.default), containerFragment);
    const toggleMenuOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((isMenuOpen)=>!isMenuOpen);
    }, [
        setIsOpen
    ]);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const handleHideClick = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'remove',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing
    ]);
    const handleSetAsDefault = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'setAsDefault',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        tabData.appId,
        tabData.typeKey
    ]);
    const handleRenameNavigationItem = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        onRenameClick?.();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'rename',
            itemType: tabData.typeKey.toLowerCase(),
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        onRenameClick,
        tabData.typeKey
    ]);
    const trigger = (triggerProps)=>{
        if (isOverflowing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            ...triggerProps,
            label: formatMessage((0, $1xdDa.default).viewOptions),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') && {
                    content: formatMessage((0, $1xdDa.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        });
        return (0, $4R6GH.fg)('fix_navigation_tab_options_icon_colour_for_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            ...triggerProps,
            label: formatMessage((0, $1xdDa.default).viewOptions),
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                    ...iconProps,
                    color: (0, $6cG4N.Tokens).COLOR_LINK
                }),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') && {
                    content: formatMessage((0, $1xdDa.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($958d18a4f28c163e$var$NavigationThemedButton, {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? formatMessage((0, $1xdDa.default).moreActionsTooltip) : formatMessage((0, $1xdDa.default).viewOptions),
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                label: formatMessage((0, $1xdDa.default).viewOptions),
                LEGACY_size: "small"
            }))
        });
    };
    const hasTopGroup = canSetAsDefault || canRename;
    const hasMiddleGroup = position !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        trigger: trigger,
        isOpen: isOpen,
        onClose: closeMenu,
        placement: isOverflowing ? 'right-start' : 'bottom-start',
        shouldUseCaptureOnOutsideClick: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
                sourceName: "navigationKitTabMenu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $958d18a4f28c163e$var$containerStyles,
                testId: "navigation-kit-tab-menu.ui.tab-menu-options",
                role: "menu"
            }, hasTopGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), null, canSetAsDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y96S.SetAsDefaultItem), {
                onClick: handleSetAsDefault,
                tabFragment: tabData,
                containerFragment: containerData
            }), canRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LJ25.RenameItem), {
                onClick: handleRenameNavigationItem
            })), hasMiddleGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q6eC.MoveItem), {
                hasSeparator: hasTopGroup,
                id: tabData?.id,
                dataId: tabData?.__id,
                beforeItemId: beforeItemId,
                afterItemId: afterItemId,
                position: position,
                onClick: closeMenu,
                tabFragment: tabData,
                containerFragment: containerData,
                isOverflowing: isOverflowing
            }), canRemove && !tabData.isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
                hasSeparator: hasTopGroup || hasMiddleGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9UUa.HideItem), {
                onClick: handleHideClick,
                tabFragment: tabData,
                containerFragment: containerData
            }))))
    });
});
// remove - on clean up fix_navigation_tab_options_icon_colour_for_theming
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $958d18a4f28c163e$var$NavigationThemedButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $22OQR.ThemedButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15ah14e8",
            __cmplp.className
        ])
    });
});
const $958d18a4f28c163e$var$containerStyles = (0, $2s57o.xcss)({
    minWidth: '124px'
});

});
parcelRegister("aFatU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ccf5dd5d1dd66a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0029a71db40a948fb3ab74f841092485>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ccf5dd5d1dd66a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$4ccf5dd5d1dd66a8$var$node.hash = "625543c1eef703b320bff9684648acce";
var $4ccf5dd5d1dd66a8$export$2e2bcd8739ae039 = $4ccf5dd5d1dd66a8$var$node;

});

parcelRegister("d3b44", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44a3b6bf8a6450a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9fe02adf4dfe0d10d1dc49670185f93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f44a3b6bf8a6450a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_tab"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ScalarField",
            "name": "canRename"
        },
        {
            "kind": "ScalarField",
            "name": "canRemove"
        },
        {
            "kind": "ScalarField",
            "name": "canSetAsDefault"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$f44a3b6bf8a6450a$var$node.hash = "c39dc9c76de61cd2fa1248c73d2f808d";
var $f44a3b6bf8a6450a$export$2e2bcd8739ae039 = $f44a3b6bf8a6450a$var$node;

});

parcelRegister("e9UUa", function(module, exports) {

$parcel$export(module.exports, "HideItem", () => $ce674b382b8b60ff$export$688a1e0eb1cb83e7);

var $dhU6F = parcelRequire("dhU6F");

var $1CLLN = parcelRequire("1CLLN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1eETS = parcelRequire("1eETS");

var $koVbs = parcelRequire("koVbs");

var $j2Q2d = parcelRequire("j2Q2d");

var $lVJAU = parcelRequire("lVJAU");

var $aHd4d = parcelRequire("aHd4d");

var $1xdDa = parcelRequire("1xdDa");
const $ce674b382b8b60ff$export$688a1e0eb1cb83e7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hideNavigationItem = (0, $j2Q2d.useHideNavigationItem)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isSelected = (0, $aHd4d.useIsTabSelected)();
    const tabData = (0, $8Uumt.useFragment)((0, $1CLLN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $dhU6F.default), containerFragment);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick();
        if (!containerData.id) return;
        const defaultTabUrl = containerData.navigationItems?.edges?.find((edge)=>edge?.node.isDefault)?.node.url;
        hideNavigationItem({
            id: tabData.id,
            relayId: tabData.__id,
            containerNavigationId: containerData.id,
            onCompleted: ()=>{
                if (defaultTabUrl && isSelected) push(defaultTabUrl);
            }
        });
    }, [
        containerData,
        hideNavigationItem,
        isSelected,
        onClick,
        push,
        tabData.__id,
        tabData.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleClick
    }, formatMessage((0, $1xdDa.default).hideItem));
});

});
parcelRegister("dhU6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26cf43974ce78bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2af84d5adc0f9b927b2d6b399dc9e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c26cf43974ce78bb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "HideItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                "action": "THROW",
                                                "path": "navigationItems.edges.node.isDefault"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "navigationItems.edges.node"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$c26cf43974ce78bb$var$node.hash = "74369dee0c0b32c1011fec3260d7a339";
var $c26cf43974ce78bb$export$2e2bcd8739ae039 = $c26cf43974ce78bb$var$node;

});

parcelRegister("1CLLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5305e5fff6e7d86b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62dbb3ecb0a3c1d9aab1d0ea97ab3827>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5305e5fff6e7d86b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HideItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$5305e5fff6e7d86b$var$node.hash = "2e58297399f7217bc7b0f7b7efcfd8cc";
var $5305e5fff6e7d86b$export$2e2bcd8739ae039 = $5305e5fff6e7d86b$var$node;

});

parcelRegister("j2Q2d", function(module, exports) {

$parcel$export(module.exports, "useHideNavigationItem", () => $60348a214ba87fe7$export$f81bcd521f99d535);

var $ZUIsc = parcelRequire("ZUIsc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $j4hty = parcelRequire("j4hty");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dGeoc = parcelRequire("dGeoc");
const $60348a214ba87fe7$export$b8b9d90f9e5bd72b = 'jiraNavigationKitHideItemService';
const $60348a214ba87fe7$export$6d6eb6668e23e980 = 'hideView';
const $60348a214ba87fe7$export$ab511d8a11c8295c = {
    experience: $60348a214ba87fe7$export$6d6eb6668e23e980
};
const $60348a214ba87fe7$var$NON_ADMIN_ERROR = 'User is not an admin';
const $60348a214ba87fe7$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $dGeoc.default).userNotLoggedInErrorFlagTitle,
                description: (0, $dGeoc.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            if (message === $60348a214ba87fe7$var$NON_ADMIN_ERROR) return {
                type: 'error',
                title: (0, $dGeoc.default).userNotAdminErrorFlagTitle,
                description: (0, $dGeoc.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
            return null;
        case 404:
            return {
                type: 'error',
                title: (0, $dGeoc.default).viewNotFoundErrorFlagTitle,
                description: (0, $dGeoc.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $60348a214ba87fe7$export$f81bcd521f99d535 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$60348a214ba87fe7$export$ab511d8a11c8295c,
        analyticsSource: $60348a214ba87fe7$export$b8b9d90f9e5bd72b
    });
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$60348a214ba87fe7$export$ab511d8a11c8295c,
            attributes: {
                withContainerNav: true
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $ZUIsc.default));
    const getAnalyticsTabPosition = (0, $5uXOq.useCallback)((store, response, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const edges = (0, $j4hty.getStoreEdges)(store, containerNavigationId);
        if (!edges) return undefined;
        const index = edges.findIndex((edge)=>{
            const node = edge?.getLinkedRecord('node');
            return node?.getValue('id') === navigationItem;
        });
        return index === -1 ? undefined : index;
    }, []);
    const updater = (0, $5uXOq.useCallback)((store, response, navigationItemRelayId, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const connectionRecord = (0, $j4hty.getConnection)(store, containerNavigationId);
        if (!connectionRecord || navigationItemRelayId == null) return;
        (0, $8Uumt.ConnectionHandler).deleteNode(connectionRecord, navigationItemRelayId);
    }, []);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag({
            messageId: 'horizontal-nav-hide-item-service.services.show-flag.error.hide-navigation-item-default-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $dGeoc.default).hideNavigationItemDefaultErrorFlagTitle),
            description: formatMessage((0, $dGeoc.default).hideNavigationItemDefaultErrorFlagDescription)
        });
        (0, $jcw0u.default)({
            meta: {
                id: $60348a214ba87fe7$export$6d6eb6668e23e980,
                packageName: $60348a214ba87fe7$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($60348a214ba87fe7$export$b8b9d90f9e5bd72b, error);
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    return (0, $5uXOq.useCallback)(({ id: id, relayId: relayId, onCompleted: onCompleted, containerNavigationId: containerNavigationId })=>{
        if (id == null) return;
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id
                }
            },
            optimisticResponse: {
                jira: {
                    deleteNavigationItem: {
                        success: true,
                        navigationItem: id,
                        errors: null
                    }
                }
            },
            optimisticUpdater: (store, response)=>{
                updater(store, response, relayId, containerNavigationId);
            },
            updater: (store, response)=>{
                const initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const initialTabPosition = getAnalyticsTabPosition(store, response, containerNavigationId);
                updater(store, response, relayId, containerNavigationId);
                if (response?.jira?.deleteNavigationItem?.success) {
                    const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                    const item = store.get(String(relayId));
                    const itemId = item?.getValue('appId');
                    const itemType = String(item?.getValue('typeKey'));
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: itemType.toLowerCase(),
                        itemId: itemId && String(itemId),
                        initialTabIndex: initialTabPosition,
                        action: 'removed'
                    });
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.deleteNavigationItem ?? {};
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $60348a214ba87fe7$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    onError(error);
                    return;
                }
                onExperienceSuccess();
                onCompleted();
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        getAnalyticsTabPosition,
        onError,
        onExperienceSuccess,
        onStartExperience,
        showFlag,
        updater
    ]);
};

});
parcelRegister("ZUIsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $72bdceab737ea3a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca421b53344a880082a01ef55ae3298d>>
 * @relayHash 5e42aa4760fa1cda0f65d32ab2e48395
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf
const $72bdceab737ea3a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "navigationItem"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf",
            "metadata": {},
            "name": "servicesHideNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$72bdceab737ea3a6$var$node.hash = "4640fb5e180d56505dbc99767c68be10";
var $72bdceab737ea3a6$export$2e2bcd8739ae039 = $72bdceab737ea3a6$var$node;

});

parcelRegister("dGeoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b007ad09be8c132$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b007ad09be8c132$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideNavigationItemDefaultErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    hideNavigationItemDefaultErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to remove can't be found."
    }
});

});


parcelRegister("1xdDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2f640b9b445879$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff2f640b9b445879$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewOptions: {
        "id": "navigation-kit-tab-menu.view-options",
        "defaultMessage": "Tab options"
    },
    setAsDefaultView: {
        "id": "navigation-kit-tab-menu.set-as-default-item.set-as-default-view",
        "defaultMessage": "Set as default"
    },
    selected: {
        "id": "navigation-kit-tab-menu.set-as-default-item.selected",
        "defaultMessage": "Selected"
    },
    renameItem: {
        "id": "navigation-kit-tab-menu.rename-item.rename-item",
        "defaultMessage": "Rename"
    },
    moveItemRight: {
        "id": "navigation-kit-tab-menu.move-item.move-item-right",
        "defaultMessage": "Move tab right"
    },
    moveItemDown: {
        "id": "navigation-kit-tab-menu.move-item.move-item-down",
        "defaultMessage": "Move tab down"
    },
    moveItemLeft: {
        "id": "navigation-kit-tab-menu.move-item.move-item-left",
        "defaultMessage": "Move tab left"
    },
    moveItemUp: {
        "id": "navigation-kit-tab-menu.move-item.move-item-up",
        "defaultMessage": "Move tab up"
    },
    hideItem: {
        "id": "navigation-kit-tab-menu.hide-item.hide-item",
        "defaultMessage": "Remove"
    },
    moreActionsTooltip: {
        "id": "navigation-kit-tab-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("8q6eC", function(module, exports) {

$parcel$export(module.exports, "MoveItem", () => $9d6543e20eb10c28$export$c684f623a254a5c0);

var $4VWIn = parcelRequire("4VWIn");

var $6zBps = parcelRequire("6zBps");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $feuVB = parcelRequire("feuVB");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $1xdDa = parcelRequire("1xdDa");
const $9d6543e20eb10c28$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $9d6543e20eb10c28$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $9d6543e20eb10c28$export$c684f623a254a5c0 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, dataId: dataId, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, hasSeparator: hasSeparator, onClick: onClick, isOverflowing: isOverflowing, tabFragment: tabFragment, containerFragment: containerFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [rankNavigationItem] = (0, $feuVB.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$9d6543e20eb10c28$export$f1e608dba99fa330,
        analyticsSource: $9d6543e20eb10c28$export$b8b9d90f9e5bd72b
    });
    const tabData = (0, $8Uumt.useFragment)((0, $6zBps.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $4VWIn.default), containerFragment);
    const handleMoveAfter = (0, $5uXOq.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabAfter',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'after',
            sourceTabIndex: position,
            targetTabIndex: position + 1,
            id: id,
            afterItemId: afterItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        afterItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    const handleMoveBefore = (0, $5uXOq.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabBefore',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'before',
            sourceTabIndex: position,
            targetTabIndex: position - 1,
            id: id,
            beforeItemId: beforeItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        beforeItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    if (!beforeItemId && !afterItemId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        hasSeparator: hasSeparator
    }, beforeItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleMoveBefore
    }, formatMessage(isOverflowing ? (0, $1xdDa.default).moveItemUp : (0, $1xdDa.default).moveItemLeft)), afterItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleMoveAfter
    }, formatMessage(isOverflowing ? (0, $1xdDa.default).moveItemDown : (0, $1xdDa.default).moveItemRight)));
});

});
parcelRegister("4VWIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $66291d49f3f4b3f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<796de95e3150e72ab27c741f11b1c768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66291d49f3f4b3f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$66291d49f3f4b3f6$var$node.hash = "f9f8b1902c6acb52496479dc02bba4da";
var $66291d49f3f4b3f6$export$2e2bcd8739ae039 = $66291d49f3f4b3f6$var$node;

});

parcelRegister("6zBps", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2310e37c8ecc6d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89b87352bf0c83a85e2ac9a5d9efd446>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2310e37c8ecc6d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$c2310e37c8ecc6d5$var$node.hash = "d80f30b8a83df095fbc3f7cdf31473c5";
var $c2310e37c8ecc6d5$export$2e2bcd8739ae039 = $c2310e37c8ecc6d5$var$node;

});


parcelRegister("7LJ25", function(module, exports) {

$parcel$export(module.exports, "RenameItem", () => $b61c9e5b9472a046$export$ee728c052485c654);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $koVbs = parcelRequire("koVbs");

var $cUcEa = parcelRequire("cUcEa");

var $k8shd = parcelRequire("k8shd");

var $1xdDa = parcelRequire("1xdDa");
const $b61c9e5b9472a046$export$ee728c052485c654 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isRenameLozengeVisible, markRenameAsSeen] = (0, $cUcEa.useOnboarding)((0, $cUcEa.RENAME_ONBOARDING));
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        markRenameAsSeen();
        onClick();
    }, [
        markRenameAsSeen,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleClick
    }, formatMessage((0, $1xdDa.default).renameItem), isRenameLozengeVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8shd.NewLozenge), null));
});

});
parcelRegister("k8shd", function(module, exports) {

$parcel$export(module.exports, "NewLozenge", () => $844e714be5fe758d$export$aaf471b17355e1c6);
/* NewLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $eOat1 = parcelRequire("eOat1");

var $koVbs = parcelRequire("koVbs");

var $aA0vY = parcelRequire("aA0vY");
const $844e714be5fe758d$export$aaf471b17355e1c6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $aA0vY.messages).new)));
};

});
parcelRegister("aA0vY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9a26d7f080fcb05$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b9a26d7f080fcb05$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    new: {
        "id": "business-onboarding-board-saved-views.new",
        "defaultMessage": "New"
    }
});

});



parcelRegister("6Y96S", function(module, exports) {

$parcel$export(module.exports, "SetAsDefaultItem", () => $62ebac591fc0f78b$export$93c39ca6fde4b432);

var $7c8T3 = parcelRequire("7c8T3");

var $1LCEa = parcelRequire("1LCEa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1eETS = parcelRequire("1eETS");

var $hbAVG = parcelRequire("hbAVG");

var $koVbs = parcelRequire("koVbs");

var $bjeNT = parcelRequire("bjeNT");

var $1xdDa = parcelRequire("1xdDa");
const $62ebac591fc0f78b$export$93c39ca6fde4b432 = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setAsDefault: setAsDefault } = (0, $bjeNT.useSetAsDefault)();
    const { id: id, __id: __id, isDefault: isDefault } = (0, $8Uumt.useFragment)((0, $1LCEa.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $7c8T3.default), containerFragment);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        if (containerData.id && !isDefault) {
            setAsDefault({
                id: id,
                __id: __id,
                containerNavigationId: containerData.id,
                scopeId: containerData?.scopeId
            });
            onClick?.();
        }
    }, [
        isDefault,
        setAsDefault,
        id,
        __id,
        containerData?.id,
        containerData?.scopeId,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleClick,
        elemAfter: isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbAVG))), {
            spacing: "spacious",
            label: formatMessage((0, $1xdDa.default).selected),
            color: "var(--ds-icon-selected, #0C66E4)"
        })
    }, formatMessage((0, $1xdDa.default).setAsDefaultView));
});

});
parcelRegister("7c8T3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4639714c7d6074$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d7fcf1f10547547ad3a73ed397c318>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f4639714c7d6074$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$5f4639714c7d6074$var$node.hash = "656aa8c184c3ae35259916ec5158b9d3";
var $5f4639714c7d6074$export$2e2bcd8739ae039 = $5f4639714c7d6074$var$node;

});

parcelRegister("1LCEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47f5fde4ac41b1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f725fd96c7a7e106c21843ce289a0e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a47f5fde4ac41b1a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$a47f5fde4ac41b1a$var$node.hash = "88982584cb03f7a8362df915df0c2838";
var $a47f5fde4ac41b1a$export$2e2bcd8739ae039 = $a47f5fde4ac41b1a$var$node;

});

parcelRegister("hbAVG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8301c29749ee534$var$_react = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c8301c29749ee534$var$_checkMark = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("dVU8x")));

var $c8301c29749ee534$var$_check = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("2n32C")));
function $c8301c29749ee534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8301c29749ee534$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c8301c29749ee534$var$_react.default.createElement($c8301c29749ee534$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c8301c29749ee534$var$_check.default
    }, props));
$c8301c29749ee534$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c8301c29749ee534$var$_default = module.exports.default = $c8301c29749ee534$var$CheckMarkIcon;

});

parcelRegister("bjeNT", function(module, exports) {

$parcel$export(module.exports, "useSetAsDefault", () => $dd83abf0517c5abf$export$5b2c06a7e56f39a8);

var $9r9JV = parcelRequire("9r9JV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $erN97 = parcelRequire("erN97");

var $dXq4S = parcelRequire("dXq4S");

var $j4hty = parcelRequire("j4hty");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9r2Nc = parcelRequire("9r2Nc");
const $dd83abf0517c5abf$var$VIEW_NOT_DEFAULTABLE_ERROR = 'View type is not defaultable';
const $dd83abf0517c5abf$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $9r2Nc.default).setAsDefaultErrorFlagTitle,
    description: (0, $9r2Nc.default).setAsDefaultErrorFlagDescription,
    messageId: 'horizontal-nav-tab-menu.services.set-as-default.default-error-flag.error.flag.default-error',
    messageType: 'transactional'
};
const $dd83abf0517c5abf$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
            if (message === $dd83abf0517c5abf$var$VIEW_NOT_DEFAULTABLE_ERROR) return {
                type: 'error',
                title: (0, $9r2Nc.default).viewNotDefaultableErrorFlagTitle,
                description: (0, $9r2Nc.default).viewNotDefaultableErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-defaultable-error',
                messageType: 'transactional'
            };
            return null;
        case 401:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).userNotLoggedInErrorFlagTitle,
                description: (0, $9r2Nc.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).userNotAdminErrorFlagTitle,
                description: (0, $9r2Nc.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).viewNotFoundErrorFlagTitle,
                description: (0, $9r2Nc.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $dd83abf0517c5abf$export$b8b9d90f9e5bd72b = 'jiraNavigationKitTabMenu';
const $dd83abf0517c5abf$export$c028e73dc12a34c5 = 'setAsDefaultView';
const $dd83abf0517c5abf$export$f444706ea2b317f8 = {
    experience: $dd83abf0517c5abf$export$c028e73dc12a34c5
};
const $dd83abf0517c5abf$export$5b2c06a7e56f39a8 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$dd83abf0517c5abf$export$f444706ea2b317f8,
        analyticsSource: $dd83abf0517c5abf$export$b8b9d90f9e5bd72b
    });
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$dd83abf0517c5abf$export$f444706ea2b317f8,
            attributes: {
                withContainerNav: true
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $9r9JV.default));
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        showFlag($dd83abf0517c5abf$var$DEFAULT_ERROR_FLAG);
        (0, $jcw0u.default)({
            meta: {
                id: $dd83abf0517c5abf$export$c028e73dc12a34c5,
                packageName: $dd83abf0517c5abf$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($dd83abf0517c5abf$export$b8b9d90f9e5bd72b, error);
    }, [
        onExperienceFail,
        showFlag
    ]);
    const setAsDefault = (0, $5uXOq.useCallback)(({ id: id, __id: __id, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id,
                    scopeId: scopeId
                }
            },
            optimisticUpdater: (store)=>{
                initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const edges = (0, $j4hty.getStoreEdges)(store, containerNavigationId);
                if (!edges) return;
                edges.forEach((edge)=>{
                    const node = edge?.getLinkedRecord('node');
                    if (node?.getValue('isDefault') === true && node?.getValue('id') !== id) node.setValue(false, 'isDefault');
                    if (node?.getValue('id') === id) node?.setValue(true, 'isDefault');
                });
            },
            updater: (store, response)=>{
                const newDefaultRecord = store.get(__id);
                if (response?.jira?.setDefaultNavigationItem?.success) {
                    if (scopeId) {
                        const ariConfig = (0, $dXq4S.getAriConfig)(scopeId);
                        const scopeType = ariConfig.resourceType === 'board' ? 'JiraBoard' : 'JiraProject';
                        const scopeRelayId = (0, $erN97.default)({
                            id: scopeId
                        }, scopeType);
                        if (scopeRelayId && newDefaultRecord) {
                            const scopeRecord = store.get(scopeRelayId);
                            scopeRecord?.setLinkedRecord(newDefaultRecord, 'defaultNavigationItem');
                        }
                    }
                    const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                    const itemId = newDefaultRecord?.getValue('appId');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: String(newDefaultRecord?.getValue('typeKey')).toLowerCase(),
                        itemId: itemId && String(itemId).toLowerCase(),
                        action: 'setAsDefault'
                    });
                }
            },
            onCompleted: (result)=>{
                const { success: success, newDefault: newDefault, errors: errors } = result?.jira?.setDefaultNavigationItem ?? {};
                if (success && newDefault && !errors) {
                    showFlag({
                        messageId: 'horizontal-nav-tab-menu.services.set-as-default.show-flag.success.flag.success',
                        messageType: 'transactional',
                        type: 'success',
                        title: formatMessage((0, $9r2Nc.default).setAsDefaultSuccessFlagTitle, {
                            viewName: newDefault.label
                        }),
                        description: formatMessage((0, $9r2Nc.default).setAsDefaultSuccessFlagDescription, {
                            viewName: newDefault.label
                        })
                    });
                    onExperienceSuccess();
                    return;
                }
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $dd83abf0517c5abf$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    handleError(error);
                }
            },
            onError: (error)=>handleError(error)
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        formatMessage,
        handleError,
        onExperienceSuccess,
        onStartExperience,
        showFlag
    ]);
    return {
        setAsDefault: setAsDefault
    };
};

});
parcelRegister("9r9JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $77ce27a3e25782bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d61d252896575ea2884d483ecd96119>>
 * @relayHash 1cdf55f994a6939963be94479cc21daf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128
const $77ce27a3e25782bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128",
            "metadata": {},
            "name": "setAsDefaultItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$77ce27a3e25782bf$var$node.hash = "bcaaa14d2f29d8020f8238f6031efdc3";
var $77ce27a3e25782bf$export$2e2bcd8739ae039 = $77ce27a3e25782bf$var$node;

});

parcelRegister("9r2Nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6ca7d9747b0867$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf6ca7d9747b0867$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setAsDefaultSuccessFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-title",
        "defaultMessage": "{viewName} set as default view"
    },
    setAsDefaultSuccessFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-description",
        "defaultMessage": "{viewName} will be the default view for everyone."
    },
    setAsDefaultErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    setAsDefaultErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to set this view as default. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotDefaultableErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-title",
        "defaultMessage": "Choose a different default view"
    },
    viewNotDefaultableErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-description",
        "defaultMessage": "You can only set the summary, board, list, calendar, or timeline as the default view."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-title",
        "defaultMessage": "This view tab been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to set as default can't be found."
    }
});

});




parcelRegister("1vy6C", function(module, exports) {

$parcel$export(module.exports, "useRenameNavigationItem", () => $93fe6a770d7bd80f$export$881d234560f027b5);

var $jl13J = parcelRequire("jl13J");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $HZElK = parcelRequire("HZElK");
const $93fe6a770d7bd80f$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $HZElK.default).defaultErrorFlagTitle,
    description: (0, $HZElK.default).defaultErrorFlagDescription,
    messageType: 'transactional',
    messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag.error.horizontal-nav-tab-menu-rename-navigation-item-default-error'
};
const $93fe6a770d7bd80f$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
        case 404:
            return {
                type: 'error',
                title: (0, $HZElK.default).defaultErrorFlagTitle,
                description: message,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-request-error'
            };
        case 401:
            return {
                type: 'error',
                title: (0, $HZElK.default).userNotLoggedInErrorFlagTitle,
                description: (0, $HZElK.default).userNotLoggedInErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-logged-in-error'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $HZElK.default).userNotAdminErrorFlagTitle,
                description: (0, $HZElK.default).userNotAdminErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-admin-error'
            };
        default:
            return null;
    }
};
const $93fe6a770d7bd80f$export$881d234560f027b5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $jl13J.default));
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag($93fe6a770d7bd80f$var$DEFAULT_ERROR_FLAG);
        (0, $jcw0u.default)({
            meta: {
                id: 'renameNavigationItem',
                packageName: 'jiraHorizontalNavTabMenu',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag
    ]);
    return (0, $5uXOq.useCallback)(({ id: id, label: label, scopeId: scopeId, typeKey: typeKey, __typename: __typename })=>{
        commitMutation({
            variables: {
                input: {
                    id: id,
                    label: label,
                    scopeId: scopeId
                }
            },
            optimisticResponse: {
                jira: {
                    renameNavigationItem: {
                        success: true,
                        errors: null,
                        navigationItem: {
                            __typename: __typename,
                            label: label,
                            id: id
                        }
                    }
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                if (response?.jira?.renameNavigationItem?.success === true) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'navigationItem renamed', {
                    typeKey: typeKey
                });
                else {
                    const firstError = response?.jira?.renameNavigationItem?.errors?.[0] ?? new Error('Unknown error');
                    const error = new (0, $eCBf9.MutationError)(firstError);
                    const flagDetails = $93fe6a770d7bd80f$var$getFlagDetails(error);
                    if (flagDetails) {
                        showFlag(flagDetails);
                        return;
                    }
                    onError(error);
                }
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        onError,
        showFlag
    ]);
};

});
parcelRegister("jl13J", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb29934efb3f8c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fac2ccbfb6948585efd00ec262359df8>>
 * @relayHash 08ee531ee69dd70fba8cb7fc363431a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb
const $3fb29934efb3f8c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "label"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb",
            "metadata": {},
            "name": "renameNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3fb29934efb3f8c8$var$node.hash = "89c71efe0597e03c9897cee5d89d8941";
var $3fb29934efb3f8c8$export$2e2bcd8739ae039 = $3fb29934efb3f8c8$var$node;

});

parcelRegister("HZElK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ce26e2314f52d94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ce26e2314f52d94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-title",
        "defaultMessage": "We couldn't update the view name"
    },
    defaultErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to rename this view. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to rename views."
    }
});

});




parcelRegister("8hXfI", function(module, exports) {

$parcel$export(module.exports, "AppTab", () => $1797734e5bab4540$export$fca347df63cfad2c);

var $7K2QI = parcelRequire("7K2QI");

var $empIN = parcelRequire("empIN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hrlU6 = parcelRequire("hrlU6");

var $byTKd = parcelRequire("byTKd");




var $3F9p6 = parcelRequire("3F9p6");

var $aUk4j = parcelRequire("aUk4j");

var $7uRML = parcelRequire("7uRML");

var $hukKC = parcelRequire("hukKC");

var $haoad = parcelRequire("haoad");
const $1797734e5bab4540$export$fca347df63cfad2c = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const tabData = (0, $8Uumt.useFragment)((0, $empIN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $7K2QI.default), containerFragment);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemType: 'app',
            itemId: tabData.appId ?? '',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        if (tabData.styleClass) {
            (0, $hrlU6.withConnectHost)((connectHost)=>{
                if (webItemRef.current && tabData.url) connectHost.triggerWebItem(webItemRef.current, tabData.styleClass ?? '', tabData.url);
            });
            if ((0, $hrlU6.isConnectDialogWebItem)(tabData.styleClass)) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
        triggerAnalytics();
    }, [
        tabData.styleClass,
        tabData.url,
        triggerAnalytics
    ]);
    if (tabData.sections && tabData.sections.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7uRML.AppTabMenu), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hukKC.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        tabFragment: tabData,
        containerFragment: containerData,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        position: position,
        onClick: triggerAnalytics,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hukKC.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: onClick,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: webItemRef
    });
};
var $1797734e5bab4540$export$2e2bcd8739ae039 = $1797734e5bab4540$export$fca347df63cfad2c;

});
parcelRegister("7K2QI", function(module, exports) {

$parcel$export(module.exports, "default", () => $96239980f0bcc191$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7f951b0c8c256682bae1d46d09e2cf2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96239980f0bcc191$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTabMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$96239980f0bcc191$var$node.hash = "8257e51a0537d2533d3cb266fbb85918";
var $96239980f0bcc191$export$2e2bcd8739ae039 = $96239980f0bcc191$var$node;

});

parcelRegister("empIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $94af1d49e6ad4653$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28152e0fd82463bb04d925e467b2c53c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $94af1d49e6ad4653$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTab_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "FragmentSpread",
                "name": "AppTabMenu_tab"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "label"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "kind": "ScalarField",
                "name": "styleClass"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$94af1d49e6ad4653$var$node.hash = "93b2820577820b8e46d082f49f2dc9ff";
var $94af1d49e6ad4653$export$2e2bcd8739ae039 = $94af1d49e6ad4653$var$node;

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("3hUjN"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("3hUjN", function(module, exports) {

let $264ea540dc548cff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264ea540dc548cff$var$load("aVR4N").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("aUk4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf3f4c4729be8b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $41Nl9 = parcelRequire("41Nl9");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edf3f4c4729be8b6$var$AppIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.size === 'small' ? "_1bsbpxbi" : "_1bsbv47k",
            __cmplp.size === 'small' ? "_4t3ipxbi" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $edf3f4c4729be8b6$var$AppItemIcon = ({ url: url, size: size })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edf3f4c4729be8b6$var$AppIcon, {
        src: url,
        alt: "",
        size: size
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
        label: "",
        spacing: size === 'small' ? 'none' : 'spacious',
        color: "currentColor",
        LEGACY_size: size
    });
var $edf3f4c4729be8b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($edf3f4c4729be8b6$var$AppItemIcon);

});

parcelRegister("7uRML", function(module, exports) {

$parcel$export(module.exports, "AppTabMenu", () => $ec5f406842763762$export$ab6e213c275a503b);

var $44zJ1 = parcelRequire("44zJ1");

var $fJZmM = parcelRequire("fJZmM");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $ew55A = parcelRequire("ew55A");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $hrlU6 = parcelRequire("hrlU6");

var $byTKd = parcelRequire("byTKd");

var $bYbah = parcelRequire("bYbah");




var $3F9p6 = parcelRequire("3F9p6");

var $aHd4d = parcelRequire("aHd4d");

var $jgJNO = parcelRequire("jgJNO");

var $haoad = parcelRequire("haoad");
const $ec5f406842763762$export$ab6e213c275a503b = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId, onClick: onClick })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const isOverflowing = (0, $aHd4d.useIsTabOverflowing)();
    const { registerTab: registerTab } = (0, $bYbah.useTabShortcuts)();
    const webItemRefs = (0, $5uXOq.useRef)([]);
    const tabData = (0, $8Uumt.useFragment)((0, $fJZmM.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $44zJ1.default), containerFragment);
    (0, $5uXOq.useEffect)(()=>{
        if (tabData.label) {
            const deregisterTab = registerTab({
                index: position,
                callback: ()=>{
                    setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
                },
                label: tabData.label
            });
            return deregisterTab;
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    }, [
        registerTab,
        tabData.label,
        position
    ]);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemType: 'appSubpage',
            itemId: tabData.appId ?? '',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    if (!tabData.label) return null;
    const handleClick = ()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
        onClick?.();
    };
    const handleConnectItemClick = (className, href, sectionIndex, index)=>(e)=>{
            if (className && href) {
                (0, $hrlU6.withConnectHost)((connectHost)=>{
                    connectHost.triggerWebItem(webItemRefs.current[sectionIndex][index], className, href);
                });
                if ((0, $hrlU6.isConnectDialogWebItem)(className)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            triggerAnalytics();
        };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
            ...triggerProps,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            onClick: handleClick,
            elemBefore: icon,
            position: position,
            tabFragment: tabData,
            containerFragment: containerData,
            elemAfter: elemAfter,
            testId: testId,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        messageId: "horizontal-nav-tabs.ui.popup",
        messageType: "transactional",
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "horizontal-nav-app-tab.ui.app-menu.dropdown-menu",
        onClose: ()=>setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, tabData?.sections && tabData?.sections.map((section, i)=>{
                if (!webItemRefs.current[i]) webItemRefs.current[i] = new Array(section?.links?.length ?? 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
                    key: section?.label ?? `section-${i}`,
                    title: section?.label ?? undefined,
                    hasSeparator: i !== 0
                }, (section?.links ?? []).filter((link)=>link && link.label).map((link, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
                        key: link?.label ?? `link-${j}`,
                        href: link?.url ?? '',
                        isDisabled: !link?.url,
                        iconBefore: link?.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
                            src: link.iconUrl,
                            size: "small"
                        }) : undefined,
                        onClick: handleConnectItemClick(link?.styleClass, link?.url, i, j),
                        ref: (ref)=>{
                            if (ref !== null) webItemRefs.current[i][j] = ref;
                        }
                    }, link?.label)));
            }))
    });
};

});
parcelRegister("44zJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $58aa5b805460479e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2792c6bb12caa73c8e12008719c7617a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58aa5b805460479e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$58aa5b805460479e$var$node.hash = "687af9e59bccecfe4646886b7021170f";
var $58aa5b805460479e$export$2e2bcd8739ae039 = $58aa5b805460479e$var$node;

});

parcelRegister("fJZmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $649ddca6218e3657$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5347f212c1326652ffb0a0988293a41e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $649ddca6218e3657$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTabMenu_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "styleClass"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$649ddca6218e3657$var$node.hash = "0b52617895e2febba892c1e3d0914263";
var $649ddca6218e3657$export$2e2bcd8739ae039 = $649ddca6218e3657$var$node;

});


parcelRegister("hukKC", function(module, exports) {

$parcel$export(module.exports, "AppEnvLozenge", () => $473d92cf52b729c9$export$63905d23c4aa4c89);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");
const $473d92cf52b729c9$export$63905d23c4aa4c89 = ({ label: label })=>label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;

});


parcelRegister("bHBFf", function(module, exports) {

$parcel$export(module.exports, "ShortcutsTab", () => $c4013aa14ae2a321$export$9bfb5d07e0d9a9ad);

var $glvW5 = parcelRequire("glvW5");

var $6Bdkk = parcelRequire("6Bdkk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $vCqQa = parcelRequire("vCqQa");

var $5P2bV = parcelRequire("5P2bV");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $haoad = parcelRequire("haoad");




var $3F9p6 = parcelRequire("3F9p6");

var $k1ALc = parcelRequire("k1ALc");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $47gW9 = parcelRequire("47gW9");

var $byTKd = parcelRequire("byTKd");

var $aHd4d = parcelRequire("aHd4d");

var $7UhxN = parcelRequire("7UhxN");

var $j4hty = parcelRequire("j4hty");

var $hScKx = parcelRequire("hScKx");
const $c4013aa14ae2a321$export$9bfb5d07e0d9a9ad = ({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectIdOrKey = (0, $j4hty.useProjectIdOrKey)() ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const closePopup = (0, $5uXOq.useCallback)(()=>setIsDropdownMenuOpen(false), []);
    const itemRef = (0, $5uXOq.useRef)(null);
    const { data: shortcutsData, loading: loading } = (0, $7UhxN.useShortcutsData)();
    const isOverflowing = (0, $aHd4d.useIsTabOverflowing)();
    const tabData = (0, $8Uumt.useFragment)((0, $6Bdkk.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $glvW5.default), containerFragment);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hScKx.shortcutMenuContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            canEdit: containerData.canEdit ?? false,
            onClosePopup: closePopup,
            itemRef: itemRef
        }), [
        containerData.canEdit,
        closePopup
    ]);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemId: undefined,
            itemType: 'shortcuts',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), []));
    const trigger = ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            isRenaming: isRenaming,
            onRenamingChange: onRenamingChange,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P2bV))), {
                label: "",
                LEGACY_size: "small"
            }),
            onClick: ()=>{
                setIsDropdownMenuOpen((isOpen)=>!isOpen);
                triggerAnalytics();
            },
            position: position,
            ref: (element)=>{
                itemRef.current = element;
                triggerRef(element);
                typeof ref === 'function' && ref(element);
            },
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            testId: "horizontal-nav-shortcuts-tab.dropdown-menu-trigger",
            ...triggerProps
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        onClose: closePopup,
        testId: "horizontal-nav-shortcuts-tab.dropdown-menu",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
                data: shortcutsData,
                loading: loading,
                isGlobal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "shortcut.shortcuts-menu-content",
                packageName: "jiraHorizontalNavShortcutsTab",
                runtimeProps: runtimeProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    xcss: $c4013aa14ae2a321$var$fallbackStyles
                })
            }))
    });
};
const $c4013aa14ae2a321$var$fallbackStyles = (0, $2s57o.xcss)({
    width: '360px',
    height: '200px'
});

});
parcelRegister("glvW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be77ece9c127918$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7604ac780c8d96764d7838fc785b06aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4be77ece9c127918$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "canEdit"
                    },
                    "action": "THROW",
                    "path": "canEdit"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$4be77ece9c127918$var$node.hash = "68870b0a4c832d2519c1a0a32742229a";
var $4be77ece9c127918$export$2e2bcd8739ae039 = $4be77ece9c127918$var$node;

});

parcelRegister("6Bdkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7944c4825be786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d1cf693bab9584542567abe8891c3e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b7944c4825be786$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$1b7944c4825be786$var$node.hash = "44ec907f13fc9eea05e67f5b8c1abeae";
var $1b7944c4825be786$export$2e2bcd8739ae039 = $1b7944c4825be786$var$node;

});

parcelRegister("5P2bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43d36a5310be3cb4$var$_react = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $43d36a5310be3cb4$var$_link = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("bDHz4")));

var $43d36a5310be3cb4$var$_link2 = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("9KNZD")));
function $43d36a5310be3cb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43d36a5310be3cb4$var$LinkIcon = (props)=>/*#__PURE__*/ $43d36a5310be3cb4$var$_react.default.createElement($43d36a5310be3cb4$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $43d36a5310be3cb4$var$_link2.default
    }, props));
$43d36a5310be3cb4$var$LinkIcon.Name = 'LinkIconMigration';
var $43d36a5310be3cb4$var$_default = module.exports.default = $43d36a5310be3cb4$var$LinkIcon;

});
parcelRegister("bDHz4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8795214424a53a62$var$_react = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8795214424a53a62$var$_baseNew = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8795214424a53a62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8795214424a53a62$var$LinkIcon = (props)=>/*#__PURE__*/ $8795214424a53a62$var$_react.default.createElement($8795214424a53a62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$8795214424a53a62$var$LinkIcon.displayName = 'LinkIcon';
var $8795214424a53a62$var$_default = module.exports.default = $8795214424a53a62$var$LinkIcon;

});

parcelRegister("9KNZD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $719f30899c971b03$var$_react = $719f30899c971b03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $719f30899c971b03$var$_link = $719f30899c971b03$var$_interopRequireDefault((parcelRequire("bDHz4")));
function $719f30899c971b03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $719f30899c971b03$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $719f30899c971b03$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $719f30899c971b03$var$_link.default
    }));
$719f30899c971b03$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $719f30899c971b03$var$_default = module.exports.default = $719f30899c971b03$var$EditorLinkIcon;

});


parcelRegister("hScKx", function(module, exports) {

$parcel$export(module.exports, "shortcutMenuContentEntryPoint", () => $9f89d7a7810d5cd9$export$3b6d8ed8ad10a2e0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $hB38K = parcelRequire("hB38K");

const $9f89d7a7810d5cd9$export$3b6d8ed8ad10a2e0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("90YQB")), {
        moduleId: "cf565f5d",
        moduleName: "ShortcutsPopupContent"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $hB38K.default),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("hB38K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2adf569e9edb344c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c0a91e745996f53732022a7307f6d7d>>
 * @relayHash a6218fab775f20b2d64f2488618a1ee0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6
const $2adf569e9edb344c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "jira_projectByIdOrKey",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v2 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.key"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v3 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectType"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v4 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_projectByIdOrKey"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6",
            "metadata": {},
            "name": "ShortcutsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2adf569e9edb344c$var$node.hash = "6fa8881cba653e7f2ddc0665b57f7b00";
var $2adf569e9edb344c$export$2e2bcd8739ae039 = $2adf569e9edb344c$var$node;

});

parcelRegister("90YQB", function(module, exports) {

let $6903502c6fa7f623$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6903502c6fa7f623$var$load("kfXhT"),
    $6903502c6fa7f623$var$load("2Lfdl"),
    $6903502c6fa7f623$var$load("h2MrD"),
    $6903502c6fa7f623$var$load("bYT2S"),
    $6903502c6fa7f623$var$load("cM9em"),
    $6903502c6fa7f623$var$load("fr9NE"),
    $6903502c6fa7f623$var$load("gWkhf")
]).then(()=>parcelRequire('bA4B1'));

});





parcelRegister("3hiNj", function(module, exports) {

$parcel$export(module.exports, "JIRA_TABS", () => $5f48941933227bf2$export$3345ebb003d7978a);

var $5uXOq = parcelRequire("5uXOq");

var $lgPyf = parcelRequire("lgPyf");

var $gLsrb = parcelRequire("gLsrb");

var $cPLt3 = parcelRequire("cPLt3");

var $ddl7e = parcelRequire("ddl7e");

var $3pK7p = parcelRequire("3pK7p");

var $dncoP = parcelRequire("dncoP");

var $gBGoV = parcelRequire("gBGoV");

var $cu8LJ = parcelRequire("cu8LJ");

var $bDHz4 = parcelRequire("bDHz4");

var $af7Zc = parcelRequire("af7Zc");

var $d0RKL = parcelRequire("d0RKL");

var $lKJPg = parcelRequire("lKJPg");

var $aqJO7 = parcelRequire("aqJO7");

var $2VmPP = parcelRequire("2VmPP");

var $4KUYb = parcelRequire("4KUYb");

var $lUn6w = parcelRequire("lUn6w");

var $9bNK0 = parcelRequire("9bNK0");

var $cQJCJ = parcelRequire("cQJCJ");

var $f0PnG = parcelRequire("f0PnG");

var $2MieS = parcelRequire("2MieS");

var $fVgSt = parcelRequire("fVgSt");

var $a87xI = parcelRequire("a87xI");

var $e7Klx = parcelRequire("e7Klx");

var $c9NFd = parcelRequire("c9NFd");

var $6nxkb = parcelRequire("6nxkb");

var $9KNZD = parcelRequire("9KNZD");

var $hWOvD = parcelRequire("hWOvD");

var $kyBZq = parcelRequire("kyBZq");

var $4R6GH = parcelRequire("4R6GH");

var $aZEzT = parcelRequire("aZEzT");

var $bU94A = parcelRequire("bU94A");

var $9a8PH = parcelRequire("9a8PH");

var $4GBow = parcelRequire("4GBow");

var $fGlXq = parcelRequire("fGlXq");

var $ivrMo = parcelRequire("ivrMo");

var $fz9oE = parcelRequire("fz9oE");

var $3pzqk = parcelRequire("3pzqk");

var $AL4UQ = parcelRequire("AL4UQ");

var $dJlky = parcelRequire("dJlky");

var $gafcx = parcelRequire("gafcx");

var $5aUMY = parcelRequire("5aUMY");

var $gzEPo = parcelRequire("gzEPo");

var $ad6tu = parcelRequire("ad6tu");

var $1X4ga = parcelRequire("1X4ga");

var $85Sm6 = parcelRequire("85Sm6");

var $sQUnj = parcelRequire("sQUnj");

var $7Zltj = parcelRequire("7Zltj");

var $5EY5v = parcelRequire("5EY5v");

var $g8Wnk = parcelRequire("g8Wnk");

var $gS64m = parcelRequire("gS64m");

var $hR0XV = parcelRequire("hR0XV");

var $833ck = parcelRequire("833ck");

var $1GbRa = parcelRequire("1GbRa");

var $52BHa = parcelRequire("52BHa");
const $5f48941933227bf2$export$3345ebb003d7978a = {
    APP: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bNK0))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $aZEzT.default),
        description: ()=>(0, $52BHa.default).appDescription
    },
    APPROVALS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0RKL))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $bU94A.default),
        description: ()=>(0, $52BHa.default).approvalsDescription
    },
    ARCHIVED_ISSUES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgPyf))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).archivedIssuesDescriptionIssueTermRefresh : (0, $52BHa.default).archivedIssuesDescription
    },
    ATTACHMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lKJPg))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $9a8PH.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).attachmentsDescriptionIssueTermRefresh : (0, $52BHa.default).attachmentsDescription
    },
    BACKLOG: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lKJPg))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $4GBow.default),
        description: ()=>(0, $52BHa.default).backlogDescription
    },
    BOARD: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $fGlXq.default),
        description: ()=>(0, $52BHa.default).boardDescription
    },
    CALENDAR: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VmPP))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ivrMo.default),
        description: ()=>(0, $52BHa.default).calendarDescription
    },
    CODE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($af7Zc))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $fz9oE.default),
        description: ()=>(0, $52BHa.default).codeDescription
    },
    COMPONENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gLsrb))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $3pzqk.default),
        description: ()=>(0, $52BHa.default).componentsDescription
    },
    DEPLOYMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUn6w))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $AL4UQ.default),
        description: ()=>(0, $52BHa.default).deploymentsDescription
    },
    DEVELOPMENT: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cu8LJ))), {
                label: "",
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $dJlky.default),
        description: ()=>(0, $52BHa.default).developmentDescription
    },
    FORMS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ddl7e))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $gafcx.default),
        description: ()=>(0, $52BHa.default).formsDescription
    },
    GOALS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dncoP))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size,
                LEGACY_fallbackIcon: (0, $1GbRa.GoalIcon)
            }),
        Illustration: (0, $5aUMY.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).goalsDescriptionIssueTermRefresh : (0, $52BHa.default).goalsDescription
    },
    INCIDENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBGoV))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hWOvD)))
            }),
        Illustration: (0, $gzEPo.default),
        description: ()=>(0, $52BHa.default).incidentsDescription
    },
    ISSUES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).issuesDescriptionIssueTermRefresh : (0, $52BHa.default).issuesDescription
    },
    LIST: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9NFd))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6nxkb)))
            }),
        Illustration: (0, $1X4ga.default),
        description: ()=>(0, $52BHa.default).listDescription
    },
    ON_CALL: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a87xI))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kyBZq)))
            }),
        Illustration: (0, $85Sm6.default),
        description: ()=>(0, $52BHa.default).onCallDescription
    },
    PAGES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0PnG))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $sQUnj.default),
        description: ()=>(0, $52BHa.default).pagesDescription
    },
    RELEASES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MieS))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $7Zltj.default),
        description: ()=>(0, $52BHa.default).releasesDescription
    },
    REPORTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4KUYb))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $5EY5v.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).reportsDescriptionIssueTermRefresh : (0, $52BHa.default).reportsDescription
    },
    SECURITY: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e7Klx))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $g8Wnk.default),
        description: ()=>(0, $52BHa.default).securityDescription
    },
    SHORTCUTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDHz4))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9KNZD)))
            }),
        Illustration: (0, $gS64m.default),
        description: ()=>(0, $52BHa.default).shortcutsDescription
    },
    SUMMARY: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3pK7p))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $hR0XV.default),
        description: ()=>(0, $52BHa.default).summaryDescriptionNonFinal
    },
    TIMELINE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $833ck.default),
        description: ()=>(0, $52BHa.default).timelineDescription
    },
    INBOX: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cPLt3))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $52BHa.default).inboxDescription
    }
};

});
parcelRegister("lgPyf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7c314a31c145780$var$_react = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7c314a31c145780$var$_baseNew = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7c314a31c145780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7c314a31c145780$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $f7c314a31c145780$var$_react.default.createElement($f7c314a31c145780$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$f7c314a31c145780$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $f7c314a31c145780$var$_default = module.exports.default = $f7c314a31c145780$var$ArchiveBoxIcon;

});

parcelRegister("gLsrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3471833a6d190d1$var$_react = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3471833a6d190d1$var$_baseNew = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c3471833a6d190d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3471833a6d190d1$var$ComponentIcon = (props)=>/*#__PURE__*/ $c3471833a6d190d1$var$_react.default.createElement($c3471833a6d190d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$c3471833a6d190d1$var$ComponentIcon.displayName = 'ComponentIcon';
var $c3471833a6d190d1$var$_default = module.exports.default = $c3471833a6d190d1$var$ComponentIcon;

});

parcelRegister("cPLt3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81177d596079c24ecbc8bf8bc933664f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $957f1184ab7d3cf5$var$_react = $957f1184ab7d3cf5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $957f1184ab7d3cf5$var$_baseNew = $957f1184ab7d3cf5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $957f1184ab7d3cf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $957f1184ab7d3cf5$var$InboxIcon = (props)=>/*#__PURE__*/ $957f1184ab7d3cf5$var$_react.default.createElement($957f1184ab7d3cf5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$957f1184ab7d3cf5$var$InboxIcon.displayName = 'InboxIcon';
var $957f1184ab7d3cf5$var$_default = module.exports.default = $957f1184ab7d3cf5$var$InboxIcon;

});

parcelRegister("ddl7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99ecde63fa3b9455$var$_react = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $99ecde63fa3b9455$var$_baseNew = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("enEmH")));
function $99ecde63fa3b9455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99ecde63fa3b9455$var$FormIcon = (props)=>/*#__PURE__*/ $99ecde63fa3b9455$var$_react.default.createElement($99ecde63fa3b9455$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$99ecde63fa3b9455$var$FormIcon.displayName = 'FormIcon';
var $99ecde63fa3b9455$var$_default = module.exports.default = $99ecde63fa3b9455$var$FormIcon;

});

parcelRegister("gBGoV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c170fe05b7830e72$var$_react = $c170fe05b7830e72$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c170fe05b7830e72$var$_baseNew = $c170fe05b7830e72$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c170fe05b7830e72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c170fe05b7830e72$var$IncidentIcon = (props)=>/*#__PURE__*/ $c170fe05b7830e72$var$_react.default.createElement($c170fe05b7830e72$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$c170fe05b7830e72$var$IncidentIcon.displayName = 'IncidentIcon';
var $c170fe05b7830e72$var$_default = module.exports.default = $c170fe05b7830e72$var$IncidentIcon;

});

parcelRegister("af7Zc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77517ff8b1b9e4eb$var$_react = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $77517ff8b1b9e4eb$var$_angleBrackets = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("elXz8")));

var $77517ff8b1b9e4eb$var$_code = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("7Vx4o")));
function $77517ff8b1b9e4eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77517ff8b1b9e4eb$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $77517ff8b1b9e4eb$var$_react.default.createElement($77517ff8b1b9e4eb$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $77517ff8b1b9e4eb$var$_code.default
    }, props));
$77517ff8b1b9e4eb$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $77517ff8b1b9e4eb$var$_default = module.exports.default = $77517ff8b1b9e4eb$var$AngleBracketsIcon;

});
parcelRegister("7Vx4o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c57823dfa4237dd$var$_react = $5c57823dfa4237dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5c57823dfa4237dd$var$_angleBrackets = $5c57823dfa4237dd$var$_interopRequireDefault((parcelRequire("elXz8")));
function $5c57823dfa4237dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c57823dfa4237dd$var$CodeIcon = (props)=>/*#__PURE__*/ $5c57823dfa4237dd$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $5c57823dfa4237dd$var$_angleBrackets.default
    }));
$5c57823dfa4237dd$var$CodeIcon.displayName = 'CodeIcon';
var $5c57823dfa4237dd$var$_default = module.exports.default = $5c57823dfa4237dd$var$CodeIcon;

});


parcelRegister("d0RKL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f7d584f0c375bf34e40fdaa7660bdc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9794f8b8484cce30$var$_react = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9794f8b8484cce30$var$_attachment = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("hZ9xc")));

var $9794f8b8484cce30$var$_attachment2 = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("8FO5r")));
function $9794f8b8484cce30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "AttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9794f8b8484cce30$var$AttachmentIcon = (props)=>/*#__PURE__*/ $9794f8b8484cce30$var$_react.default.createElement($9794f8b8484cce30$var$_attachment.default, Object.assign({
        LEGACY_fallbackIcon: $9794f8b8484cce30$var$_attachment2.default
    }, props));
$9794f8b8484cce30$var$AttachmentIcon.Name = 'AttachmentIconMigration';
var $9794f8b8484cce30$var$_default = module.exports.default = $9794f8b8484cce30$var$AttachmentIcon;

});
parcelRegister("hZ9xc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb48769bc9741be5df69b5fd6e0f8435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d17f8781c4018223$var$_react = $d17f8781c4018223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d17f8781c4018223$var$_baseNew = $d17f8781c4018223$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d17f8781c4018223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d17f8781c4018223$var$AttachmentIcon = (props)=>/*#__PURE__*/ $d17f8781c4018223$var$_react.default.createElement($d17f8781c4018223$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.72 1.97a3.578 3.578 0 1 1 5.06 5.06l-4.5 4.5a2.164 2.164 0 1 1-3.06-3.06l4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.493 3.493 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 1 1-7.06-7.06z" clip-rule="evenodd"/>`
    }, props));
$d17f8781c4018223$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $d17f8781c4018223$var$_default = module.exports.default = $d17f8781c4018223$var$AttachmentIcon;

});

parcelRegister("8FO5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6509013b18e62844$var$_react = $6509013b18e62844$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6509013b18e62844$var$_attachment = $6509013b18e62844$var$_interopRequireDefault((parcelRequire("hZ9xc")));
function $6509013b18e62844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6509013b18e62844$var$AttachmentIcon = (props)=>/*#__PURE__*/ $6509013b18e62844$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $6509013b18e62844$var$_attachment.default
    }));
$6509013b18e62844$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $6509013b18e62844$var$_default = module.exports.default = $6509013b18e62844$var$AttachmentIcon;

});


parcelRegister("2VmPP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22129e2c287d5de4$var$_react = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $22129e2c287d5de4$var$_calendar = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("iTgNO")));

var $22129e2c287d5de4$var$_calendar2 = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("kqwhU")));
function $22129e2c287d5de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22129e2c287d5de4$var$CalendarIcon = (props)=>/*#__PURE__*/ $22129e2c287d5de4$var$_react.default.createElement($22129e2c287d5de4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $22129e2c287d5de4$var$_calendar2.default
    }, props));
$22129e2c287d5de4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $22129e2c287d5de4$var$_default = module.exports.default = $22129e2c287d5de4$var$CalendarIcon;

});
parcelRegister("iTgNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc0a65a8f23cfe26$var$_react = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc0a65a8f23cfe26$var$_baseNew = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dc0a65a8f23cfe26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc0a65a8f23cfe26$var$CalendarIcon = (props)=>/*#__PURE__*/ $dc0a65a8f23cfe26$var$_react.default.createElement($dc0a65a8f23cfe26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$dc0a65a8f23cfe26$var$CalendarIcon.displayName = 'CalendarIcon';
var $dc0a65a8f23cfe26$var$_default = module.exports.default = $dc0a65a8f23cfe26$var$CalendarIcon;

});

parcelRegister("kqwhU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edef480bec250815$var$_react = $edef480bec250815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $edef480bec250815$var$_calendar = $edef480bec250815$var$_interopRequireDefault((parcelRequire("iTgNO")));
function $edef480bec250815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $edef480bec250815$var$CalendarIcon = (props)=>/*#__PURE__*/ $edef480bec250815$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $edef480bec250815$var$_calendar.default
    }));
$edef480bec250815$var$CalendarIcon.displayName = 'CalendarIcon';
var $edef480bec250815$var$_default = module.exports.default = $edef480bec250815$var$CalendarIcon;

});


parcelRegister("4KUYb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3767a65103c7d22a$var$_react = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3767a65103c7d22a$var$_chartTrend = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("g95pD")));

var $3767a65103c7d22a$var$_graphLine = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("6tgIY")));
function $3767a65103c7d22a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3767a65103c7d22a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $3767a65103c7d22a$var$_react.default.createElement($3767a65103c7d22a$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $3767a65103c7d22a$var$_graphLine.default
    }, props));
$3767a65103c7d22a$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $3767a65103c7d22a$var$_default = module.exports.default = $3767a65103c7d22a$var$ChartTrendIcon;

});
parcelRegister("6tgIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013743d1004a6124$var$_react = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $013743d1004a6124$var$_chartTrend = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("g95pD")));
function $013743d1004a6124$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $013743d1004a6124$var$GraphLineIcon = (props)=>/*#__PURE__*/ $013743d1004a6124$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $013743d1004a6124$var$_chartTrend.default
    }));
$013743d1004a6124$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $013743d1004a6124$var$_default = module.exports.default = $013743d1004a6124$var$GraphLineIcon;

});


parcelRegister("lUn6w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff30bfed1a85ba7b$var$_react = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ff30bfed1a85ba7b$var$_cloudArrowUp = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("fbDNl")));

var $ff30bfed1a85ba7b$var$_upload = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("c2AHP")));
function $ff30bfed1a85ba7b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff30bfed1a85ba7b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $ff30bfed1a85ba7b$var$_react.default.createElement($ff30bfed1a85ba7b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $ff30bfed1a85ba7b$var$_upload.default
    }, props));
$ff30bfed1a85ba7b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $ff30bfed1a85ba7b$var$_default = module.exports.default = $ff30bfed1a85ba7b$var$CloudArrowUpIcon;

});
parcelRegister("fbDNl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e6c08723df58e1$var$_react = $b0e6c08723df58e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0e6c08723df58e1$var$_baseNew = $b0e6c08723df58e1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $b0e6c08723df58e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0e6c08723df58e1$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b0e6c08723df58e1$var$_react.default.createElement($b0e6c08723df58e1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b0e6c08723df58e1$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b0e6c08723df58e1$var$_default = module.exports.default = $b0e6c08723df58e1$var$CloudArrowUpIcon;

});

parcelRegister("c2AHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c4224fd0fe9f51e$var$_react = $8c4224fd0fe9f51e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $8c4224fd0fe9f51e$var$_cloudArrowUp = $8c4224fd0fe9f51e$var$_interopRequireDefault((parcelRequire("fbDNl")));
function $8c4224fd0fe9f51e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8c4224fd0fe9f51e$var$UploadIcon = (props)=>/*#__PURE__*/ $8c4224fd0fe9f51e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $8c4224fd0fe9f51e$var$_cloudArrowUp.default
    }));
$8c4224fd0fe9f51e$var$UploadIcon.displayName = 'UploadIcon';
var $8c4224fd0fe9f51e$var$_default = module.exports.default = $8c4224fd0fe9f51e$var$UploadIcon;

});


parcelRegister("9bNK0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b0bb9a80ddcdb58$var$_react = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6b0bb9a80ddcdb58$var$_decision = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("iZSbd")));

var $6b0bb9a80ddcdb58$var$_decision2 = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("h3Khn")));
function $6b0bb9a80ddcdb58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b0bb9a80ddcdb58$var$DecisionIcon = (props)=>/*#__PURE__*/ $6b0bb9a80ddcdb58$var$_react.default.createElement($6b0bb9a80ddcdb58$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $6b0bb9a80ddcdb58$var$_decision2.default
    }, props));
$6b0bb9a80ddcdb58$var$DecisionIcon.Name = 'DecisionIconMigration';
var $6b0bb9a80ddcdb58$var$_default = module.exports.default = $6b0bb9a80ddcdb58$var$DecisionIcon;

});
parcelRegister("iZSbd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd47f381f05c3215$var$_react = $dd47f381f05c3215$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd47f381f05c3215$var$_baseNew = $dd47f381f05c3215$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dd47f381f05c3215$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd47f381f05c3215$var$DecisionIcon = (props)=>/*#__PURE__*/ $dd47f381f05c3215$var$_react.default.createElement($dd47f381f05c3215$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$dd47f381f05c3215$var$DecisionIcon.displayName = 'DecisionIcon';
var $dd47f381f05c3215$var$_default = module.exports.default = $dd47f381f05c3215$var$DecisionIcon;

});

parcelRegister("h3Khn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6b69d938eef8b40$var$_react = $c6b69d938eef8b40$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c6b69d938eef8b40$var$_decision = $c6b69d938eef8b40$var$_interopRequireDefault((parcelRequire("iZSbd")));
function $c6b69d938eef8b40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6b69d938eef8b40$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $c6b69d938eef8b40$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $c6b69d938eef8b40$var$_decision.default
    }));
$c6b69d938eef8b40$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $c6b69d938eef8b40$var$_default = module.exports.default = $c6b69d938eef8b40$var$EditorDecisionIcon;

});


parcelRegister("a87xI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54d86c00219aaf0598bf3eec65b605b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7600809161132cc6$var$_react = $7600809161132cc6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7600809161132cc6$var$_baseNew = $7600809161132cc6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7600809161132cc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OnCall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing on-call across Atlassian products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7600809161132cc6$var$OnCallIcon = (props)=>/*#__PURE__*/ $7600809161132cc6$var$_react.default.createElement($7600809161132cc6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.75A.75.75 0 0 1 .75 2h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L3.29 8.86a12.3 12.3 0 0 0 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 0 2.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM2.56 7.516 4.27 6.09a.25.25 0 0 0 .08-.261L3.684 3.5H1.525A11.4 11.4 0 0 0 2.56 7.516" clip-rule="evenodd"/><path fill="currentcolor" d="M16 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$7600809161132cc6$var$OnCallIcon.displayName = 'OnCallIcon';
var $7600809161132cc6$var$_default = module.exports.default = $7600809161132cc6$var$OnCallIcon;

});

parcelRegister("c9NFd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0248b92f6c6ad227$var$_react = $0248b92f6c6ad227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0248b92f6c6ad227$var$_baseNew = $0248b92f6c6ad227$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0248b92f6c6ad227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0248b92f6c6ad227$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $0248b92f6c6ad227$var$_react.default.createElement($0248b92f6c6ad227$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$0248b92f6c6ad227$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $0248b92f6c6ad227$var$_default = module.exports.default = $0248b92f6c6ad227$var$SpreadsheetIcon;

});

parcelRegister("kyBZq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef74739d60846a84$var$_react = $ef74739d60846a84$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $ef74739d60846a84$var$_onCall = $ef74739d60846a84$var$_interopRequireDefault((parcelRequire("a87xI")));
function $ef74739d60846a84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef74739d60846a84$var$HipchatDialOutIcon = (props)=>/*#__PURE__*/ $ef74739d60846a84$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.794 5.364c-1.726 2.133-.611 4.957.266 7.089.416 1.012 1.073 2.025 1.629 2.84.973 1.424 3.189 4.13 5.901 3.722 1.168-.176 2.527-1.555 1.597-2.436l-1.869-1.94s-.523-.436-1.171-.08l-1.048.613s-.428.202-.799-.275c-1.163-1.371-1.995-2.797-2.578-4.496-.227-.663.168-.828.168-.828l.767-.45c.637-.378.524-1.051.524-1.051l-.438-2.738c-.132-.568-.601-.803-1.145-.803-.648 0-1.4.334-1.804.833"/></svg>`
    }, props, {
        newIcon: $ef74739d60846a84$var$_onCall.default
    }));
$ef74739d60846a84$var$HipchatDialOutIcon.displayName = 'HipchatDialOutIcon';
var $ef74739d60846a84$var$_default = module.exports.default = $ef74739d60846a84$var$HipchatDialOutIcon;

});

parcelRegister("aZEzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e9302a8b16bd67$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $25Q2Y = parcelRequire("25Q2Y");

var $eosrI = parcelRequire("eosrI");
const $f8e9302a8b16bd67$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eosrI)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($25Q2Y))
});
var $f8e9302a8b16bd67$export$2e2bcd8739ae039 = $f8e9302a8b16bd67$var$Illustration;
// for advanced use only
const $f8e9302a8b16bd67$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("25Q2Y", function(module, exports) {
module.exports = new URL("app-preview-dark.692f3794.svg", import.meta.url).toString();

});

parcelRegister("eosrI", function(module, exports) {
module.exports = new URL("app-preview.701bd916.svg", import.meta.url).toString();

});


parcelRegister("bU94A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab5734c5483a312$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $6UE2v = parcelRequire("6UE2v");

var $7yuDf = parcelRequire("7yuDf");
const $2ab5734c5483a312$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7yuDf)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6UE2v))
});
var $2ab5734c5483a312$export$2e2bcd8739ae039 = $2ab5734c5483a312$var$Illustration;
// for advanced use only
const $2ab5734c5483a312$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("6UE2v", function(module, exports) {
module.exports = new URL("approvals-preview-dark.6d3cc8df.svg", import.meta.url).toString();

});

parcelRegister("7yuDf", function(module, exports) {
module.exports = new URL("approvals-preview.ce5f015e.svg", import.meta.url).toString();

});


parcelRegister("9a8PH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d6f697cd504e99$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2AEJs = parcelRequire("2AEJs");

var $g8jD8 = parcelRequire("g8jD8");
const $45d6f697cd504e99$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($g8jD8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2AEJs))
});
var $45d6f697cd504e99$export$2e2bcd8739ae039 = $45d6f697cd504e99$var$Illustration;
// for advanced use only
const $45d6f697cd504e99$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2AEJs", function(module, exports) {
module.exports = new URL("attachments-preview-dark.33a03e0d.svg", import.meta.url).toString();

});

parcelRegister("g8jD8", function(module, exports) {
module.exports = new URL("attachments-preview.7bdfffc6.svg", import.meta.url).toString();

});


parcelRegister("4GBow", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68ffabe5e49917a$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $hTvA3 = parcelRequire("hTvA3");

var $b504E = parcelRequire("b504E");
const $e68ffabe5e49917a$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($b504E)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hTvA3))
});
var $e68ffabe5e49917a$export$2e2bcd8739ae039 = $e68ffabe5e49917a$var$Illustration;
// for advanced use only
const $e68ffabe5e49917a$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("hTvA3", function(module, exports) {
module.exports = new URL("backlog-preview-dark.d971d34f.svg", import.meta.url).toString();

});

parcelRegister("b504E", function(module, exports) {
module.exports = new URL("backlog-preview.286ce430.svg", import.meta.url).toString();

});


parcelRegister("fGlXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $56958bdcbb5fed5b$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $dfBGt = parcelRequire("dfBGt");

var $jNEsV = parcelRequire("jNEsV");
const $56958bdcbb5fed5b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jNEsV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dfBGt))
});
var $56958bdcbb5fed5b$export$2e2bcd8739ae039 = $56958bdcbb5fed5b$var$Illustration;
// for advanced use only
const $56958bdcbb5fed5b$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dfBGt", function(module, exports) {
module.exports = new URL("board-preview-dark.ba6ae5d7.svg", import.meta.url).toString();

});

parcelRegister("jNEsV", function(module, exports) {
module.exports = new URL("board-preview.caf8f30f.svg", import.meta.url).toString();

});


parcelRegister("ivrMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e950b3b295ffcd66$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $fRklT = parcelRequire("fRklT");

var $C1qTt = parcelRequire("C1qTt");
const $e950b3b295ffcd66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($C1qTt)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fRklT))
});
var $e950b3b295ffcd66$export$2e2bcd8739ae039 = $e950b3b295ffcd66$var$Illustration;
// for advanced use only
const $e950b3b295ffcd66$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("fRklT", function(module, exports) {
module.exports = new URL("calendar-preview-dark.1428b9c3.svg", import.meta.url).toString();

});

parcelRegister("C1qTt", function(module, exports) {
module.exports = new URL("calendar-preview.cff0b145.svg", import.meta.url).toString();

});


parcelRegister("fz9oE", function(module, exports) {

$parcel$export(module.exports, "default", () => $edee4da055e0570e$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2uqa1 = parcelRequire("2uqa1");

var $8kkig = parcelRequire("8kkig");
const $edee4da055e0570e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8kkig)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2uqa1))
});
var $edee4da055e0570e$export$2e2bcd8739ae039 = $edee4da055e0570e$var$Illustration;
// for advanced use only
const $edee4da055e0570e$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2uqa1", function(module, exports) {
module.exports = new URL("code-preview-dark.6f4d4989.svg", import.meta.url).toString();

});

parcelRegister("8kkig", function(module, exports) {
module.exports = new URL("code-preview.15cf9a6e.svg", import.meta.url).toString();

});


parcelRegister("3pzqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $936ff2bab8c98662$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $glR0t = parcelRequire("glR0t");

var $1M128 = parcelRequire("1M128");
const $936ff2bab8c98662$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1M128)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($glR0t))
});
var $936ff2bab8c98662$export$2e2bcd8739ae039 = $936ff2bab8c98662$var$Illustration;
// for advanced use only
const $936ff2bab8c98662$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("glR0t", function(module, exports) {
module.exports = new URL("component-preview-dark.ac5aacd0.svg", import.meta.url).toString();

});

parcelRegister("1M128", function(module, exports) {
module.exports = new URL("component-preview.e6bd185f.svg", import.meta.url).toString();

});


parcelRegister("AL4UQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2dcc9d70948736f$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $dKWIV = parcelRequire("dKWIV");

var $g7Ocm = parcelRequire("g7Ocm");
const $c2dcc9d70948736f$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($g7Ocm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dKWIV))
});
var $c2dcc9d70948736f$export$2e2bcd8739ae039 = $c2dcc9d70948736f$var$Illustration;
// for advanced use only
const $c2dcc9d70948736f$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dKWIV", function(module, exports) {
module.exports = new URL("deployments-preview-dark.0cf1d99c.svg", import.meta.url).toString();

});

parcelRegister("g7Ocm", function(module, exports) {
module.exports = new URL("deployments-preview.78ac1bac.svg", import.meta.url).toString();

});


parcelRegister("dJlky", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c1e2819400ba27$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $BPL7A = parcelRequire("BPL7A");

var $eMOKP = parcelRequire("eMOKP");
const $64c1e2819400ba27$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eMOKP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($BPL7A))
});
var $64c1e2819400ba27$export$2e2bcd8739ae039 = $64c1e2819400ba27$var$Illustration;
// for advanced use only
const $64c1e2819400ba27$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("BPL7A", function(module, exports) {
module.exports = new URL("development-preview-dark.d26e9f57.svg", import.meta.url).toString();

});

parcelRegister("eMOKP", function(module, exports) {
module.exports = new URL("development-preview.bf178645.svg", import.meta.url).toString();

});


parcelRegister("gafcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cfa41e2e38c966$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $kHWJn = parcelRequire("kHWJn");

var $6PP4l = parcelRequire("6PP4l");
const $84cfa41e2e38c966$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6PP4l)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kHWJn))
});
var $84cfa41e2e38c966$export$2e2bcd8739ae039 = $84cfa41e2e38c966$var$Illustration;
// for advanced use only
const $84cfa41e2e38c966$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("kHWJn", function(module, exports) {
module.exports = new URL("forms-preview-dark.430156b1.svg", import.meta.url).toString();

});

parcelRegister("6PP4l", function(module, exports) {
module.exports = new URL("forms-preview.5e482c7a.svg", import.meta.url).toString();

});


parcelRegister("5aUMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9def757a09f39c8$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $9xqmZ = parcelRequire("9xqmZ");

var $6QGRR = parcelRequire("6QGRR");
const $a9def757a09f39c8$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6QGRR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9xqmZ))
});
var $a9def757a09f39c8$export$2e2bcd8739ae039 = $a9def757a09f39c8$var$Illustration;
// for advanced use only
const $a9def757a09f39c8$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("9xqmZ", function(module, exports) {
module.exports = new URL("goals-preview-dark.0421fbf5.svg", import.meta.url).toString();

});

parcelRegister("6QGRR", function(module, exports) {
module.exports = new URL("goals-preview.8d233f18.svg", import.meta.url).toString();

});


parcelRegister("gzEPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be86b79c8ab00b9$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $1Vyoa = parcelRequire("1Vyoa");

var $dFGxR = parcelRequire("dFGxR");
const $9be86b79c8ab00b9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dFGxR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1Vyoa))
});
var $9be86b79c8ab00b9$export$2e2bcd8739ae039 = $9be86b79c8ab00b9$var$Illustration;
// for advanced use only
const $9be86b79c8ab00b9$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1Vyoa", function(module, exports) {
module.exports = new URL("incidents-preview-dark.30e9470b.svg", import.meta.url).toString();

});

parcelRegister("dFGxR", function(module, exports) {
module.exports = new URL("incidents-preview.e6af1843.svg", import.meta.url).toString();

});


parcelRegister("ad6tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $686a30c829043502$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2Spml = parcelRequire("2Spml");

var $8PHg6 = parcelRequire("8PHg6");
const $686a30c829043502$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8PHg6)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2Spml))
});
var $686a30c829043502$export$2e2bcd8739ae039 = $686a30c829043502$var$Illustration;
// for advanced use only
const $686a30c829043502$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2Spml", function(module, exports) {
module.exports = new URL("issues-preview-dark.5cdc89fc.svg", import.meta.url).toString();

});

parcelRegister("8PHg6", function(module, exports) {
module.exports = new URL("issues-preview.c08edc67.svg", import.meta.url).toString();

});


parcelRegister("1X4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7a866c21212700$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $ar1zY = parcelRequire("ar1zY");

var $73Rxa = parcelRequire("73Rxa");
const $3b7a866c21212700$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($73Rxa)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ar1zY))
});
var $3b7a866c21212700$export$2e2bcd8739ae039 = $3b7a866c21212700$var$Illustration;
// for advanced use only
const $3b7a866c21212700$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("ar1zY", function(module, exports) {
module.exports = new URL("list-preview-dark.e53f1bb5.svg", import.meta.url).toString();

});

parcelRegister("73Rxa", function(module, exports) {
module.exports = new URL("list-preview.9c8441b2.svg", import.meta.url).toString();

});


parcelRegister("85Sm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef2577684df85ff$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $1ZFGf = parcelRequire("1ZFGf");

var $1bu4s = parcelRequire("1bu4s");
const $fef2577684df85ff$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1bu4s)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1ZFGf))
});
var $fef2577684df85ff$export$2e2bcd8739ae039 = $fef2577684df85ff$var$Illustration;
// for advanced use only
const $fef2577684df85ff$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1ZFGf", function(module, exports) {
module.exports = new URL("oncall-preview-dark.44c69321.svg", import.meta.url).toString();

});

parcelRegister("1bu4s", function(module, exports) {
module.exports = new URL("oncall-preview.83fb7508.svg", import.meta.url).toString();

});


parcelRegister("sQUnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $128e5932ddfe0686$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2BF50 = parcelRequire("2BF50");

var $jGooG = parcelRequire("jGooG");
const $128e5932ddfe0686$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jGooG)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2BF50))
});
var $128e5932ddfe0686$export$2e2bcd8739ae039 = $128e5932ddfe0686$var$Illustration;
// for advanced use only
const $128e5932ddfe0686$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2BF50", function(module, exports) {
module.exports = new URL("pages-preview-dark.db4817b0.svg", import.meta.url).toString();

});

parcelRegister("jGooG", function(module, exports) {
module.exports = new URL("pages-preview.fb1778e6.svg", import.meta.url).toString();

});


parcelRegister("7Zltj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7f4a374446cdd2$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $9lkCG = parcelRequire("9lkCG");

var $1CU0t = parcelRequire("1CU0t");
const $4a7f4a374446cdd2$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1CU0t)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9lkCG))
});
var $4a7f4a374446cdd2$export$2e2bcd8739ae039 = $4a7f4a374446cdd2$var$Illustration;
// for advanced use only
const $4a7f4a374446cdd2$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("9lkCG", function(module, exports) {
module.exports = new URL("releases-preview-dark.7aa6179c.svg", import.meta.url).toString();

});

parcelRegister("1CU0t", function(module, exports) {
module.exports = new URL("releases-preview.d6e2b061.svg", import.meta.url).toString();

});


parcelRegister("5EY5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $05de15dfc4738b45$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $dJYWt = parcelRequire("dJYWt");

var $bykH3 = parcelRequire("bykH3");
const $05de15dfc4738b45$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bykH3)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dJYWt))
});
var $05de15dfc4738b45$export$2e2bcd8739ae039 = $05de15dfc4738b45$var$Illustration;
// for advanced use only
const $05de15dfc4738b45$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dJYWt", function(module, exports) {
module.exports = new URL("reports-preview-dark.c0a44511.svg", import.meta.url).toString();

});

parcelRegister("bykH3", function(module, exports) {
module.exports = new URL("reports-preview.8bb5ca71.svg", import.meta.url).toString();

});


parcelRegister("g8Wnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e877357083e802$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $cGlAQ = parcelRequire("cGlAQ");

var $5VpLK = parcelRequire("5VpLK");
const $32e877357083e802$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5VpLK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cGlAQ))
});
var $32e877357083e802$export$2e2bcd8739ae039 = $32e877357083e802$var$Illustration;
// for advanced use only
const $32e877357083e802$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("cGlAQ", function(module, exports) {
module.exports = new URL("security-preview-dark.fe257a0b.svg", import.meta.url).toString();

});

parcelRegister("5VpLK", function(module, exports) {
module.exports = new URL("security-preview.5dc5fb3a.svg", import.meta.url).toString();

});


parcelRegister("gS64m", function(module, exports) {

$parcel$export(module.exports, "default", () => $098262013fc43113$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2KuAY = parcelRequire("2KuAY");

var $7EBtb = parcelRequire("7EBtb");
const $098262013fc43113$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7EBtb)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2KuAY))
});
var $098262013fc43113$export$2e2bcd8739ae039 = $098262013fc43113$var$Illustration;
// for advanced use only
const $098262013fc43113$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2KuAY", function(module, exports) {
module.exports = new URL("shortcuts-preview-dark.ee547f9e.svg", import.meta.url).toString();

});

parcelRegister("7EBtb", function(module, exports) {
module.exports = new URL("shortcuts-preview.8780e9d0.svg", import.meta.url).toString();

});


parcelRegister("hR0XV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0734d37e50948b26$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $5EwWC = parcelRequire("5EwWC");

var $laN0O = parcelRequire("laN0O");
const $0734d37e50948b26$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($laN0O)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5EwWC))
});
var $0734d37e50948b26$export$2e2bcd8739ae039 = $0734d37e50948b26$var$Illustration;
// for advanced use only
const $0734d37e50948b26$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("5EwWC", function(module, exports) {
module.exports = new URL("summary-preview-dark.32dd4d90.svg", import.meta.url).toString();

});

parcelRegister("laN0O", function(module, exports) {
module.exports = new URL("summary-preview.10045d4f.svg", import.meta.url).toString();

});


parcelRegister("833ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $7790084e44c29578$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $jc7Jr = parcelRequire("jc7Jr");

var $5wMM8 = parcelRequire("5wMM8");
const $7790084e44c29578$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5wMM8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jc7Jr))
});
var $7790084e44c29578$export$2e2bcd8739ae039 = $7790084e44c29578$var$Illustration;
// for advanced use only
const $7790084e44c29578$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("jc7Jr", function(module, exports) {
module.exports = new URL("timeline-preview-dark.a8fbe72d.svg", import.meta.url).toString();

});

parcelRegister("5wMM8", function(module, exports) {
module.exports = new URL("timeline-preview.cf56bfbb.svg", import.meta.url).toString();

});


parcelRegister("1GbRa", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $12f8ec0674b81469$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");

var $koVbs = parcelRequire("koVbs");

var $bG0w3 = parcelRequire("bG0w3");
const $12f8ec0674b81469$var$getGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $12f8ec0674b81469$export$134cbcd70c6693b8 = ({ size: size, primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $12f8ec0674b81469$var$getGlyph,
        size: size,
        label: formatMessage((0, $bG0w3.default).goalIconLabel),
        primaryColor: primaryColor
    });
};

});
parcelRegister("bG0w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9702f2f1c783da1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9702f2f1c783da1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "spa-apps-sidebar-common.goal-icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("52BHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e950f63c8f63875d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e950f63c8f63875d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    approvalsDescription: {
        "id": "horizontal-nav-add-tab-details.approvals-description",
        "defaultMessage": "Add approvals into your workflow to save you time following up."
    },
    attachmentsDescription: {
        "id": "horizontal-nav-add-tab-details.attachments-description",
        "defaultMessage": "View attachments that have been added to issues within your project."
    },
    archivedIssuesDescription: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description",
        "defaultMessage": "View all the issues archived in your project here."
    },
    attachmentsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.attachments-description-issue-term-refresh",
        "defaultMessage": "View attachments that have been added to work items within your project."
    },
    archivedIssuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items archived in your project here."
    },
    issuesDescription: {
        "id": "horizontal-nav-add-tab-details.issues-description",
        "defaultMessage": "View all the issues in your project. Use built-in filters and text search to find issues."
    },
    backlogDescription: {
        "id": "horizontal-nav-add-tab-details.backlog-description",
        "defaultMessage": "Plan and prioritize your team's work in a dedicated space."
    },
    reportsDescription: {
        "id": "horizontal-nav-add-tab-details.reports-description",
        "defaultMessage": "View statistics for people, projects, versions, or information about issues."
    },
    securityDescription: {
        "id": "horizontal-nav-add-tab-details.security-description",
        "defaultMessage": "Connect security tools to triage and track vulnerabilities in Jira."
    },
    boardDescription: {
        "id": "horizontal-nav-add-tab-details.board-description",
        "defaultMessage": "Get a snapshot of the status of your team's work and easily drag your cards through a workflow."
    },
    codeDescription: {
        "id": "horizontal-nav-add-tab-details.code-description",
        "defaultMessage": "Connect Bitbucket, GitHub and other development tools to link your team's repositories to Jira."
    },
    componentsDescription: {
        "id": "horizontal-nav-add-tab-details.components-description",
        "defaultMessage": "Use components to create subsections of a project."
    },
    deploymentsDescription: {
        "id": "horizontal-nav-add-tab-details.deployments-description",
        "defaultMessage": "Easily manage and track deployments for a seamless software delivery experience."
    },
    developmentDescription: {
        "id": "horizontal-nav-add-tab-details.development-description",
        "defaultMessage": "Discover key technical insights and work suggestions for your software development journey in one place."
    },
    goalsDescription: {
        "id": "horizontal-nav-add-tab-details.goals-description",
        "defaultMessage": "View issues that are linked to goals in this project."
    },
    incidentsDescription: {
        "id": "horizontal-nav-add-tab-details.incidents-description",
        "defaultMessage": "Triage incidents and track PIR actions in your project by connecting incident management tools."
    },
    releasesDescription: {
        "id": "horizontal-nav-add-tab-details.releases-description",
        "defaultMessage": "Versions help you package and schedule project deliveries."
    },
    requestsDescription: {
        "id": "horizontal-nav-add-tab-details.requests-description",
        "defaultMessage": "Manage, prioritize, and track requests, and connect them to this project."
    },
    timelineDescription: {
        "id": "horizontal-nav-add-tab-details.timeline-description",
        "defaultMessage": "Plan and manage your project dependencies on a timeline and see when things are landing."
    },
    onCallDescription: {
        "id": "horizontal-nav-add-tab-details.on-call-description",
        "defaultMessage": "View on-call schedules in your project. Requires Opsgenie by Atlassian."
    },
    calendarDescription: {
        "id": "horizontal-nav-add-tab-details.calendar-description",
        "defaultMessage": "See when work is due and get a quick glance at what the next month looks like."
    },
    shortcutsDescription: {
        "id": "horizontal-nav-add-tab-details.shortcuts-description",
        "defaultMessage": "Add easily accessible links for your team to access from your project."
    },
    pagesDescription: {
        "id": "horizontal-nav-add-tab-details.pages-description",
        "defaultMessage": "Create and manage Confluence pages in your project."
    },
    listDescription: {
        "id": "horizontal-nav-add-tab-details.list-description",
        "defaultMessage": "Get a list of your project's work in spreadsheet-like table."
    },
    appDescription: {
        "id": "horizontal-nav-add-tab-details.app-description",
        "defaultMessage": "Supercharge your project by integrating third-party apps."
    },
    formsDescription: {
        "id": "horizontal-nav-add-tab-details.forms-description",
        "defaultMessage": "Collect information for your team with forms."
    },
    summaryDescriptionNonFinal: {
        "id": "horizontal-nav-add-tab-details.summary-description-non-final",
        "defaultMessage": "Get an overview of work progress, priorities, workload distribution, and other projects."
    },
    issuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items in your project. Use built-in filters and text search to find work items."
    },
    reportsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.reports-description-issue-term-refresh",
        "defaultMessage": "View statistics for people, projects, versions, or information about work items."
    },
    goalsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.goals-description-issue-term-refresh",
        "defaultMessage": "View work items that are linked to goals in this project."
    },
    inboxDescription: {
        "id": "horizontal-nav.inbox-description",
        "defaultMessage": "Enable customer service teams to forward work items to this project. Teams will see this project in their forwarding options and can forward work directly to your inbox."
    }
});

});



parcelRegister("drBJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee696677b637264b$export$2e2bcd8739ae039);

var $hHUIQ = parcelRequire("hHUIQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $1MaBz = parcelRequire("1MaBz");
const $ee696677b637264b$var$ThemeEvaluated = ({ projectRef: projectRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $hHUIQ.default), projectRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [theme] = (0, $1MaBz.useThemeSetting)();
    (0, $5uXOq.useEffect)(()=>{
        if (data.projectType === 'BUSINESS') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
            theme: theme?.value,
            projectId: data?.projectId
        });
    }, [
        theme?.value,
        data.projectType,
        data?.projectId,
        createAnalyticsEvent
    ]);
    return null;
};
var $ee696677b637264b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ee696677b637264b$var$ThemeEvaluated);

});
parcelRegister("hHUIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $96582841df96123f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b167150cc58177efe723ed182f69949>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96582841df96123f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeEvaluated",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$96582841df96123f$var$node.hash = "9bc6a556dad6e9a6508f296e65c79d05";
var $96582841df96123f$export$2e2bcd8739ae039 = $96582841df96123f$var$node;

});

parcelRegister("1MaBz", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $5ffb1b62a0c37aa6$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $5ffb1b62a0c37aa6$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
// Delete file when cleaning up jira_theming_relay_migration

var $ajpes = parcelRequire("ajpes");

var $fHEdP = parcelRequire("fHEdP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$actions = {
    setTheme: $5ffb1b62a0c37aa6$var$setTheme,
    setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
};
const $5ffb1b62a0c37aa6$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $5ffb1b62a0c37aa6$var$Store = (0, $iXqE5.createStore)({
    initialState: $5ffb1b62a0c37aa6$var$initialState,
    actions: $5ffb1b62a0c37aa6$var$actions,
    name: 'ProjectTheme'
});
const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        }
});
const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store);
const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, $6dDSs.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getThemeSetting
});
const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, $6dDSs.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
});

});
parcelRegister("fHEdP", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $a34e148e1f33a06a$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $a34e148e1f33a06a$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $a34e148e1f33a06a$export$224c78c119a97f91);

var $6cG4N = parcelRequire("6cG4N");
const $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $6cG4N.NO_BACKGROUND_CONFIG)
];
const $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a34e148e1f33a06a$var$ThemeManager {
    init() {
        $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $6cG4N.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $6cG4N.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $6cG4N.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $6cG4N.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
$a34e148e1f33a06a$export$aba92a7f3273f617.init();
function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $a34e148e1f33a06a$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});






//# sourceMappingURL=HorizontalNavJiraInner.47f5ce0c.js.map
